import React, {
    useState,
    createContext,
    useContext,
    useEffect,
    useRef,
    useLayoutEffect,
    useCallback,
    useMemo
} from "react";
import { createPortal } from "react-dom";

//import { Link } from 'react-router-dom'
import LoadingSpinnerImage from "../LoadingSpinnerImage.js";
import "../../TaskManagerApp/App.css";
import "../App.css";
import * as FieldTypes from '../FieldTypes/FieldTypes.js';
import * as Constants from '../Constants.js'
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsGantt from "highcharts/highcharts-gantt";
import { TagFilter } from '../Tags.js';
import HC_map from "highcharts/modules/map";
import worldMap from "@highcharts/map-collection/custom/world.geo.json";
import Exporting from 'highcharts/modules/exporting';
import OfflineExporting from 'highcharts/modules/offline-exporting';
import ColumnsConfiguration from '../ColumnsConfiguration.js';
import { downloadEudamedXmlFile, sendEudamedXml, EudamedPlaygroundNotice, describeDownloadWarnings } from '../EudamedXmlDownload.js';
import RIMSFilter from '../RIMSFilter.js';
import MultiItemAIChatPane from '../MultiItemAIChatPane.js';
import DOMPurify from 'dompurify';
import SubmissionQAKpiCard from '../../Submissions/SubmissionQAKpiCard.js';
import OpenSubmissionsKpiCard from '../../Submissions/OpenSubmissionsKpiCard.js';
import { EventEmitter } from "events";


HC_map(Highcharts);
Exporting(HighchartsGantt);
OfflineExporting(HighchartsGantt);

const GlobalAppContext = createContext();
let debounceTimer = null;

// Entity types of the UDIs page (Basic UDIs + UDIs per region)
const UDI_ENTITY_TYPES = ["basic-udis", "product-udis-eu", "product-udis-us"];

import $ from "jquery";

const taskManagerEmitter = new EventEmitter();


const DataTable = ({ dataTableStructure, ItemDetailsPane, AddItemPopup, RemoveItemPopup, CustomMenuBar = null, ReloadStructureFunction = null, defaultFilters }) => {

    const [data, setData] = useState([]);
    const [dataSortByType, setDataSortByType] = useState("ASCENDING");
    const [dataSortByField, setDataSortByField] = useState(dataTableStructure.defaultOrderByField ? dataTableStructure.defaultOrderByField : "Name");
    const [dataFilterBy, setFilterBy] = useState("");
    const [dataFilterValue, setFilterValue] = useState("");
    const [currentCompanyId, setCurrentCompanyId] = useState(window.currentCompanyId);
    const [userRole, setUserRole] = useState(window.userRole);
    const [rimsUserRole] = useState(window.rimsUserRole);   // eTD only -- gates "send to submission"
    const [isMemberGuest, setIsMemberGuest] = useState(window.isMemberGuest);
    const [hasMoreData, setHasMoreData] = useState(true);
    const [isPaneOpen, setIsPaneOpen] = useState(false);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [dataTableHeight, setDataTableHeight] = useState("calc(100vh - 90px)");
    const [currentPage, setCurrentPage] = useState(0);
    const [currentItem, setCurrentItem] = useState(null);
    const [originalItem, setOriginalItem] = useState(null);
    const [isSavingItem, setIsSavingItem] = useState(false);
    const [isShowingSaveMessage, setIsShowingSaveMessage] = useState(false);
    const [isDeletingItem, setIsDeletingItem] = useState(false);
    const [itemSearchText, setItemSearchText] = useState("");
    const [addItemName, setAddItemName] = useState("");
    const [errorAddItemName, setErrorAddItemName] = useState(false);
    const [errorCurrentItemTitle, setErrorCurrentItemTitle] = useState(false);
    const [isAddingItem, setIsAddingItem] = useState(false);
    const [isVisibleAddItemPopup, setIsVisibleAddItemPopup] = useState(dataTableStructure.defaultOpenAddItemPopup ? dataTableStructure.defaultOpenAddItemPopup : false);
    const [isVisibleRemoveItemPopup, setIsVisibleRemoveItemPopup] = useState(false);
    const [errorCurrentItemName, setErrorCurrentItemName] = useState(false);
    const [isShowingDeleteConfirmation, setIsShowingDeleteConfirmation] = useState(false);
    const [isLoadingItemDetails, setIsLoadingItemDetails] = useState(false);
    const [selectedFilterComplianceStatus, setSelectedFilterComplianceStatus] = useState("");
    const [selectedFilterSubmissionsStatus, setSelectedFilterSubmissionsStatus] = useState("");
    const [selectedFilterSubmissionsType, setSelectedFilterSubmissionsType] = useState("");
    const [selectedFilterSubmissionsOpen, setSelectedFilterSubmissionsOpen] = useState("true");
    const [selectedFilterSystematicReviewsArea, setSelectedFilterSystematicReviewsArea] = useState([0,1,2,3,4].indexOf(dataTableStructure.srArea) != -1 ? dataTableStructure.srArea : 1);
    const [selectedSystematicReviewsType, setSelectedSystematicReviewsType] = useState(null);
    const [selectedSystematicReviewsTypeAdd, setSelectedSystematicReviewsTypeAdd] = useState(null);
    const [selectedSystematicReviewToDelete, setSelectedSystematicReviewToDelete] = useState(null);
    const [selectedFilterSystematicReviewsSection, setSelectedFilterSystematicReviewsSection] = useState(dataTableStructure.srSection);
    const [selectedFilterSystematicReviewsShowMineOnly, setSelectedFilterSystematicReviewsShowMineOnly] = useState(false);
    const [systematicReviewsHeader, setSystematicReviewsHeader] = useState(null);
    const [isChoosingComplianceStatusFilter, setIsChoosingComplianceStatusFilter] = useState(false);
    const [isChoosingSubmissionsStatusFilter, setIsChoosingSubmissionsStatusFilter] = useState(false);
    const [isChoosingSubmissionsTypeFilter, setIsChoosingSubmissionsTypeFilter] = useState(false);
    const [selectedFilterCountry, setSelectedFilterCountry] = useState("");
    const [isChoosingCountryFilter, setIsChoosingCountryFilter] = useState(false);
    const [selectedFilterRegulatoryArea, setSelectedFilterRegulatoryArea] = useState("");
    const [isChoosingRegulatoryAreaFilter, setIsChoosingRegulatoryAreaFilter] = useState(false);
    const [selectedFilterPublicationType, setSelectedFilterPublicationType] = useState("");
    const [isChoosingPublicationTypeFilter, setIsChoosingPublicationTypeFilter] = useState(false);
    const [users, setUsers] = useState([]);
    const [currentUserId, setCurrentUserId] = useState(window.currentUserId ? window.currentUserId : null);
    const [isLoadingRegulatoryDocumentsGraphs, setIsLoadingRegulatoryDocumentsGraphs] = useState(null);
    const [isLoadingStandardsGraphs, setIsLoadingStandardsGraphs] = useState(null);
    const [isLoadingSubmissionsGraphs, setIsLoadingSubmissionsGraphs] = useState(null);
    const [isLoadingComplianceFilters, setIsLoadingComplianceFilters] = useState(null);
    const [isLoadingSubmissionsFilters, setIsLoadingSubmissionsFilters] = useState(null);
    const [regDocsGraphOptionsForCountry, setRegDocsGraphOptionsForCountry] = useState({});
    const [regDocsGraphOptionsForRegulatory, setRegDocsGraphOptionsForRegulatory] = useState({});
    const [regDocsGraphOptionsForComplianceStatus, setRegDocsGraphOptionsForComplianceStatus] = useState({});
    const [submissionsGraphOptionsForCountry, setSubmissionsGraphOptionsForCountry] = useState(null);
    const [submissionsGraphOptionsForType, setSubmissionsGraphOptionsForType] = useState(null);
    const [submissionsGraphOptionsForStatus, setSubmissionsGraphOptionsForStatus] = useState(null);
    const [standardsGraphOptionsForComplianceStatus, setStandardsGraphOptionsForComplianceStatus] = useState({});
    const [standardsGraphOptionsForSource, setStandardsGraphOptionsForSource] = useState({});
    const [filterOptions_Status, setFilterOptions_Status] = useState([]);
    const [filterOptions_Types, setFilterOptions_Types] = useState([]);
    const [filterOptions_Countries, setFilterOptions_Countries] = useState([]);
    const [filterOptions_RegulatoryAreas, setFilterOptions_RegulatoryAreas] = useState([]);
    const [filterOptions_PublicationTypes, setFilterOptions_PublicationTypes] = useState([]);
    const [triggerRefreshData, setTriggerRefreshData] = useState(0);
    const [triggerRefreshGraphs, setTriggerRefreshGraphs] = useState(0);
    const [selectedReferences, setSelectedReferences] = useState([]);
    const [allReferencesSelected, setAllReferencesSelected] = useState(false);
    const isFirstLoadingReferences = useRef(true);
    const [showExportSelectedReferencesPopup, setShowExportSelectedReferencesPopup] = useState(false);
    const [showDeleteSelectedReferencesPopup, setShowDeleteSelectedReferencesPopup] = useState(false);

    const [showCountryRegistrationsExportAllReferencesPopup, setShowCountryRegistrationsExportAllReferencesPopup] = useState(false);
    const [showCountryRegistrationsDeleteAllReferencesPopup, setShowCountryRegistrationsDeleteAllReferencesPopup] = useState(false);

    




    const [isExporting, setIsExporting] = useState(false);
    const [errorExporting, setErrorExporting] = useState(false);
    const [successExporting, setSuccessExporting] = useState(false);
    const [eudamedXmlError, setEudamedXmlError] = useState(null);
    const [eudamedXmlWarning, setEudamedXmlWarning] = useState(null);
    const [eudamedXmlSuccess, setEudamedXmlSuccess] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const [errorDeleting, setErrorDeleting] = useState(false);
    const [successDeleting, setSuccessDeleting] = useState(false);
    const [absoluteTotalCount, setAbsoluteTotalCount] = useState();
    const [filteredTotalCount, setFilteredTotalCount] = useState();
    const [updatingTotalCounts, setUpdatingTotalCounts] = useState(false);
    const [addTaskEntityTypesList, setAddTaskEntityTypesList] = useState([]);
    const [linkedObjectsList, setLinkedObjectsList] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);
    const [submissionPossibleStatuses, setSubmissionPossibleStatuses] = useState([]);
    const [submissionPriorities, setSubmissionPriorities] = useState([]);
    const [submissionTypes, setSubmissionTypes] = useState([]);
    const [isRowContextualMenuVisible, setIsRowContextualMenuVisible] = useState(null);
    const [rowContextualMenu, setRowContextualMenu] = useState(null);
    const [selectedSRProjectToDelete, setSelectedSRProjectToDelete] = useState(null);
    const [isChoosingSrProjectsArchiveFilter, setIsChoosingSrProjectsArchiveFilter] = useState(false);
    const [selectedFilterSrProjectsArchive, setSelectedFilterSrProjectsArchive] = useState("false");
    const [selectedFilterProductsArchive, setSelectedFilterProductsArchive] = useState("false");
    const [selectedFilterCMArchive, setSelectedFilterCMArchive] = useState("false");
    const [selectedFilterSRProjectsShowMineOnly, setSelectedFilterSRProjectsShowMineOnly] = useState(false);
    const [legalManufacturers, setLegalManufacturers] = useState([]);
    const [isLoadingLegalManufacturers, setIsLoadingLegalManufacturers] = useState(false);
    const [currentLegalManufacturerFilter, setCurrentLegalManufacturerFilter] = useState(dataTableStructure.currentLegalManufacturerFilter && dataTableStructure.currentLegalManufacturerFilter != -1 ? dataTableStructure.currentLegalManufacturerFilter : null);
    const [currentLegalManufacturerNameFilter, setCurrentLegalManufacturerNameFilter] = useState(dataTableStructure.currentLegalManufacturerNameFilter ? dataTableStructure.currentLegalManufacturerNameFilter : null);
    const [isLoadingRelatedLegalManufacturers, setIsLoadingRelatedLegalManufacturers] = useState(false);
    const [relatedLegalManufacturers, setRelatedLegalManufacturers] = useState([]);
    const [isCustomizablePopupVisible, setIsCustomizablePopupVisible] = useState(false);
    const [customizablePopup, setCustomizablePopup] = useState(null);
    const [enableCustomFields, setEnableCustomFields] = useState(dataTableStructure.enableCustomFields ? dataTableStructure.enableCustomFields : false);
    const [tagFilterUpdateTrigger, setTagFilterUpdateTrigger] = useState(0);
    const [currentRIMSFilters, setCurrentRIMSFilters] = useState(null)
    const [isMultiItemAIChatPaneOpen, setIsMultiItemAIChatPaneOpen] = useState(false);
    const [alreadyReturnedAll, setAlreadyReturnedAll] = useState(false);
    const [showLoadingInsteadOfSelectAllCheckbox, setShowLoadingInsteadOfSelectAllCheckbox] = useState(false);
    const [reachedAllowance, setReachedAllowance] = useState(dataTableStructure.reachedAllowance ? dataTableStructure.reachedAllowance : false); // ;
    const [showTimelineGraphPopup, setShowTimelineGraphPopup] = useState(false);
    const [showRefreshLastLoadData, setShowRefreshLastLoadData] = useState(false);
    const [newItemCustomFields, setNewItemCustomFields] = useState([]);   // This field is generic and stores the custom fields for the current entity type to be used in the add form (as opposed to the edit form)
    const [newItemCustomFieldsAnswers, setNewItemCustomFieldsAnswers] = useState([]);   // This field is generic and stores the custom fields answers for the current entity type to be used in the add form (as opposed to the edit form)
    const [triggerSelectAllCount, setTriggerSelectAllCount] = useState(0);
    const [isUpdatingProductsCount, setIsUpdatingProductsCount] = useState(false);
    const [productsCount, setProductsCount] = useState(null);
    const [filteredProductsCount, setFilteredProductsCount] = useState(null);
    const [columnFilters, setColumnFilters] = useState({});
    const [expandedRowIds, setExpandedRowIds] = useState([]);
    const [childRowsByParent, setChildRowsByParent] = useState({});
    const [loadingChildId, setLoadingChildId] = useState(null);
    const extraParamsMounted = useRef(false);
    const [errorMessageObject, setErrorMessageObject] = useState(null);
    const [showErrorMessagePopup, setShowErrorMessagePopup] = useState(false);
    const [isVisibleTechnicalDocumentationTemplates, setIsVisibleTechnicalDocumentationTemplates] = useState(false);
    const [isVisibleTechnicalDocumentationJurisdictions, setIsVisibleTechnicalDocumentationJurisdictions] = useState(false);

    const [isLoadingListTotalCount, setIsUpdatingListTotalCount] = useState(false);
    const [listTotalCount, setListTotalCount] = useState(null);
    const [lastFiltersUsedForListTotalCount, setLastFiltersUsedForListTotalCount] = useState("");
    const [taskCount, setTaskCount] = useState("-");
    const [isShowingTaskManagerPopup, setIsShowingTaskManagerPopup] = useState(false);
    const [showTaskCount, setShowTaskCount] = useState(dataTableStructure.showTaskCount ? dataTableStructure.showTaskCount : false);


    const [isEditingField, setIsEditingField] = useState({
        name: false,
        compliance_status: false,
    });
    
    
    let dataStructure = dataTableStructure.dataStructure;
    let dataUrl = dataTableStructure.dataUrl;
    let getSingleItemUrl = dataTableStructure.getSingleItemUrl ? dataTableStructure.getSingleItemUrl : dataTableStructure.dataUrl;
    let pageTitle = dataTableStructure.pageTitle;
    let singleItemTitle = dataTableStructure.singleItemTitle;
    let pageIcon = dataTableStructure.pageIcon;
    let breadcrumbs = dataTableStructure.breadcrumbs;
    const entityType = dataTableStructure.entityType;
    const entityTypeId = dataTableStructure.entityTypeId;
    let pageDescription = window.pageDescription;
    let preLoadItemId = dataTableStructure.preLoadItemId;
    let preLoadItemUrlParamName = dataTableStructure.preLoadItemUrlParamName;
    let showComplianceStatusFilter = dataTableStructure.showComplianceStatusFilter;
    let showCountryFilter = dataTableStructure.showCountryFilter;
    let showSubmissionsStatusFilter = dataTableStructure.showSubmissionsStatusFilter;
    let showSubmissionsTypeFilter = dataTableStructure.showSubmissionsTypeFilter;
    let showRegulatoryAreaFilter = dataTableStructure.showRegulatoryAreaFilter;
    let showPublicationTypeFilter = dataTableStructure.showPublicationTypeFilter;
    let showSystematicReviewsCompanyUserFilter = dataTableStructure.showSystematicReviewsCompanyUserFilter;
    let exportUrl = dataTableStructure.exportUrl;
    let eudamedXmlServices = dataTableStructure.eudamedXmlServices ?? [];
    let deleteUrl = dataTableStructure.deleteUrl;
    let showTotalAndFilteredCounts = dataTableStructure.showTotalAndFilteredCounts;
    let minWidth = 0;
    let ComplianceType = dataTableStructure.ComplianceType;
    let enableTags = dataTableStructure.enableTags;
    let hideAddButton = dataTableStructure.hideAddButton;
    let initUrl = dataTableStructure.initUrl;
    let certificateId = window.certificateId;
    //let legalManufacturerId = window.legalManufacturerId;
    //let legalManufacturerName = window.legalManufacturerName;
    let hasLeftMenu = dataTableStructure.hasLeftMenu;
    let customLoadItemDetails = dataTableStructure.customLoadItemDetails;
    let srCategoriesUrl = dataTableStructure.categoriesUrl;
    let srAddButton = dataTableStructure.srAddButton;
    let LimitNumberOfSurveillances = dataTableStructure.LimitNumberOfSurveillances;
    let NumberOfSurveillances = dataTableStructure.NumberOfSurveillances;
    let srApiUrl = dataTableStructure.srApiUrl;
    let srProjectApiUrl = dataTableStructure.srProjectApiUrl;
    let srProjectPageUrl = dataTableStructure.srProjectPageUrl;
    let showSRProjectsArchiveFilter = dataTableStructure.showSRProjectsArchiveFilter;
    let showProductsArchiveFilter = dataTableStructure.showProductsArchiveFilter;
    let showCMArchiveFilter = dataTableStructure.showCMArchiveFilter;
    let showSRProjectsCompanyUserFilter = dataTableStructure.showSRProjectsCompanyUserFilter;
    let srProjectIdFilter = dataTableStructure.srProjectIdFilter;
    let srProjectName = dataTableStructure.srProjectName;
    let customRowClickFunction = dataTableStructure.customRowClickFunction;
    let rowClickUrlToProjectSystematicReviews = dataTableStructure.rowClickUrlToProjectSystematicReviews;
    let baseLinkUrlForSrs = dataTableStructure.baseLinkUrlForSrs;
    let embedInSubmissions = dataTableStructure.embedInSubmissions;
    let actionMethodForSubmissions = dataTableStructure.actionMethodForSubmissions;
    let hideHeader = dataTableStructure.hideHeader;
    let hideBreadcrumbs = dataTableStructure.hideBreadcrumbs;
    let hideTitle = dataTableStructure.hideTitle;
    let showTitleAsSubTitle = !!dataTableStructure.showTitleAsSubTitle;
    let filterDocType = dataTableStructure.filterDocType;
    let showLegalManufacturerFilter = dataTableStructure.showLegalManufacturerFilter;
    let showRIMSFilter = dataTableStructure.showRIMSFilter;
    let enableMultiItemAIChatPane = dataTableStructure.enableMultiItemAIChatPane;
    let showExportButton = dataTableStructure.showExportButton;
    let showDeleteButton = dataTableStructure.showDeleteButton;
    let enableTimelineGraph = dataTableStructure.enableTimelineGraph ? dataTableStructure.enableTimelineGraph : false;
    let productStandardsListItemUrl = dataTableStructure.productStandardsListItemUrl ? dataTableStructure.productStandardsListItemUrl : null;
    let productRegulatoryDocumentsListItemUrl = dataTableStructure.productRegulatoryDocumentsListItemUrl ? dataTableStructure.productRegulatoryDocumentsListItemUrl : null;
    let productReferenceManagerListItemUrl = dataTableStructure.productReferenceManagerListItemUrl ? dataTableStructure.productReferenceManagerListItemUrl : null;
    let productsConfigurationsUrl = dataTableStructure.productsConfigurationsUrl ? dataTableStructure.productsConfigurationsUrl : null;
    let productsStandardsUrl = dataTableStructure.productsStandardsUrl ? dataTableStructure.productsStandardsUrl : null;
    let productsRegdocsUrl = dataTableStructure.productsRegdocsUrl ? dataTableStructure.productsRegdocsUrl : null;
    let productsLiteratureUrl = dataTableStructure.productsLiteratureUrl ? dataTableStructure.productsLiteratureUrl : null;
    let productsArchiveUrl = dataTableStructure.productsArchiveUrl ? dataTableStructure.productsArchiveUrl : null;
    let excelExportFileName = dataTableStructure.excelExportFileName ? dataTableStructure.excelExportFileName : null;
    let productFamilyUrl = dataTableStructure.productFamilyUrl ? dataTableStructure.productFamilyUrl : null;
    let productRegistrationsCountUrl = dataTableStructure.productRegistrationsCountUrl ? dataTableStructure.productRegistrationsCountUrl : null;
    let productFamiliesStandardsUrl = dataTableStructure.productFamiliesStandardsUrl ? dataTableStructure.productFamiliesStandardsUrl : null;
    let productFamiliesRegdocsUrl = dataTableStructure.productFamiliesRegdocsUrl ? dataTableStructure.productFamiliesRegdocsUrl : null;
    let hideSelectAllCheckbox = dataTableStructure.hideSelectAllCheckbox ? dataTableStructure.hideSelectAllCheckbox : null;
    let complianceStandardsUrl = dataTableStructure.complianceStandardsUrl ? dataTableStructure.complianceStandardsUrl : null;
    let complianceRegdocsUrl = dataTableStructure.complianceRegdocsUrl ? dataTableStructure.complianceRegdocsUrl : null;
    let reachedAllowanceProductsOnly = dataTableStructure.reachedAllowanceProductsOnly ? dataTableStructure.reachedAllowanceProductsOnly : null;
    let showListTotalCount = dataTableStructure.showListTotalCount ? dataTableStructure.showListTotalCount : false;
    let listTotalCountURL = dataTableStructure.listTotalCountURL ? dataTableStructure.listTotalCountURL : false;
    let hideSearchBar = dataTableStructure.hideSearchBar ? dataTableStructure.hideSearchBar : false;
    let filterBarControls = dataTableStructure.filterBarControls ?? null;
    let hideExcelExport = dataTableStructure.hideExcelExport ? dataTableStructure.hideExcelExport : false;
    // Page-specific query parameters sent with the list, count and select-all requests
    let extraDataUrlParams = dataTableStructure.extraDataUrlParams ?? {};
    let disableCustomFieldCreation = dataTableStructure.disableCustomFieldCreation ? dataTableStructure.disableCustomFieldCreation : false;
    let searchPlaceholder = dataTableStructure.searchPlaceholder || null;


    // Calculate minimum width for table

    // Prefer a configured field (e.g. Task name) so column reordering does not move the chevron.
    // Fall back to the first non-checkbox column if that field is hidden.
    const expandColumnIndex = (() => {
        if (!dataTableStructure.expandable)
            return -1;
        const preferredField = dataTableStructure.expandable.expandColumnField;
        if (preferredField) {
            const preferredIndex = dataStructure.findIndex(
                (column) => !column.isSelectItemCheckbox && column.field === preferredField
            );
            if (preferredIndex >= 0)
                return preferredIndex;
        }
        return dataStructure.findIndex((column) => !column.isSelectItemCheckbox);
    })();

    const columnWidth = (width, index) => {
        if (!dataTableStructure.expandable || index !== expandColumnIndex || !width)
            return width;
        const size = parseInt(String(width).replace("px", ""), 10);
        return Number.isNaN(size) ? width : `${size + 24}px`;
    };

    dataStructure.map((item, index) => {
        if (item.width) {
            let width = parseInt(String(columnWidth(item.width, index)).replace("px", ""));
            minWidth += width;
        }
    });


    // This default filters is used to inject filters from start (for country filters in registrations for example)
    if (defaultFilters == undefined)
        defaultFilters = useMemo(() => getDefaultFiltersFromUrl(), []);



    let countryFilterId = defaultFilters?.find(f => f.key === "CountryId")?.value;

    /* FIRST RUN */
    /* FIRST RUN */
    /* FIRST RUN */

    useEffect(() => {

        loadUsers();


        // Load initial data and show any requested preloaded item

        // Is there any preloaded item that we need to show immediately? (direct link to view an item)
        if (preLoadItemId) {
            setTimeout(() => {
                loadItemDetails(preLoadItemId);
            }, 500);
        }

        loadData().then(() => {
            
        });


        // Load entities to linked to

        loadEntities();


        // Load possible filters for the entity type

        if (entityType == "compliance-regulatorydocuments") {
            loadRegulatoryDocumentsGraphs();
            loadComplianceFilters();
        }

        if (entityType == "compliance-standards") {
            loadComplianceFilters(); // For now the same method but will change when backend has the new one regarding standards
        }


        if (entityType == "submissions" || entityType == "change-assessments") {

            loadSubmissionsFilters();

            // Load possible statuses
            setSubmissionPossibleStatuses([
                { id: 0, name: "Preparation", isOpenType: "true" },   // The isOpenType distinguishes if the state is a part of the "Open" or of the "Completed" general state (from the tab bar)
                { id: 1, name: "Submitted", isOpenType: "true" },
                { id: 2, name: "Questions", isOpenType: "true" },
                { id: 3, name: "Completed", isOpenType: "false" },
            ]);


            // Set Priorities
            setSubmissionPriorities([
                { id: 1, name: "High" },
                { id: 2, name: "Medium" },
                { id: 3, name: "Low" },
                { id: 4, name: "None" },
            ]);

            // Set Priorities
            setSubmissionTypes([
                { id: 0, name: "New" },
                { id: 1, name: "Renewal" },
                { id: 2, name: "Change" },
                { id: 3, name: "Other" },
            ]);


        }


        if (entityType == "systematic-review") {
            loadSystematicReviewHeader(selectedFilterSystematicReviewsSection);
        }




        // LEGAL MANUFACTURERS FILTER

        if (showLegalManufacturerFilter) {
            loadLegalManufacturers();
        }


        // Load tasks count for bullet
        if (showTaskCount) {

            if (entityType == "countryregistrations") {
                if (countryFilterId)
                    updateTaskCount();
                else
                    setShowTaskCount(false); // If it's a countryregistration without country filter there is no corresponding task page so hide task count button
            }
            else
                updateTaskCount();
        }


    }, []);



    /* Toggles the side pane */
    const togglePane = () => {
        setIsPaneOpen(!isPaneOpen);
    };


    const closePane = () => {
        setIsPaneOpen(false);

        if (preLoadItemUrlParamName) {
            const url = new URL(window.location);
            url.searchParams.delete(preLoadItemUrlParamName);
            window.history.pushState({}, "", url);
        }

    };


    const toggleMultiItemAIChatPane = () => {
        setIsMultiItemAIChatPaneOpen(!isMultiItemAIChatPaneOpen);
    }

    const closeMultiItemAIChatPane = () => {
        setIsMultiItemAIChatPaneOpen(false);
    };



    const disableAllItemFormFieldsEdit = () => {
        let newObj = { ...isEditingField };
        for (let prop in newObj) {
            newObj[prop] = false;
        }
        setIsEditingField(newObj);
    };


    const changeDataOrderField = (field) => {
        let newOrderByType = "ASCENDING";

        if (field == dataSortByField) {
            if (dataSortByType == "ASCENDING") newOrderByType = "DESCENDING";
            setDataSortByType(newOrderByType);
        } else {
            setDataSortByType("ASCENDING");
            setDataSortByField(field);
        }

        loadData({
            localSortType: newOrderByType,
            localSortByField: field
        });
    };



    function getDefaultFiltersFromUrl() {
        const params = new URLSearchParams(window.location.search);

        const filters = [];

        for (const [key, value] of params.entries()) {
            const match = key.match(/^filter\[(.+)\]$/);

            if (match) {
                filters.push({
                    key: match[1],
                    value,
                });
            }
        }

        return filters;
    }



    const loadCurrentUserId = () => {

        let loadUserURL = "/umbraco/api/Compliance/CurrentUserId";

        fetch(loadUserURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((data) => {
                setCurrentUserId(data);
            })
            .catch((error) => {
            });

    };


    useEffect(() => {

        if (currentUserId == null)
            return;

        updateUsers();

    }, [currentUserId]);


    const updateUsers = ({ userList = users } = {}) => {

        if (userList == null || userList.length == 0)
            return;

        userList = userList.map((item) => {
            return {
                ...item,
                ["IsItMe"]: item.Id == currentUserId ? true : false
            };
        });

        setUsers(userList);

        window.userList = userList;

    }

    const loadUsers = () => {
        let loadUsersURL = "/umbraco/api/TaskManagerApi/Users";

        fetch(loadUsersURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // Update state with the received data
                updateUsers({ userList: data });

                if (currentUserId == null)
                    loadCurrentUserId();

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            });
    };


    const addItem = () => {
        let addItemURL = dataUrl;

        let newItem = {
            Name: addItemName,
        };

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newItem)
        };

        // Validations

        let isValidForm = true;

        setErrorAddItemName(false);

        if (!validFormField(addItemName, setErrorAddItemName)) isValidForm = false;

        if (!isValidForm) return false;

        setIsAddingItem(true);

        fetch(addItemURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {
                // Update state with the received data
                if (result.Id) {
                    let newDataList = [result, ...data];
                    setData(newDataList);
                    updateListTotalCount();
                    showAddItemPopup(false);
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsAddingItem(false);
            });
    };


    const saveCurrentItem = () => {
        // Validations

        let isValidForm = true;

        setErrorCurrentItemName(false);

        if (!validFormField(currentItem.Name, setErrorCurrentItemName)) isValidForm = false;

        if (!isValidForm) return false;

        setIsSavingItem(true);
        setIsShowingSaveMessage(false);
        disableAllItemFormFieldsEdit();

        // Update item remotely and if successful...

        setCurrentItem(currentItem);

        let updateItemURL = dataUrl;

        let requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(currentItem)
        };

        fetch(updateItemURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Id) {
                    // Update the item in the existing item array
                    let updatedDataArray = data.map((item) =>
                        item.Id === result.Id ? result : item
                    );

                    // If a subtask was marked incomplete, the backend also forces the parent incomplete
                    if (result.ParentTaskId && (result.CompletionStatus == 0 || result.CompletionStatus == "0")) {
                        updatedDataArray = updatedDataArray.map((item) =>
                            item.Id == result.ParentTaskId ? { ...item, CompletionStatus: 0 } : item
                        );
                        if (currentItem?.Id == result.ParentTaskId)
                            setCurrentItem((prev) => prev ? { ...prev, CompletionStatus: 0 } : prev);
                    }

                    setData(updatedDataArray);
                    // Expanded subtasks are kept beside the parent list, so a saved child
                    // has to be written back into that cache as well.
                    setChildRowsByParent((prev) => {
                        let changed = false;
                        const next = {};
                        Object.keys(prev).forEach((parentId) => {
                            const children = prev[parentId];
                            if (!Array.isArray(children) || !children.some((child) => child.Id === result.Id)) {
                                next[parentId] = children;
                                return;
                            }
                            changed = true;
                            next[parentId] = children.map((child) => child.Id === result.Id ? result : child);
                        });
                        return changed ? next : prev;
                    });
                    setIsShowingSaveMessage(true);
                }
                
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingItem(false);
            });
    };


    const deleteCurrentItem = ({ callBack }) => {
        setIsDeletingItem(true);

        // Delete item remotely

        let itemId = currentItem.Id;

        let deleteTaskURL = dataUrl + `?` +
            `Id=${encodeURIComponent(itemId)}&`;

        let requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        };

        fetch(deleteTaskURL, requestOptions)
            .then(async (response) => {
                if (!response.ok) {
                    // User is logged out
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    // There was a server error, is it readable?
                    if (response.status === 400) {
                        try {
                            let errorObject = await response.json();
                            setErrorMessageObject(errorObject);
                            setShowErrorMessagePopup(true);
                        }
                        catch (ex) { }
                    }

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result === true || result.Status == 1) {
                    const deletedChildIds = (childRowsByParent[itemId] || []).map((child) => child.Id);
                    const deletedItem = data.find((item) => item.Id === itemId)
                        || Object.values(childRowsByParent).flat().find((item) => item.Id === itemId);

                    // Remove parent (and cascade-deleted children) from the top-level list
                    let updatedDataArray = data.filter(
                        (item) => item.Id !== itemId
                    );

                    // If a subtask was deleted, drop it from the parent cache and reduce SubtaskCount
                    if (deletedItem?.ParentTaskId) {
                        setChildRowsByParent((prev) => {
                            const parentId = deletedItem.ParentTaskId;
                            const children = prev[parentId];
                            if (!Array.isArray(children))
                                return prev;
                            return {
                                ...prev,
                                [parentId]: children.filter((child) => child.Id !== itemId),
                            };
                        });
                        updatedDataArray = updatedDataArray.map((item) =>
                            item.Id == deletedItem.ParentTaskId
                                ? { ...item, SubtaskCount: Math.max(0, (item.SubtaskCount || 0) - 1) }
                                : item
                        );
                    } else if (deletedChildIds.length > 0) {
                        // Parent deleted: clear its expanded children cache
                        setChildRowsByParent((prev) => {
                            const next = { ...prev };
                            delete next[itemId];
                            return next;
                        });
                    }

                    setData(updatedDataArray);
                    setSelectedReferences((prev) =>
                        prev.filter((id) => id !== itemId && !deletedChildIds.includes(id))
                    );
                    closePane();

                    updateListTotalCount();

                    if (callBack)
                        callBack();
                }
                else {
                    setErrorMessageObject(result);
                    setShowErrorMessagePopup(true);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsDeletingItem(false);
                setIsShowingDeleteConfirmation(false);
            });
    };


    const showAddItemPopup = (status) => {
        if (status === false) {
            setIsVisibleAddItemPopup(false);

            // Remove defaultOpenAddItemPopup url param if exists
            const url = new URL(window.location.href);
            url.searchParams.delete("defaultOpenAddItemPopup");
            window.history.replaceState({}, document.title, url.toString());

            // also set to false in the dataTableStructure because it retriggers in case of column management datatable refresh
            dataTableStructure.defaultOpenAddItemPopup = false;

        } else {

            // Clear other popups
            closeAllPopups();
            // Clean fields
            setAddItemName("");
            // Clean errors
            setErrorAddItemName(false);
            // Show add task popup
            setIsVisibleAddItemPopup(true);
        }
    };

    const showRemoveItemPopup = (status) => {
        if (status === false) {
            setIsVisibleRemoveItemPopup(false);
        } else {
            setIsVisibleRemoveItemPopup(true);
        }
    };




    const enableTaskFormFieldEdit = (field, e) => {
        e.stopPropagation();
        let newObj = { ...isEditingField, [field]: true };
        setIsEditingField(newObj);
    };


    const doTextSearchTask = ({ localSearch }) => {
        let debouncingTime = 500;
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {

            refreshData();
            refreshGraphs();

        }, debouncingTime);
    };



    const applyFilterSrProjectsArchive = (value) => {

        setSelectedFilterSrProjectsArchive(value);
        setIsChoosingSrProjectsArchiveFilter(false);

        refreshData();
    }

    const applyFilterProductsArchive = (value) => {

        setItemSearchText("");
        setSelectedFilterProductsArchive(value);

        refreshData();
        //updateProductsCount(value);
    }


    const applyFilterCMArchive = (value) => {

        setItemSearchText("");
        setSelectedFilterCMArchive(value);

        refreshData();
        refreshGraphs();
        //updateProductsCount(value);
    }




    const applyFilterComplianceStatus = (value) => {

        setSelectedFilterComplianceStatus(value);
        setIsChoosingComplianceStatusFilter(false);

        refreshData();
        refreshGraphs();
    }


    const applyFilterSubmissionsStatus = (value) => {

        setSelectedFilterSubmissionsStatus(value);
        setIsChoosingSubmissionsStatusFilter(false);

        refreshData();
        refreshGraphs();
    }


    const applyFilterSubmissionsType = (value) => {

        setSelectedFilterSubmissionsType(value);
        setIsChoosingSubmissionsTypeFilter(false);

        refreshData();
        refreshGraphs();
    }

    const applyFilterPublicationType = (value) => {

        setSelectedFilterPublicationType(value);
        setIsChoosingPublicationTypeFilter(false);

        refreshData();
        refreshGraphs();
    }


    const applyFilterRegulatoryArea = (value) => {

        setSelectedFilterRegulatoryArea(value);
        setIsChoosingRegulatoryAreaFilter(false);

        refreshData();
        refreshGraphs();
    }


    const applyFilterCountry = (value) => {

        setSelectedFilterCountry(value);
        setIsChoosingCountryFilter(false);

        refreshData();
        refreshGraphs();
    }


    const refreshData = () => {

        setTriggerRefreshData(triggerRefreshData + 1);

    }

    useEffect(() => {

        // dont run on initialization
        if (triggerRefreshData == 0)
            return;

        loadData();

    }, [triggerRefreshData])

    useEffect(() => {
        if (!extraParamsMounted.current) {
            extraParamsMounted.current = true;
            return;
        }
        if (dataTableStructure.extraQueryParamsKey == null)
            return;
        loadData();
    }, [dataTableStructure.extraQueryParamsKey])






    // Each time the selectedTags changes we update the list

    const hasMountedSelectedTags = useRef(false);

    useEffect(() => {

        // is it the first load? Dont update this time then
        if (!hasMountedSelectedTags.current) {
            hasMountedSelectedTags.current = true;
            return;
        }

        refreshData();
        refreshGraphs();

    }, [selectedTags]);





    const triggerSelectAll = () => {

        setTriggerSelectAllCount(prev => prev + 1);

    }


    useEffect(() => {

        if (triggerSelectAllCount > 0)
            selectAllReferences(data);

    }, [triggerSelectAllCount]);






    const resolveExtraQueryParams = () => {
        const raw = dataTableStructure.extraQueryParams;
        if (typeof raw === "function")
            return raw() || {};
        return raw || {};
    };

    const loadData = ({
        localSearch = itemSearchText,
        localSortType = dataSortByType,
        localSortByField = dataSortByField,
        localFilterComplianceStatus = selectedFilterComplianceStatus,
        localFilterRegulatoryArea = selectedFilterRegulatoryArea,
        localFilterPublicationType = selectedFilterPublicationType,
        localFilterCountry = selectedFilterCountry,
        nextPage = false,
        localFilterSubmissionsStatus = selectedFilterSubmissionsStatus,
        localFilterSubmissionsType = selectedFilterSubmissionsType,
        localFilterSubmissionsOpen = selectedFilterSubmissionsOpen,
        localFilterSystematicReviewsArea = selectedFilterSystematicReviewsArea,
        localFilterSystematicReviewsSection = selectedFilterSystematicReviewsSection,
        localFilterSystematicReviewsShowMineOnly = selectedFilterSystematicReviewsShowMineOnly,
        localFilterSRProjectsArchive = selectedFilterSrProjectsArchive,
        localFilterProductsArchive = selectedFilterProductsArchive,
        localFilterSRProjectsShowMineOnly = selectedFilterSRProjectsShowMineOnly,
        localFilterSRProjectsProjectId = srProjectIdFilter,
        localFilterLegalManufacturerId = currentLegalManufacturerFilter,
        localFilterRIMSFilters = currentRIMSFilters,
        localFilterCMArchive = selectedFilterCMArchive,
        returnAll = false,
        selectAll = false,

    } = {}) => {


        return new Promise((resolve, reject) => {



            if (isLoadingData) {
                resolve();
                return;
            }


            if (returnAll) {
                if (alreadyReturnedAll) {
                    if(selectAll)
                        selectAllReferences(data);
                    resolve();
                    return;
                }
                if(selectAll)
                    setShowLoadingInsteadOfSelectAllCheckbox(true);

                setAlreadyReturnedAll(true);
            }
            else
                setAlreadyReturnedAll(false);



            setIsLoadingData(true);
            setShowRefreshLastLoadData(false);
            setHasMoreData(true);

            let local_data = data;
            let local_data_page = currentPage;

            if (nextPage == false) {
                local_data = [];
                local_data_page = 1;
                setData(local_data);
                //setCurrentPage(local_data_page);
                setSelectedReferences([]);

                if (showTotalAndFilteredCounts) {
                    // If it's the first page update the total and filtered counts
                    updateRegulatoryDocumentsCounts();
                }

                if (entityType == "product-skus") {
                    updateProductsCount(localSearch, selectedFilterProductsArchive);
                }

            
            } else {
                local_data_page++;
                //setCurrentPage(local_data_page);
            }


            let tagIds = selectedTags.map((tag) => tag.Id).join(",");


            const extraQueryParams = resolveExtraQueryParams();
            const searchForQuery = extraQueryParams.search !== undefined && extraQueryParams.search !== null
                ? extraQueryParams.search
                : localSearch;

            let dataURLParams = 
                `search=${encodeURIComponent(searchForQuery)}&` +
                `sortBy=${encodeURIComponent(localSortByField)}&` +
                `sortType=${encodeURIComponent(localSortType)}&` +
                `page=${encodeURIComponent(local_data_page)}&` + 
                `tagIds=${encodeURIComponent(tagIds)}&` + 
                `returnAll=${encodeURIComponent(returnAll)}&`;

            Object.entries(extraDataUrlParams).forEach(([key, value]) => {
                dataURLParams += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`;
            });


            // Filters for Compliance

            if (entityType == "compliance-regulatorydocuments" || entityType == "compliance-standards") {
                //dataURLParams += `filter[status]=${encodeURIComponent(localFilterComplianceStatus)}&`;
                //dataURLParams += `filter[country]=${encodeURIComponent(localFilterCountry)}&`;
                //dataURLParams += `filter[regulatoryArea]=${encodeURIComponent(localFilterRegulatoryArea)}&`;
                //dataURLParams += `filter[publicationType]=${encodeURIComponent(localFilterPublicationType)}&`;

                if (localFilterRIMSFilters != null) {
                    dataURLParams += `filter[products]=${encodeURIComponent(localFilterRIMSFilters.products?.map(item => item.Id).join(",")) ?? ""}&`;
                    dataURLParams += `filter[productFamilies]=${encodeURIComponent(localFilterRIMSFilters.productFamilies?.map(item => item.Id).join(",")) ?? ""}&`;
                    dataURLParams += `filter[countries]=${encodeURIComponent(localFilterRIMSFilters.countries?.map(item => item.Id).join(",")) ?? ""}&`;
                    dataURLParams += `filter[certificates]=${encodeURIComponent(localFilterRIMSFilters.certificates?.map(item => item.Id).join(",")) ?? ""}&`;
                    dataURLParams += `filter[operators]=${encodeURIComponent(localFilterRIMSFilters.operators?.map(item => item.Id).join(",")) ?? ""}&`;
                }

                if (localFilterCMArchive != null) {
                    dataURLParams += `archive=${encodeURIComponent(localFilterCMArchive)}&`;
                }

            }



            if (entityType == "compliance-qms" || entityType == "compliance-technical-documents") {

                if (localFilterCMArchive != null) {
                    dataURLParams += `archive=${encodeURIComponent(localFilterCMArchive)}&`;
                }
            }


            // Filters for Country Registration Files

            if (entityType == "country-registration-documents" && filterDocType != null) {
                dataURLParams += `docType=${encodeURIComponent(filterDocType)}&`;
            }
            // Filters for Submissions

            if (entityType == "submissions") {

                dataURLParams += `open=${encodeURIComponent(localFilterSubmissionsOpen)}&`;

                if (localFilterLegalManufacturerId != undefined)
                    dataURLParams += `legalManufacturerId=${encodeURIComponent(localFilterLegalManufacturerId)}&`;

                if(certificateId != undefined)
                    dataURLParams += `filter[certificateId]=${encodeURIComponent(certificateId)}&`;
                
                dataURLParams += `filter[status]=${encodeURIComponent(localFilterSubmissionsStatus)}&`;
                dataURLParams += `filter[country]=${encodeURIComponent(localFilterCountry)}&`;
                dataURLParams += `filter[type]=${encodeURIComponent(localFilterSubmissionsType)}&`;
            }


            // Filters for Systematic Reviews

            if (entityType == "systematic-review") {

                dataURLParams += `area=${encodeURIComponent(localFilterSystematicReviewsArea)}&`;
                dataURLParams += `section=${encodeURIComponent(localFilterSystematicReviewsSection)}&`;
                dataURLParams += `showMineOnly=${encodeURIComponent(localFilterSystematicReviewsShowMineOnly)}&`;
                dataURLParams += `groupId=${encodeURIComponent(localFilterSRProjectsProjectId)}&`;

                if (localFilterRIMSFilters != null) {
                    dataURLParams += `filter[products]=${encodeURIComponent(localFilterRIMSFilters.products?.map(item => item.Id).join(",")) ?? ""}&`;
                    dataURLParams += `filter[productFamilies]=${encodeURIComponent(localFilterRIMSFilters.productFamilies?.map(item => item.Id).join(",")) ?? ""}&`;
                    dataURLParams += `filter[countries]=${encodeURIComponent(localFilterRIMSFilters.countries?.map(item => item.Id).join(",")) ?? ""}&`;
                    dataURLParams += `filter[certificates]=${encodeURIComponent(localFilterRIMSFilters.certificates?.map(item => item.Id).join(",")) ?? ""}&`;
                    dataURLParams += `filter[operators]=${encodeURIComponent(localFilterRIMSFilters.operators?.map(item => item.Id).join(",")) ?? ""}&`;
                }

            }


            // Filters for SR Projects

            if (entityType == "srprojects") {

                dataURLParams += `showArchived=${encodeURIComponent(localFilterSRProjectsArchive)}&`;
                dataURLParams += `showMineOnly=${encodeURIComponent(localFilterSRProjectsShowMineOnly)}&`;
            }


            // Filters for Legal Manufacturer
            if (localFilterLegalManufacturerId != -1) {
                dataURLParams += `legalManufacturerId=${encodeURIComponent(localFilterLegalManufacturerId)}&`;
            }


            // Filters for Products
            if (entityType == "product-skus") {

                dataURLParams += `archived=${encodeURIComponent(localFilterProductsArchive)}&`;
            }
            

            // Add column filters
            Object.keys(columnFilters).forEach((filter) => {
                if(columnFilters[filter] && columnFilters[filter] != "")
                    dataURLParams += `filter[${filter}]=${encodeURIComponent(columnFilters[filter])}&`;
            });


            // Add general default filters from url ONLY if not already present in columnFilters
            defaultFilters.forEach(({ key, value }) => {

                // Skip if columnFilters already contains this field
                if (Object.prototype.hasOwnProperty.call(columnFilters, key)) {
                    return;
                }

                dataURLParams += `filter[${key}]=${encodeURIComponent(value)}&`;
            });

            Object.entries(extraQueryParams).forEach(([key, value]) => {
                if (key === "search" || key === "sortBy" || key === "sortType" || key === "page")
                    return;
                if (value === undefined || value === null)
                    return;
                dataURLParams += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`;
            });



            let loadDataURL = dataUrl + `?` + dataURLParams;

            // Also get total counts?
            if (local_data_page == 1 && showListTotalCount) {
                updateListTotalCount(dataURLParams);
            }


            let requestOptions = {};

            fetch(loadDataURL, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        //setHasMoreData(false);
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((result) => {


                    // DUMMY - DELETE THIS WHEN BACKEND IS READY

                    //result = result.map((item) => {
                    //    item.Status == undefined ? item.Status = Math.round(Math.random() * 4 + 1) : null;
                    //    item.TaskCount == undefined ? item.TaskCount = Math.round(Math.random() * 10) : null;
                    //
                    //    return item;
                    //});

                    setCurrentPage(local_data_page);

                    if (returnAll)
                        setHasMoreData(false);

                    let allData = [];
                    const resultRows = Array.isArray(result) ? result : [];

                    // If no items returned it means there is no more data to retrieve
                    if (resultRows.length == 0) {
                        setHasMoreData(false);
                        allData = data;
                        if (!nextPage && dataTableStructure.expandable) {
                            setChildRowsByParent({});
                            setExpandedRowIds([]);
                        }
                    }
                    else {
                        // Select-all uses nextPage + returnAll: keep already-loaded pages and
                        // append only rows not yet in the list (returnAll may re-send earlier pages).
                        if (nextPage) {
                            const seen = new Set((data || []).map((row) => row.Id));
                            const additions = resultRows.filter((row) => !seen.has(row.Id));
                            allData = [...(data || []), ...additions];
                            setData(allData);
                        } else {
                            setData(resultRows);
                            allData = resultRows;
                        }

                        // Task Manager (and other expandable tables): seed matched children
                        // so search / "my tasks" subtask hits are visible under their parents.
                        if (dataTableStructure.expandable) {
                            const byParent = {};
                            const expandIds = [];
                            resultRows.forEach((item) => {
                                if (Array.isArray(item.MatchedSubtasks) && item.MatchedSubtasks.length > 0) {
                                    byParent[item.Id] = item.MatchedSubtasks;
                                    expandIds.push(item.Id);
                                }
                            });
                            if (nextPage) {
                                setChildRowsByParent((prev) => ({ ...prev, ...byParent }));
                                setExpandedRowIds((prev) => Array.from(new Set([...prev, ...expandIds])));
                            } else {
                                setChildRowsByParent(byParent);
                                setExpandedRowIds(expandIds);
                            }
                        }
                    }

                    // Was it a "check all" action on the list?
                    if (selectAll) {
                        // Select after state updates: include already-loaded rows + new result + subtasks.
                        // triggerSelectAll can race with setData and miss children.
                        setAllReferencesSelected(true);
                        setSelectedReferences((prevSelected) => {
                            const ids = new Set(prevSelected || []);
                            (data || []).forEach((row) => ids.add(row.Id));
                            resultRows.forEach((row) => {
                                ids.add(row.Id);
                                (row.MatchedSubtasks || []).forEach((child) => ids.add(child.Id));
                            });
                            if (dataTableStructure.expandable) {
                                Object.values(childRowsByParent || {}).forEach((children) => {
                                    (children || []).forEach((child) => ids.add(child.Id));
                                });
                            }
                            return [...ids];
                        });
                        setShowLoadingInsteadOfSelectAllCheckbox(false);
                    }

                    resolve();

                })
                .catch((error) => {
                    // Handle any errors that occurred during the fetch
                    setShowRefreshLastLoadData(true);
                    setHasMoreData(false);
                    reject();
                })
                .finally(() => {
                    setIsLoadingData(false);
                });


        });
        
    };





    const updateListTotalCount = (dataURLParams = lastFiltersUsedForListTotalCount) => {

        if (!showListTotalCount)
            return;

        setIsUpdatingListTotalCount(true);

        // This is used for create/delete requests that need to update the count but dont go through the loadData method
        setLastFiltersUsedForListTotalCount(dataURLParams);

        let loadListTotalCountURL = listTotalCountURL + "?" + dataURLParams;

        fetch(loadListTotalCountURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                setListTotalCount(data);
                
            })
            .catch((error) => {
                setListTotalCount(null);
            })
            .finally(() => {
                setIsUpdatingListTotalCount(false);
            });


    }



    const loadEntities = () => {

        // For now, the entities are retrieved by getting the menu and checking which items are "IsSearchable"
        let loadEntitiesURL = "/umbraco/api/TaskManagerApi/Menu?entityType=&entityId=";

        fetch(loadEntitiesURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                // Set the Entity types that can be used in the create/edit task
                if (addTaskEntityTypesList.length == 0) {
                    let listOfEntities = [];
                    data.Nodes.map((item) => {
                        if (item.IsSearchable) {
                            listOfEntities.push(item);
                        }
                    });

                    setAddTaskEntityTypesList(listOfEntities);
                    
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });

    }



    /*
     * This method is just static names for entity types that aren't initially fetched when getting the menu like for example "systematic-review-item"
     * */
    const getStaticEntityTypeName = (entityType) => {

        let entityName = "";

        switch (entityType) {
            case "systematic-review-item": entityName = "Systematic Review Item"; break;
            case "product": entityName = "Products"; break;
            case "countryregistration": entityName = "Country Registrations"; break;
            case "compliance": entityName = "Compliance Manager"; break;
            default: entityName = "";
        }

        return entityName;

    }



    



    /* Opens the side pane and loads the task details */
    const loadItemDetails = (ItemId, e = null, ignoreCustomLoadFunction = false) => {
        if(e != null)
            e.stopPropagation();

        let legalManufacturerId = currentLegalManufacturerFilter;

        // Is there a custom loadItemDetails? Possibly from the Entity
        if (customLoadItemDetails && !ignoreCustomLoadFunction) {

            if (entityType == "systematic-review") {
                let itemSection = data.find(item => item.Id == ItemId).Type;
                customLoadItemDetails(itemSection, ItemId);
            }

            return;
        }


        // Change URL to reflect details view
        if (preLoadItemUrlParamName) {
            const url = new URL(window.location);
            url.searchParams.set(preLoadItemUrlParamName, ItemId); // add or update
            window.history.pushState({}, "", url);
        }


        // Clear errors
        setErrorCurrentItemName(false);


        // Close all visible popups
        closeAllPopups();


        // Open side pane
        if (!isPaneOpen) togglePane();

        setCurrentItem(null);
        setOriginalItem(null);

        setIsLoadingItemDetails(true);

        let loadItemURL = getSingleItemUrl + `?` + 
            `Id=${encodeURIComponent(ItemId)}&`;
        if (legalManufacturerId != -1) {
            loadItemURL += `legalManufacturerId=${encodeURIComponent(legalManufacturerId)}&`;
        }

        fetch(loadItemURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        closePane();
                        document.dispatchEvent(new Event("api:unauthorized"));
                    }

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Id) {

                    let currentItem = result;

                    // Load task details
                    setCurrentItem(currentItem);
                    setOriginalItem(currentItem);

                    // DEBUG# Add this when the backend sends it in the item details
                    // DEBUG# Add this when the backend sends it in the item details
                    // DEBUG# Add this when the backend sends it in the item details

                    if (currentItem.Entities) {
                        let simplifiedEntities = currentItem.Entities.map((item) => ({ EntityType: item.SecondaryEntityType, EntityId: item.SecondaryEntityId, EntityName: item.SecondaryEntityName, EntityUrl: item.SecondaryEntityUrl }));

                        setLinkedObjectsList(simplifiedEntities);
                    }
                    else
                        setLinkedObjectsList([]);

                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
                setIsLoadingItemDetails(false);
            });


    };











    /* SCROLL TO LOAD FEATURE */
    /*
    const resultsDivRef = useRef(null);

    function useFixMissingScroll({ hasMoreItems, isLoading, fetchMoreItems }) {

        const mainElement = resultsDivRef.current;

        const fetchCb = useCallback(() => {
            fetchMoreItems({ nextPage: true });
        }, [fetchMoreItems])

        useEffect(() => {

            const hasScroll = mainElement ? mainElement.scrollHeight > mainElement.clientHeight : false
            if (!hasScroll && hasMoreItems && !isLoading) {

                setTimeout(() => {
                    fetchCb()
                }, 100)
            }
        }, [hasMoreItems, fetchCb, mainElement])
    }

    useFixMissingScroll({ hasMoreItems: hasMoreData, isLoading: isLoadingData, fetchMoreItems: loadData });

    useEffect(() => {
        const handleScrollResultsDiv = () => {
            const div = resultsDivRef.current;
            if (div) {
                const threshold = 20;
                const isBottom =
                    div.scrollTop + threshold >= div.scrollHeight - div.clientHeight;

                if (isBottom && !isLoadingData && hasMoreData) {
                    //console.log("LOAD MORE");
                    setIsLoadingData(true);
                    loadData({ nextPage: true });
                }
            }
        };

        const div = resultsDivRef.current;

        if (div) {
            div.addEventListener("scroll", handleScrollResultsDiv);
        }

        return () => {
            // Remove listener for scroll
            if (div) div.removeEventListener("scroll", handleScrollResultsDiv);
        };
    });
    */


    const targetRef = useRef(null);

    useEffect(() => {

        // If its the first time is loading data there might be a race condition that replaces the first results. This is to avoid that situation (tentative fix)
        if (isFirstLoadingReferences.current == true) {
            isFirstLoadingReferences.current = false;
            return;
        }

        // Check if the targetRef is visible
        const observer = new IntersectionObserver(
            ([entry]) => {

                // It's visible?
                if (entry.isIntersecting) {

                    if (hasMoreData && !isLoadingData) {
                        loadData({ nextPage: true });
                    }

                }

            },
            { threshold: 0 } // Adjust the threshold as needed
        );

        if (targetRef.current) {
            observer.observe(targetRef.current);
        }

        return () => {
            if (targetRef.current) {
                observer.unobserve(targetRef.current);
            }
        };
    }, [isLoadingData]);












    const validFormField = (field, errorFunc) => {
        if (field == "") {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };


    

    // When a user clicks outside of any element in the main area
    const handleOutsideClick = () => {
        // Close task details pane
        closePane();

        // Hide contextual item menu
        setIsRowContextualMenuVisible(false);

    };



    const loadSystematicReviewHeader = (section = null) => {


        
        let dataUrl = "/umbraco/api/SystematicReviewApi/Header";

        let loadHeaderURL = dataUrl + `?` +
            `section=${encodeURIComponent(section)}&`
            ;

        let requestOptions = {};


        fetch(loadHeaderURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((result) => {

                setSystematicReviewsHeader(result);

            })
            .catch((error) => {
            })
            .finally(() => {
            });


    }



    const loadComplianceFilters = () => {

        let filtersURL = "/umbraco/api/Compliance/Filters";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(filtersURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                let filters = JSON.parse(JSON.stringify(result));

                // Extract the grapoh values from the request result
                let optionsFor_Status = filters["Status"];
                let optionsFor_Countries = filters["Countries"];
                let optionsFor_RegulatoryAreas = filters["RegulatoryAreas"];
                let optionsFor_PublicationTypes = filters["PublicationTypes"];

                setFilterOptions_Status(optionsFor_Status);
                setFilterOptions_Countries(optionsFor_Countries);
                setFilterOptions_RegulatoryAreas(optionsFor_RegulatoryAreas);
                setFilterOptions_PublicationTypes(optionsFor_PublicationTypes);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoadingComplianceFilters(false);
            });

    }









    const loadSubmissionsFilters = () => {

        let filtersURL = "/umbraco/api/Submission/Filters";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsLoadingSubmissionsFilters(true);

        fetch(filtersURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                let filters = JSON.parse(JSON.stringify(result));

                // Extract the graph values from the request result
                let optionsFor_Status = filters["Status"];
                let optionsFor_Countries = filters["Countries"];
                let optionsFor_Types = filters["Types"];

                setFilterOptions_Status(optionsFor_Status);
                setFilterOptions_Countries(optionsFor_Countries);
                setFilterOptions_Types(optionsFor_Types);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoadingSubmissionsFilters(false);
            });

    }


    

    /*
     * Each time properties that affect the graphs change call the update to the graphs
     */

    // Just trigger the update change
    const refreshGraphs = () => {

        setTriggerRefreshGraphs(prev => prev + 1);
    }

    useEffect(() => {

        if (entityType == "compliance-regulatorydocuments")
            loadRegulatoryDocumentsGraphs();

        if (entityType == "compliance-standards")
            loadStandardsGraphs();

        if (entityType == "submissions")
            loadSubmissionsGraphs();


    }, [triggerRefreshGraphs])



    const loadRegulatoryDocumentsGraphs = () => {

        setIsLoadingRegulatoryDocumentsGraphs(true);

        let search = itemSearchText;
        //let status = selectedFilterComplianceStatus;
        //let regulatoryArea = selectedFilterRegulatoryArea;
        //let publicationType = selectedFilterPublicationType;
        //let country = selectedFilterCountry;
        let legalManufacturerId = currentLegalManufacturerFilter;
        let rimsFilters = currentRIMSFilters;


        let tagIds = selectedTags.map((tag) => tag.Id).join(",");

        let graphsURL = "/umbraco/api/Compliance/RegulatoryDocumentsGraphs?" +

            `search=${encodeURIComponent(search)}&` +
            //`filter[status]=${encodeURIComponent(status)}&` +
            //`filter[regulatoryArea]=${encodeURIComponent(regulatoryArea)}&` +
            //`filter[publicationType]=${encodeURIComponent(publicationType)}&` +
            //`filter[country]=${encodeURIComponent(country)}&` +
            `tagIds=${encodeURIComponent(tagIds)}&` + 
            `archive=${encodeURIComponent(selectedFilterCMArchive)}&`;


            
        // Add column filters
        Object.keys(columnFilters).forEach((filter) => {
            if(columnFilters[filter] && columnFilters[filter] != "")
                graphsURL += `filter[${filter}]=${encodeURIComponent(columnFilters[filter])}&`;
        });


        // Add general default filters from url ONLY if not already present in columnFilters
        defaultFilters.forEach(({ key, value }) => {

            // Skip if columnFilters already contains this field
            if (Object.prototype.hasOwnProperty.call(columnFilters, key)) {
                return;
            }

            graphsURL += `filter[${key}]=${encodeURIComponent(value)}&`;
        });



        if (legalManufacturerId != -1) {
            graphsURL += `legalManufacturerId=${encodeURIComponent(legalManufacturerId)}&`;
        }

        if (rimsFilters) {
            graphsURL += `filter[products]=${encodeURIComponent(rimsFilters.products?.map(item => item.Id).join(",")) ?? ""}&`;
            graphsURL += `filter[productFamilies]=${encodeURIComponent(rimsFilters.productFamilies?.map(item => item.Id).join(",")) ?? ""}&`;
            graphsURL += `filter[countries]=${encodeURIComponent(rimsFilters.countries?.map(item => item.Id).join(",")) ?? ""}&`;
            graphsURL += `filter[certificates]=${encodeURIComponent(rimsFilters.certificates?.map(item => item.Id).join(",")) ?? ""}&`;
            graphsURL += `filter[operators]=${encodeURIComponent(rimsFilters.operators?.map(item => item.Id).join(",")) ?? ""}&`;
        }

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(graphsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                let baseOptions = {
                    chart: {
                        type: 'pie',
                        height: 200
                    },
                    title: {
                        text: '',
                        align: 'center',
                        style: { fontWeight: '500', fontSize: '14px', color: '#334155' }

                    },
                    credits: {
                        text: 'MedBoard.com',
                        href: 'https://www.medboard.com'
                    },
                    series: [
                        {
                            name: 'Count',
                            colorByPoint: true,
                            data: []
                        }
                    ],
                    responsive: {
                        rules: [{
                            condition: { maxWidth: 450 },
                            chartOptions: { legend: { enabled: false } }
                        }]
                    }
                };


                const mapOptions = {
                    chart: {
                        map: worldMap,
                        height: 200,
                    },
                    title: {
                        text: '',
                        align: 'center',
                        style: { fontWeight: '500', fontSize: '14px', color: '#334155' }

                    },
                    mapNavigation: {
                        enabled: true,
                        enableMouseWheelZoom: true
                    },
                    credits: {
                        enabled: true,
                        text: 'MedBoard.com',
                        href: 'https://www.medboard.com',
                        mapText: null
                    },
                    legend: {
                        enabled: false,
                    },
                    tooltip: {
                        pointFormat: '{point.name}: {point.value}'
                    },
                    colorAxis: {
                        min: 0,
                        stops: [
                            [0, '#cce0ff'],
                            [0.5, '#7cb5ec'],
                            [1, '#003399']
                        ]
                    },
                    series: [
                        {
                            name: "Count",
                            data: [],
                        },
                    ],
                };



                let countryOptions = JSON.parse(JSON.stringify(mapOptions));
                let regulatoryOptions = JSON.parse(JSON.stringify(baseOptions));
                let complianceStatusOptions = JSON.parse(JSON.stringify(baseOptions));

                // --- COUNTRIES MAP (Untouched) ---
                countryOptions.title.text = "Countries";
                const countryCounts = result.find(item => item.Name === "Country").Counts;

                const groupedData = countryCounts.reduce((acc, item) => {
                    const key = item.Code?.toLowerCase();
                    if (!key) return acc;

                    if (!acc[key]) {
                        acc[key] = {
                            "hc-key": key,
                            value: 0,
                            countryName: item.Name,
                            details: []
                        };
                    } else {
                        if (acc[key].countryName === 'European Union' && item.Name !== 'European Union') {
                            acc[key].countryName = item.Name;
                        }
                    }

                    acc[key].value += item.Count;

                    acc[key].details.push({
                        name: item.Name,
                        count: item.Count,
                        countryName: item.Name,
                        value: item.Count
                    });

                    return acc;
                }, {});

                countryOptions.series[0].data = Object.values(groupedData);
                countryOptions.tooltip = {
                    enabled: true,
                    useHTML: true,
                    formatter: function () {
                        if (!this.point) {
                            return '';
                        }
                        const pointTitle = this.point.countryName || this.point.name || this.key || 'Region';
                        const isSingleDetail = this.point.details && this.point.details.length === 1;

                        let tooltipHtml = '<span style="font-weight:600; font-size: 11px; padding-bottom:5px;">' + pointTitle + '</span><br/>';

                        if (this.point.details && this.point.details.length > 0) {
                            this.point.details.sort((a, b) => b.count - a.count).forEach(detail => {
                                const detailName = detail.name || '';
                                const isMatch = detailName.includes(pointTitle) || pointTitle.includes(detailName);
                                if (isSingleDetail && isMatch) {
                                    tooltipHtml += detail.count + ' documents<br/>';
                                } else {
                                    tooltipHtml += detail.name + ': ' + detail.count + ' documents<br/>';
                                }
                            });
                        } else if (this.point.value !== undefined) {
                            tooltipHtml += 'Total: ' + this.point.value;
                        }

                        return tooltipHtml;
                    }
                };

                // --- REGULATORY AREAS (Modern Pie Chart - No Text Labels) ---
                regulatoryOptions.title.text = "Regulatory Areas";
                regulatoryOptions.chart.type = 'pie';

                const regulatoryRawData = result.find((item) => item.Name === "Regulatory")?.Counts || [];
                regulatoryOptions.series = [{
                    name: "Documents",
                    colorByPoint: true,
                    data: regulatoryRawData
                        .map((item) => ({ name: item.Name, y: item.Count }))
                        .sort((a, b) => b.y - a.y)
                }];

                regulatoryOptions.tooltip = {
                    pointFormat: 'Count: <b>{point.y}</b><br/>Share: <b>{point.percentage:.1f}%</b>'
                };

                // Use a clean legend instead of spider lines
                regulatoryOptions.legend = {
                    enabled: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    y: 15,
                    maxHeight: 140,
                    itemMarginTop: 4,
                    itemMarginBottom: 3,
                    itemStyle: {
                        fontWeight: 'normal',
                        color: '#333'
                    }
                };

                regulatoryOptions.plotOptions = {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        borderWidth: 2,
                        borderColor: '#ffffff',
                        showInLegend: true, // Enables the legend to read from pie slices
                        dataLabels: {
                            enabled: false // Disables text and spider lines
                        }
                    }
                };


                // --- COMPLIANCE STATUS (Donut Chart - No Text Labels) ---
                complianceStatusOptions.title.text = "Compliance Status";
                if (!complianceStatusOptions.chart) complianceStatusOptions.chart = {};
                complianceStatusOptions.chart.type = 'pie';

                const complianceRawData = result.find((item) => item.Name === "RegulatoryDocuments")?.StatusCount || [];
                complianceStatusOptions.series = [{
                    name: "Status",
                    innerSize: '65%',
                    data: complianceRawData
                        .filter((item) => item.Count > 0)
                        .map((item) => {
                            const statusMatch = Constants.ComplianceStatuses.find(x => x.id === item.Status);
                            return {
                                name: statusMatch ? statusMatch.name : `Unknown (${item.Status})`,
                                y: item.Count,
                                color: statusMatch ? statusMatch.bgColor : '#cccccc'
                            };
                        })
                }];

                complianceStatusOptions.tooltip = {
                    pointFormat: 'Count: <b>{point.y}</b><br/>Share: <b>{point.percentage:.1f}%</b>'
                };

                complianceStatusOptions.legend = {
                    enabled: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    y: 15,
                    maxHeight: 140,
                    itemMarginTop: 4,
                    itemMarginBottom: 3,
                    itemStyle: {
                        fontWeight: 'normal',
                        color: '#333'
                    }
                };

                complianceStatusOptions.plotOptions = {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        borderWidth: 2,
                        borderColor: '#ffffff',
                        showInLegend: true,
                        dataLabels: {
                            enabled: false
                        }
                    }
                };
                
                setRegDocsGraphOptionsForCountry(countryOptions);
                setRegDocsGraphOptionsForRegulatory(regulatoryOptions);
                setRegDocsGraphOptionsForComplianceStatus(complianceStatusOptions);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoadingRegulatoryDocumentsGraphs(false);
            });


    }

    const loadStandardsGraphs = () => {

        setIsLoadingStandardsGraphs(true);

        let search = itemSearchText;
        //let status = selectedFilterComplianceStatus;
        //let regulatoryArea = selectedFilterRegulatoryArea;
        //let country = selectedFilterCountry;
        let legalManufacturerId = currentLegalManufacturerFilter;
        let rimsFilters = currentRIMSFilters;

        let tagIds = selectedTags.map((tag) => tag.Id).join(",");

        let graphsURL = "/umbraco/api/Compliance/StandardsGraphs?" +
            `search=${encodeURIComponent(search)}&` +
            //`filter[status]=${encodeURIComponent(status)}&` +
            //`filter[regulatoryArea]=${encodeURIComponent(regulatoryArea)}&` +
            //`filter[country]=${encodeURIComponent(country)}&` +
            `tagIds=${encodeURIComponent(tagIds)}&` +
            `archive=${encodeURIComponent(selectedFilterCMArchive)}&`;

        // Add column filters
        Object.keys(columnFilters).forEach((filter) => {
            if (columnFilters[filter] && columnFilters[filter] != "")
                graphsURL += `filter[${filter}]=${encodeURIComponent(columnFilters[filter])}&`;
        });

        // Add general default filters from url ONLY if not already present in columnFilters
        defaultFilters.forEach(({ key, value }) => {
            // Skip if columnFilters already contains this field
            if (Object.prototype.hasOwnProperty.call(columnFilters, key)) {
                return;
            }
            graphsURL += `filter[${key}]=${encodeURIComponent(value)}&`;
        });

        if (legalManufacturerId != -1) {
            graphsURL += `legalManufacturerId=${encodeURIComponent(legalManufacturerId)}&`;
        }

        if (rimsFilters) {
            graphsURL += `filter[products]=${encodeURIComponent(rimsFilters.products?.map(item => item.Id).join(",")) ?? ""}&`;
            graphsURL += `filter[productFamilies]=${encodeURIComponent(rimsFilters.productFamilies?.map(item => item.Id).join(",")) ?? ""}&`;
            graphsURL += `filter[countries]=${encodeURIComponent(rimsFilters.countries?.map(item => item.Id).join(",")) ?? ""}&`;
            graphsURL += `filter[certificates]=${encodeURIComponent(rimsFilters.certificates?.map(item => item.Id).join(",")) ?? ""}&`;
            graphsURL += `filter[operators]=${encodeURIComponent(rimsFilters.operators?.map(item => item.Id).join(",")) ?? ""}&`;
        }

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(graphsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                // --- Base Options for Pie/Donut Charts ---
                let baseOptions = {
                    chart: {
                        type: 'pie',
                        height: 200,
                        backgroundColor: 'transparent',
                        style: { fontFamily: 'inherit' }
                    },
                    title: {
                        text: '',
                        align: 'center',
                        style: { fontWeight: '500', fontSize: '14px', color: '#334155' }
                    },
                    credits: {
                        enabled: false
                    },
                    tooltip: {
                        pointFormat: 'Count: <b>{point.y}</b><br/>Share: <b>{point.percentage:.1f}%</b>',
                        backgroundColor: '#ffffff',
                        borderColor: '#e2e8f0',
                        borderRadius: 8,
                        padding: 10,
                        shadow: { color: 'rgba(0, 0, 0, 0.1)', offsetX: 0, offsetY: 4, width: 10 }
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            borderWidth: 2,
                            borderColor: '#ffffff',
                            showInLegend: true, // Enables the legend to read from pie slices
                            dataLabels: {
                                enabled: false // Disables text and spider lines
                            },
                            states: {
                                hover: { halo: { size: 7, attributes: { fillOpacity: 0.1 } } }
                            }
                        }
                    },
                    legend: {
                        enabled: true,
                        layout: 'vertical',
                        align: 'right',
                        verticalAlign: 'middle',
                        itemMarginTop: 3,
                        itemMarginBottom: 3,
                        itemStyle: { fontWeight: 'normal', color: '#333', textOverflow: 'ellipsis' }
                    },
                    responsive: {
                        rules: [{
                            condition: { maxWidth: 450 },
                            chartOptions: { legend: { enabled: false } }
                        }]
                    }
                };

                let complianceStatusOptions = JSON.parse(JSON.stringify(baseOptions));
                let sourcesOptions = JSON.parse(JSON.stringify(baseOptions));

                // --- COMPLIANCE STATUS (Donut Chart) ---
                complianceStatusOptions.title.text = "Compliance Status";
                const complianceRawData = result.find((item) => item.Name === "Standards")?.StatusCount || [];

                complianceStatusOptions.series = [{
                    name: "Status",
                    innerSize: '65%', // Creates the donut shape
                    data: complianceRawData
                        .filter((item) => item.Count > 0)
                        .map((item) => {
                            const statusMatch = Constants.ComplianceStatuses.find(x => x.id == item.Status);
                            return {
                                name: statusMatch ? statusMatch.name : `Unknown (${item.Status})`,
                                y: item.Count,
                                color: statusMatch ? statusMatch.bgColor : '#cccccc'
                            };
                        })
                        .sort((a, b) => b.y - a.y) // Optional: sorts largest slices first
                }];


                // --- SOURCES (Pie Chart) ---
                sourcesOptions.title.text = "Sources";
                const sourcesRawData = result.find((item) => item.Name === "Sources")?.Counts || [];

                sourcesOptions.series = [{
                    name: "Sources",
                    colorByPoint: true,
                    data: sourcesRawData
                        .map((item) => ({
                            name: item.Name,
                            y: item.Count
                        }))
                        .sort((a, b) => b.y - a.y) // Optional: sorts largest slices first
                }];

                // Set states
                setStandardsGraphOptionsForComplianceStatus(complianceStatusOptions);
                setStandardsGraphOptionsForSource(sourcesOptions);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoadingStandardsGraphs(false);
            });
    }

    const loadSubmissionsGraphs = async () => {
        setIsLoadingSubmissionsGraphs(true);

        try {
            const params = new URLSearchParams({
                search: itemSearchText || "",
                "filter[status]": selectedFilterSubmissionsStatus || "",
                "filter[type]": selectedFilterSubmissionsType || "",
                "filter[country]": selectedFilterCountry || "",
                tagIds: selectedTags.map((tag) => tag.Id).join(","),
                open: selectedFilterSubmissionsOpen || ""
            });

            if (currentLegalManufacturerFilter) {
                params.append("legalManufacturerId", currentLegalManufacturerFilter);
            }
            if (certificateId) {
                params.append("filter[certificateId]", certificateId);
            }

            const graphsURL = `/umbraco/api/Submission/SubmissionsGraphs?${params.toString()}`;

            const response = await fetch(graphsURL, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });

            if (!response.ok) {
                if (response.status === 401) {
                    document.dispatchEvent(new Event("api:unauthorized"));
                }
                throw new Error("Network response was not ok");
            }

            const result = await response.json();

            // --- Base Options for Pie/Donut Charts ---
            let baseOptions = {
                chart: {
                    type: 'pie',
                    height: 200,
                    backgroundColor: 'transparent',
                    style: { fontFamily: 'inherit' }
                },
                title: {
                    text: '',
                    align: 'center',
                    style: { fontWeight: '500', fontSize: '14px', color: '#334155' }
                },
                credits: { enabled: false },
                tooltip: {
                    pointFormat: 'Count: <b>{point.y}</b><br/>Share: <b>{point.percentage:.1f}%</b>',
                    backgroundColor: '#ffffff',
                    borderColor: '#e2e8f0',
                    borderRadius: 8,
                    padding: 10,
                    shadow: { color: 'rgba(0, 0, 0, 0.1)', offsetX: 0, offsetY: 4, width: 10 }
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        borderWidth: 2,
                        borderColor: '#ffffff',
                        showInLegend: true,
                        dataLabels: { enabled: false },
                        states: {
                            hover: { halo: { size: 7, attributes: { fillOpacity: 0.1 } } }
                        }
                    }
                },
                legend: {
                    enabled: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemMarginTop: 3,
                    itemMarginBottom: 3,
                    itemStyle: { fontWeight: 'normal', color: '#333', textOverflow: 'ellipsis' }
                },
                responsive: {
                    rules: [{
                        condition: { maxWidth: 450 },
                        chartOptions: { legend: { enabled: false } }
                    }]
                }
            };

            // --- Base Options for Map Chart ---
            const mapOptions = {
                chart: {
                    map: worldMap,
                    height: 200,
                },
                title: {
                    text: '',
                    align: 'center',
                    style: { fontWeight: '500', fontSize: '14px', color: '#334155' }
                },
                mapNavigation: {
                    enabled: true,
                    enableMouseWheelZoom: true
                },
                credits: {
                    enabled: true,
                    text: 'MedBoard.com',
                    href: 'https://www.medboard.com',
                    mapText: null
                },
                legend: {
                    enabled: false,
                },
                tooltip: {
                    pointFormat: '{point.name}: {point.value}'
                },
                colorAxis: {
                    min: 0,
                    stops: [
                        [0, '#cce0ff'],
                        [0.5, '#7cb5ec'],
                        [1, '#003399']
                    ]
                },
                series: [
                    {
                        name: "Count",
                        data: [],
                    },
                ],
            };

            let countryOptions = JSON.parse(JSON.stringify(mapOptions));
            let typeOptions = JSON.parse(JSON.stringify(baseOptions));
            let statusOptions = JSON.parse(JSON.stringify(baseOptions));

            // --- COUNTRIES MAP ---

            countryOptions.chart.map = worldMap;

            countryOptions.chart.map = worldMap;
            countryOptions.series[0].mapData = worldMap;

            // 2. Define the series type and rendering rules
            countryOptions.series[0].type = 'map';
            countryOptions.series[0].allAreas = true; // Ensures the entire world map draws, even if countries have 0 submissions
            countryOptions.series[0].joinBy = 'hc-key'; // Explicitly tells Highcharts to match your data's "hc-key" to the map's geometry

            // 3. Add the missing title
            countryOptions.title.text = "Countries";
            const countryCounts = result.find(item => item.Name === "Country")?.Counts || [];

            const groupedData = countryCounts.reduce((acc, item) => {
                const key = item.Code?.toLowerCase();
                if (!key) return acc;

                if (!acc[key]) {
                    acc[key] = {
                        "hc-key": key,
                        value: 0,
                        countryName: item.Name,
                        details: []
                    };
                } else {
                    if (acc[key].countryName === 'European Union' && item.Name !== 'European Union') {
                        acc[key].countryName = item.Name;
                    }
                }

                acc[key].value += item.Count;
                acc[key].details.push({
                    name: item.Name,
                    count: item.Count,
                    countryName: item.Name,
                    value: item.Count
                });

                return acc;
            }, {});

            countryOptions.series[0].data = Object.values(groupedData);

            countryOptions.tooltip = {
                enabled: true,
                useHTML: true,
                formatter: function () {
                    if (!this.point) {
                        return '';
                    }
                    const pointTitle = this.point.countryName || this.point.name || this.key || 'Region';
                    const isSingleDetail = this.point.details && this.point.details.length === 1;

                    let tooltipHtml = '<span style="font-weight:600; font-size: 11px; padding-bottom:5px;">' + pointTitle + '</span><br/>';

                    if (this.point.details && this.point.details.length > 0) {
                        this.point.details.sort((a, b) => b.count - a.count).forEach(detail => {
                            const detailName = detail.name || '';
                            const isMatch = detailName.includes(pointTitle) || pointTitle.includes(detailName);
                            if (isSingleDetail && isMatch) {
                                tooltipHtml += detail.count + ' submissions<br/>';
                            } else {
                                tooltipHtml += detail.name + ': ' + detail.count + ' submissions<br/>';
                            }
                        });
                    } else if (this.point.value !== undefined) {
                        tooltipHtml += 'Total: ' + this.point.value;
                    }

                    return tooltipHtml;
                }
            };

            // --- SUBMISSIONS TYPES (Pie Chart) ---
            typeOptions.title.text = "Submissions Types";
            const typeRawData = result.find((item) => item.Name === "Type")?.Counts || [];
            typeOptions.series = [{
                name: "Count",
                // innerSize: '65%', <-- NOT DONUT
                colorByPoint: true,
                data: typeRawData
                    .filter(item => item.Count > 0)
                    .map(item => ({
                        name: item.Name,
                        y: item.Count,
                        color: Constants.SubmissionsTypes.find(x => x.name === item.Name)?.bgColor
                    }))
                    .sort((a, b) => b.y - a.y)
            }];

            // --- SUBMISSIONS STATUS (Donut Chart) ---
            statusOptions.title.text = "Submissions Status";
            const statusRawData = result.find((item) => item.Name === "Status")?.Counts || [];
            statusOptions.series = [{
                name: "Status",
                innerSize: '65%',
                data: statusRawData
                    .filter(item => item.Count > 0)
                    .map(item => ({
                        name: item.Name,
                        y: item.Count,
                        color: Constants.SubmissionsStatuses.find(x => x.name === item.Name)?.bgColor
                    }))
                    .sort((a, b) => b.y - a.y)
            }];

            // Apply Setters
            setSubmissionsGraphOptionsForCountry(countryOptions);
            setSubmissionsGraphOptionsForType(typeOptions);
            setSubmissionsGraphOptionsForStatus(statusOptions);

        } catch (error) {
            console.error("Error loading submission graphs:", error);
        } finally {
            setIsLoadingSubmissionsGraphs(false);
        }
    };











    const handleMainListSelect = (event) => {
        const value = parseInt(event.target.value);
        const isExpandable = !!dataTableStructure.expandable;
        const loadedChildIds = isExpandable
            ? (childRowsByParent[value] || []).map((child) => child.Id)
            : [];

        if (event.target.checked) {
            // Parent + any already-loaded children (even if the row is collapsed)
            const next = new Set(selectedReferences);
            next.add(value);
            loadedChildIds.forEach((id) => next.add(id));
            setSelectedReferences([...next]);
        } else {
            // Always clear loaded children with the parent, even if the row is collapsed
            const removeIds = new Set([value, ...loadedChildIds]);
            setSelectedReferences(selectedReferences.filter((item) => !removeIds.has(item)));
        }

    };



    const handleSelectAllReferences = (event) => {

        if (event.target.checked) {
            // Get and select all references
            loadData({ nextPage: true, returnAll: true, selectAll: true });

        } else {
            // Deselect all references
            setAllReferencesSelected(false);
            setSelectedReferences([]);
        }

    }










    const closeAllPopups = () => {


        // Close add task in case it's opened
        showAddItemPopup(false);

        // Hide delete confirmation if visible
        setIsShowingDeleteConfirmation(false);

        // Export selected references popup
        setShowExportSelectedReferencesPopup(false);
        setEudamedXmlError(null);

        // Delete selected references popup
        setShowDeleteSelectedReferencesPopup(false);

        // Hide timeline graph is visible
        setShowTimelineGraphPopup(false);

        // Export country registrations all references popup
        setShowCountryRegistrationsExportAllReferencesPopup(false);

        // Delete country registrations all references popup
        setShowCountryRegistrationsDeleteAllReferencesPopup(false);


    }






    const deleteSelectedItems = () => {


        let itemIds = selectedReferences ? selectedReferences.join(",") : "";

        let deleteItemsURL = deleteUrl + itemIds;

        setIsDeleting(true);
        setErrorDeleting(false);
        setSuccessDeleting(false);

        let requestOptions = {
            method: "DELETE",
        };


        fetch(deleteItemsURL, requestOptions)
            .then(async (response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    // There was a server error, is it readable?
                    if (response.status === 400) {
                        try {
                            let errorObject = await response.json();
                            setErrorMessageObject(errorObject);
                            setShowErrorMessagePopup(true);
                        }
                        catch (ex) { }
                    }

                    setErrorDeleting(true);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Status == 1) {
                    setData(prev => prev.filter(item => !itemIds.includes(item.Id)));
                    setSuccessDeleting(true);
                    updateListTotalCount();
                    setSelectedReferences([]);
                }
                else {
                    setIsDeleting(false);

                    setErrorMessageObject(result);
                    setShowErrorMessagePopup(true);

                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsDeleting(false);
            });

    }








    const exportReferences = (type) => {

        let referenceIds = selectedReferences ? selectedReferences.join(",") : "";

        let exportReferencesURL = exportUrl + referenceIds;

        setIsExporting(true);
        setErrorExporting(false);
        setSuccessExporting(false);

        let requestOptions = {
            method: "GET",
        };

        if (type == "excel") {
            requestOptions["headers"] = { 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };
        }

        if (type == "excel-with-legal") {
            exportReferencesURL = exportReferencesURL + "&withLegal=true";
            requestOptions["headers"] = { 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };
        }

        fetch(exportReferencesURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setErrorDeleting(true);
                    throw new Error("Network response was not ok");
                }
                return response;
            })
            .then((data) => {

                data.blob().then((blob) => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    if (type == "excel") a.download = excelExportFileName ? excelExportFileName + '.xlsx' : 'MedboardExport.xlsx';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);

                });

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsExporting(false);
            });

    }

    const exportEudamedXml = (service) => {

        if (!selectedReferences || selectedReferences.length === 0) {
            setEudamedXmlError("Select at least one product first.");
            return;
        }

        setIsExporting(true);
        setEudamedXmlError(null);
        setEudamedXmlWarning(null);
        setEudamedXmlSuccess(null);

        downloadEudamedXmlFile(service.url + selectedReferences.join(","), service.filename)
            .then((result) => {
                const warning = describeDownloadWarnings(result);
                if (warning)
                    setEudamedXmlWarning(warning);
            })
            .catch((error) => {
                setEudamedXmlError(error.message);
            })
            .finally(() => {
                setIsExporting(false);
            });

    }

    // Generates the selected service's XML server-side and submits it straight to EUDAMED
    // (SubmitEudamedXml re-validates the company SRN and the module's security key). Not
    // available for zip-producing services - those are download-only.
    const sendEudamedXmlToEudamed = (service) => {

        if (window.enableEUDAMED !== true)
            return;

        if (!selectedReferences || selectedReferences.length === 0) {
            setEudamedXmlError("Select at least one product first.");
            return;
        }

        setIsExporting(true);
        setEudamedXmlError(null);
        setEudamedXmlWarning(null);
        setEudamedXmlSuccess(null);

        sendEudamedXml(service.url + selectedReferences.join(","))
            .then(() => {
                setEudamedXmlSuccess("Sent to EUDAMED successfully.");
            })
            .catch((error) => {
                setEudamedXmlError(error.message);
            })
            .finally(() => {
                setIsExporting(false);
            });

    }





    const updateProductsCount = (search = "", archived = false) => {


        setIsUpdatingProductsCount(true);

        const hasColumnFilters = Object.keys(columnFilters).some((key) => columnFilters[key] && columnFilters[key] != "");

        let countsURL = `/umbraco/api/RIMSProducts/ProductCount?archived=${String(archived)}&${search != "" ? "search=" + search + "&" : ""}`;


        countsURL += "legalManufacturerId=" + currentLegalManufacturerFilter + "&";


        Object.keys(columnFilters).forEach((key) => {
            if (columnFilters[key] && columnFilters[key] != "")
                countsURL += `filter[${key}]=${encodeURIComponent(columnFilters[key])}&`;
        });
        defaultFilters.forEach(({ key, value }) => {
            if (Object.prototype.hasOwnProperty.call(columnFilters, key)) return;
            countsURL += `filter[${key}]=${encodeURIComponent(value)}&`;
        });


        let requestOptions = {
            method: "GET",
        };

        fetch(countsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (search == "" && !hasColumnFilters) {
                    setProductsCount(result);
                    setFilteredProductsCount(null);
                }
                else
                    setFilteredProductsCount(result);
            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsUpdatingProductsCount(false);
            });


    }






    const updateRegulatoryDocumentsCounts = () => {

        setUpdatingTotalCounts(true);

        let search = itemSearchText;
        //let status = selectedFilterComplianceStatus;
        //let regulatoryArea = selectedFilterRegulatoryArea;
        //let publicationType = selectedFilterPublicationType;
        //let country = selectedFilterCountry;
        let legalManufacturerId = currentLegalManufacturerFilter;
        let rimsFilters = currentRIMSFilters;

        let countsURL = "/umbraco/api/Compliance/Counts?" +

            `complianceType=${encodeURIComponent(ComplianceType)}&` +
            `search=${encodeURIComponent(search)}&` +
            `archive=${encodeURIComponent(selectedFilterCMArchive)}&`;
            //`filter[status]=${encodeURIComponent(status)}&` +
            //`filter[regulatoryArea]=${encodeURIComponent(regulatoryArea)}&` +
            //`filter[publicationType]=${encodeURIComponent(publicationType)}&` +
            //`filter[country]=${encodeURIComponent(country)}&`;


        
        // Add column filters
        Object.keys(columnFilters).forEach((filter) => {
            if(columnFilters[filter] && columnFilters[filter] != "")
                countsURL += `filter[${filter}]=${encodeURIComponent(columnFilters[filter])}&`;
        });


        // Add general default filters from url ONLY if not already present in columnFilters
        defaultFilters.forEach(({ key, value }) => {

            // Skip if columnFilters already contains this field
            if (Object.prototype.hasOwnProperty.call(columnFilters, key)) {
                return;
            }

            countsURL += `filter[${key}]=${encodeURIComponent(value)}&`;
        });


        if (legalManufacturerId != -1) {
            countsURL += `legalManufacturerId=${encodeURIComponent(legalManufacturerId)}&`;
        }

        if (rimsFilters) {
            countsURL += `filter[products]=${encodeURIComponent(rimsFilters.products?.map(item => item.Id).join(",")) ?? ""}&`;
            countsURL += `filter[productFamilies]=${encodeURIComponent(rimsFilters.productFamilies?.map(item => item.Id).join(",")) ?? ""}&`;
            countsURL += `filter[countries]=${encodeURIComponent(rimsFilters.countries?.map(item => item.Id).join(",")) ?? ""}&`;
            countsURL += `filter[certificates]=${encodeURIComponent(rimsFilters.certificates?.map(item => item.Id).join(",")) ?? ""}&`;
            countsURL += `filter[operators]=${encodeURIComponent(rimsFilters.operators?.map(item => item.Id).join(",")) ?? ""}&`;

        }



        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(countsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                setAbsoluteTotalCount(result.TotalCount);
                setFilteredTotalCount(result.FilteredCount);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setUpdatingTotalCounts(false);
            });


    }

    

    const getUserById = (id) => {
        return users.find((item) => item.Id == id);
    };




    const readableDate = (inputDate, showYear = false) => {

        if (inputDate == null || inputDate == "")
            return "<no date>";

        //const options = { year: 'numeric', month: 'short', day: 'numeric' };
        //return new Date(inputDate).toLocaleDateString(undefined, options);
        const date = new Date(inputDate);
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]; // To always be in English, not locale dependant
        const month = monthNames[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();
        return `${day} ${month}` + (showYear ? ` ${year}` : ``);
    }


    const readableDateUTC = (inputDate, showYear = false) => {

        if (inputDate == null || inputDate == "")
            return "<no date>";

        //const options = { year: 'numeric', month: 'short', day: 'numeric' };
        //return new Date(inputDate).toLocaleDateString(undefined, options);
        const date = new Date(inputDate);
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]; // To always be in English, not locale dependant
        const month = monthNames[date.getUTCMonth()];
        const day = date.getUTCDate();
        const year = date.getUTCFullYear();
        return `${day} ${month}` + (showYear ? ` ${year}` : ``);
    }



    /*
    Convert: Wed Aug 30 2023 00:00:00 GMT+0100 (Western European Summer Time) 
    To: 2023-08-30
    */

    const formatDate = (dateStr, includeTime = false) => {

        if (dateStr == null || dateStr == "")
            return "";

        const dateObj = new Date(dateStr);
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Month is zero-indexed
        const day = String(dateObj.getDate()).padStart(2, "0");

        let time = "";
        if (includeTime) {
            let hours = (dateObj.getHours() < 10 ? '0' : '') + dateObj.getHours();
            let minutes = (dateObj.getMinutes() < 10 ? '0' : '') + dateObj.getMinutes();

            time = ` ${hours}:${minutes}`;
        }

        const formattedDate = `${year}-${month}-${day}${time}`;
        return formattedDate;
    };


    /*
    Convert: 2023-08-30
    To: Wed Aug 30 2023 00:00:00 GMT+0100 (Western European Summer Time) 
    */

    const unformatDate = (dateStr) => {

        if (dateStr == null || dateStr == "")
            return "";

        const parts = dateStr.split("-");
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Month is zero-indexed
        const day = parseInt(parts[2], 10);
        const dateObject = new Date(year, month, day);

        return dateObject;
    };



    /*
    Returns the priority object with the requested id
    */
    const getSubmissionPriorityById = (id) => {
        return submissionPriorities.find((item) => item.id == id);
    };

    const SubmissionPriority = ({ value, size }) => {
        let bgcolor = "";
        let color = "white";

        value = parseInt(value);

        switch (value) {
            case 1:
                bgcolor = "#d1153a";
                break;
            case 2:
                bgcolor = "#f7b204";
                break;
            case 3:
                bgcolor = "#48ca94";
                break;
            case 4:
                bgcolor = "#f0f0f0";
                color = "#333";
                break;
            default:
                break;
        }

        let padding = "5px";
        let width = "100px";

        if (size == "small") {
            padding = "2px";
            width = "70px";
        }

        return (
            <>
                <div
                    style={{
                        padding: padding,
                        borderRadius: "5px",
                        textAlign: "center",
                        color: color,
                        width: width,
                        backgroundColor: bgcolor
                    }}
                >
                    {getSubmissionPriorityById(value)?.name}
                </div>
            </>
        );
    };









    /*
    Returns the priority object with the requested id
    */
    const getSubmissionTypeById = (id) => {
        return submissionTypes.find((item) => item.id == id);
    };

    const SubmissionType = ({ value, size }) => {
        let bgcolor = "#dedede";
        let color = "white";

        value = parseInt(value);

        let colorInfo = Constants.SubmissionsTypes.find(x => x.id == value);

        if (colorInfo != undefined) {
            bgcolor = colorInfo.bgColor;
            color = colorInfo.textColor;
        }

        let padding = "5px";
        let width = "100px";

        if (size == "small") {
            padding = "2px";
            width = "70px";
        }

        return (
            <>
                <div
                    style={{
                        padding: padding,
                        borderRadius: "5px",
                        textAlign: "center",
                        color: color,
                        width: width,
                        backgroundColor: bgcolor
                    }}
                >
                    {getSubmissionTypeById(value)?.name}
                </div>
            </>
        );
    };













    const getSubmissionStatusById = (id) => {
        return submissionPossibleStatuses.find((item) => item.id == id);
    };


    const SubmissionStatus = ({ value, size }) => {
        let bgcolor = "";
        let color = "white";

        value = parseInt(value);

        switch (value) {
            case 0:
                bgcolor = "#9dc3e6";
                color = "#333";
                break;
            case 1:
                bgcolor = "#2e75b6";
                break;
            case 2:
                bgcolor = "#ffc000";
                color = "#333";
                break;
            case 3:
                bgcolor = "#548235";
                break;
            default:
                break;
        }

        let padding = "5px";
        let width = "100px";

        if (size == "small") {
            padding = "2px";
            width = "70px";
        }

        return (
            <>
                <div
                    style={{
                        padding: padding,
                        borderRadius: "5px",
                        textAlign: "center",
                        color: color,
                        width: width,
                        backgroundColor: bgcolor
                    }}
                >
                    {getSubmissionStatusById(value)?.name}
                </div>
            </>
        );
    };




    



    const clearAllFilters = () => {

        setSelectedFilterComplianceStatus("");
        setSelectedFilterCountry("");
        setSelectedFilterRegulatoryArea("");
        setSelectedFilterPublicationType("");
        setSelectedFilterSubmissionsStatus("");
        setSelectedFilterSubmissionsType("");
        setItemSearchText("");

        setIsChoosingComplianceStatusFilter(false);
        setIsChoosingCountryFilter(false);
        setIsChoosingRegulatoryAreaFilter(false);
        setIsChoosingPublicationTypeFilter(false);
        setIsChoosingSubmissionsStatusFilter(false);
        setIsChoosingSubmissionsTypeFilter(false);

        refreshData();
        refreshGraphs();
    }





    const handleSystematicReviewMenuOptionClick = (section) => {

        setSelectedFilterSystematicReviewsSection(section);
        loadData({ localFilterSystematicReviewsSection: section });
        loadSystematicReviewHeader(section);

    }




    const loadLegalManufacturers = () => {


        let legalManufacturerRoleId = 1;

        let countsURL = "/umbraco/api/ProductRegistrationsApi/CompanyOperators?" +
            `search=&` + 
            `roleId=${encodeURIComponent(legalManufacturerRoleId)}&`;

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsLoadingLegalManufacturers(true);

        fetch(countsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                setLegalManufacturers(result);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoadingLegalManufacturers(false);
            });

    }





    const callbackUpdateTriggerTagFilter = () => {

        setTagFilterUpdateTrigger(tagFilterUpdateTrigger+1);

    }






    const contentParentRef = useRef(null);
    const [contentParentwidth, setContentParentWidth] = useState(0);



    
    useLayoutEffect(() => {

        if (!contentParentRef.current) return;

        const observer = new ResizeObserver(entries => {
            const entry = entries[0];
            setContentParentWidth(entry.contentRect.width);
        });

        observer.observe(contentParentRef.current);

        return () => observer.disconnect();

    }, []);


        



    const rimsSearchCallback = (filters) => {

        //console.log("apply filters " + filters);

        setCurrentRIMSFilters(filters);

        refreshData();
        refreshGraphs();

    }


    const selectAllReferences = (currentReferences) => {

        setAllReferencesSelected(true);
        const ids = new Set((currentReferences || []).map((r) => r.Id));

        // Expandable tables (Task Manager): also select visible/loaded subtasks.
        if (dataTableStructure.expandable) {
            (currentReferences || []).forEach((row) => {
                (row.MatchedSubtasks || []).forEach((child) => ids.add(child.Id));
            });
            Object.values(childRowsByParent || {}).forEach((children) => {
                (children || []).forEach((child) => ids.add(child.Id));
            });
        }

        setSelectedReferences([...ids]);

    }


    const columnFilterCallBack = ({ field, values }) => {

        console.log("called column filter callback", field, values);


        setColumnFilters(prev => ({...prev, [field]: values }));

        refreshData();
        refreshGraphs();

    }

    const selectChildrenIfParentSelected = (parentId, children) => {
        if (!Array.isArray(children) || children.length === 0)
            return;
        setSelectedReferences((prev) => {
            if (!prev.includes(parentId))
                return prev;
            const next = new Set(prev);
            children.forEach((child) => next.add(child.Id));
            return [...next];
        });
    };

    const toggleExpandedRow = (row) => {
        const parentId = row.Id;
        if (expandedRowIds.includes(parentId)) {
            setExpandedRowIds(expandedRowIds.filter((id) => id != parentId));
            return;
        }

        setExpandedRowIds([...expandedRowIds, parentId]);
        if (childRowsByParent[parentId]) {
            selectChildrenIfParentSelected(parentId, childRowsByParent[parentId]);
            return;
        }

        setLoadingChildId(parentId);
        const params =
            `search=&` +
            `sortBy=${encodeURIComponent(dataSortByField)}&` +
            `sortType=${encodeURIComponent(dataSortByType)}&` +
            `page=1&` +
            `assignedTo=Company&` +
            `completionStatus=All&` +
            `parentTaskId=${encodeURIComponent(parentId)}&` +
            `linkedEntityType=&linkedEntityId=`;

        fetch(`${dataUrl}?${params}`)
            .then((response) => {
                if (!response.ok)
                    throw new Error("Network response was not ok");
                return response.json();
            })
            .then((result) => {
                const children = Array.isArray(result) ? result : [];
                setChildRowsByParent((prev) => ({ ...prev, [parentId]: children }));
                selectChildrenIfParentSelected(parentId, children);
            })
            .catch(() => {
                setChildRowsByParent((prev) => ({ ...prev, [parentId]: [] }));
            })
            .finally(() => {
                setLoadingChildId(null);
            });
    }


    const columnFilterLoadFilterOptions = async (field) => {

        try {

            let filtersUrl = `/umbraco/api/Filters/Filters/?entityTypeId=${entityTypeId}&field=${field}&`;


            if (currentLegalManufacturerFilter)
                filtersUrl += `legalManufacturerSessionFilter=${currentLegalManufacturerFilter}&`;

            // Scope product option lists to the Active/Archived tab.
            if (entityType == "product-skus")
                filtersUrl += `archived=${encodeURIComponent(selectedFilterProductsArchive)}&`;


            // Narrow this column's option list by every OTHER column's active filter (cascading).
            Object.keys(columnFilters).forEach((key) => {
                if (key === field) return;
                if (columnFilters[key] && columnFilters[key] != "")
                    filtersUrl += `filter[${key}]=${encodeURIComponent(columnFilters[key])}&`;
            });


            // Narrow this column's option list by every OTHER column's active filter
            Object.keys(columnFilters).forEach((key) => {
                if (key === field) return;
                if (columnFilters[key] && columnFilters[key] != "")
                    filtersUrl += `filter[${key}]=${encodeURIComponent(columnFilters[key])}&`;
            });


            // Add general default filters from url, unless a column filter already covers that key
            if (Array.isArray(defaultFilters)) {
                defaultFilters.forEach(({ key, value }) => {
                    if (Object.prototype.hasOwnProperty.call(columnFilters, key)) return;
                    filtersUrl += `filter[${key}]=${encodeURIComponent(value)}&`;
                });
            }


            //&countryId=

            let requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            };

            const response = await fetch(filtersUrl, requestOptions);

            if (!response.ok) {
                if (response.status === 401) {
                    document.dispatchEvent(new Event("api:unauthorized"));
                }

                throw new Error(`Request failed with status ${response.status}`);
            }

                    // DUMMY 
                    //let result = [
                    //        { value: 1, label: "OP1 " + field },
                    //        { value: 2, label: "OP2 " + field }
                    //];
                    //return result;


            return await response.json();

        } catch (error) {
            console.error("Fetch error:", error);
            throw error;
        }
        


    }


    const closeErrorMessagePopup = () => {
        setShowErrorMessagePopup(false);
        setErrorMessageObject(null);
    }
    




    
    const hideTaskManagerPopup = () => {

        setIsShowingTaskManagerPopup(false);

        // Reload task count here
        updateTaskCount();

    }




    const updateTaskCount = () => {
        let url = "/umbraco/api/TaskManagerApi/Summary/?entityType=" + entityType;

        if (countryFilterId != null)
            url = "/umbraco/api/TaskManagerApi/Summary/?entityType=countryregistration-country&entityId=" + countryFilterId;

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {
                if (result.length) {

                    setTaskCount(result.find(r => r.TaskFor == "Company")?.Total);
                }
            })
            .catch((error) => {
                console.log("error: " + error);
            })
            .finally(() => {
            });
    }


    const openTaskManagerForEntity = () => {

        let baseUrl = "";

        switch (entityType) {
            case "compliance-standards":
            case "compliance-regulatorydocuments":
            case "compliance-qms":
            case "compliance-technical-documents": baseUrl = "/your-medboard/compliance-portfolio/compliancetaskmanager/?entityType=" + entityType; break;
            case "countryregistration-certificate":
            case "countryregistration-operator": baseUrl = "/your-medboard/country-registrations/country-registrations-task-manager/?entityType=" + entityType; break;
            case "product-family":
            case "product-skus": baseUrl = "/your-medboard/product-portfolio/product-portfolio-task-manager/?entityType=" + entityType; break;
            case "countryregistrations":
                baseUrl = "/your-medboard/country-registrations/country-registrations-task-manager/?entityType=countryregistration-country&entityId=" + countryFilterId;
                break;

            default: break;
        }

        if(baseUrl != "")
            window.location.href = baseUrl;

    }




    /* List of functions and elements available in the app context */
    let globalContext = {};
    globalContext.dataTableStructure = dataTableStructure;
    globalContext.pageTitle = pageTitle;
    globalContext.breadcrumbs = breadcrumbs;
    globalContext.singleItemTitle = singleItemTitle;
    globalContext.pageDescription = pageDescription;
    globalContext.pageIcon = pageIcon;
    globalContext.itemSearchText = itemSearchText;
    globalContext.setItemSearchText = setItemSearchText;
    globalContext.showAddItemPopup = showAddItemPopup;
    globalContext.showRemoveItemPopup = showRemoveItemPopup;
    globalContext.errorAddItemName = errorAddItemName;
    globalContext.currentCompanyId = currentCompanyId;
    globalContext.currentUserId = currentUserId;
    globalContext.setAddItemName = setAddItemName;
    globalContext.isAddingItem = isAddingItem;
    globalContext.isLoadingData = isLoadingData;
    globalContext.addItem = addItem;
    globalContext.doTextSearchTask = doTextSearchTask;
    globalContext.isPaneOpen = isPaneOpen;
    globalContext.togglePane = togglePane;
    globalContext.closePane = closePane;
    globalContext.toggleMultiItemAIChatPane = toggleMultiItemAIChatPane;
    globalContext.closeMultiItemAIChatPane = closeMultiItemAIChatPane;
    globalContext.enableTaskFormFieldEdit = enableTaskFormFieldEdit;
    globalContext.deleteCurrentItem = deleteCurrentItem;
    globalContext.isShowingDeleteConfirmation = isShowingDeleteConfirmation;
    globalContext.setIsShowingDeleteConfirmation = setIsShowingDeleteConfirmation;
    globalContext.isLoadingItemDetails = isLoadingItemDetails;
    globalContext.setIsLoadingItemDetails = setIsLoadingItemDetails;
    globalContext.isEditingField = isEditingField;
    globalContext.currentItem = currentItem;
    globalContext.setCurrentItem = setCurrentItem;
    globalContext.originalItem = originalItem;
    globalContext.setOriginalItem = setOriginalItem;
    globalContext.setErrorCurrentItemName = setErrorCurrentItemName;
    globalContext.disableAllItemFormFieldsEdit = disableAllItemFormFieldsEdit;
    globalContext.errorCurrentItemName = errorCurrentItemName;
    globalContext.validFormField = validFormField;
    globalContext.isDeletingItem = isDeletingItem;
    globalContext.isShowingSaveMessage = isShowingSaveMessage;
    globalContext.setIsShowingSaveMessage = setIsShowingSaveMessage;
    globalContext.isSavingItem = isSavingItem;
    globalContext.setIsSavingItem = setIsSavingItem;
    globalContext.saveCurrentItem = saveCurrentItem;
    globalContext.data = data;
    globalContext.setData = setData;
    globalContext.dataUrl = dataUrl;
    globalContext.entityType = entityType;
    globalContext.entityTypeId = entityTypeId;
    globalContext.showComplianceStatusFilter = showComplianceStatusFilter;
    globalContext.showCountryFilter = showCountryFilter;
    globalContext.showSubmissionsStatusFilter = showSubmissionsStatusFilter;
    globalContext.showSubmissionsTypeFilter = showSubmissionsTypeFilter;
    globalContext.showRegulatoryAreaFilter = showRegulatoryAreaFilter;
    globalContext.showPublicationTypeFilter = showPublicationTypeFilter;
    globalContext.showSystematicReviewsCompanyUserFilter = showSystematicReviewsCompanyUserFilter;
    globalContext.exportUrl = exportUrl;
    globalContext.eudamedXmlServices = eudamedXmlServices;
    globalContext.eudamedXmlError = eudamedXmlError;
    globalContext.setEudamedXmlError = setEudamedXmlError;
    globalContext.eudamedXmlWarning = eudamedXmlWarning;
    globalContext.setEudamedXmlWarning = setEudamedXmlWarning;
    globalContext.exportEudamedXml = exportEudamedXml;
    globalContext.eudamedXmlSuccess = eudamedXmlSuccess;
    globalContext.sendEudamedXmlToEudamed = sendEudamedXmlToEudamed;
    globalContext.selectedFilterComplianceStatus = selectedFilterComplianceStatus;
    globalContext.setSelectedFilterComplianceStatus = setSelectedFilterComplianceStatus;
    globalContext.applyFilterComplianceStatus = applyFilterComplianceStatus;
    globalContext.applyFilterSubmissionsStatus = applyFilterSubmissionsStatus;
    globalContext.applyFilterCountry = applyFilterCountry;
    globalContext.applyFilterRegulatoryArea = applyFilterRegulatoryArea;
    globalContext.applyFilterPublicationType = applyFilterPublicationType;
    globalContext.applyFilterSubmissionsType = applyFilterSubmissionsType;
    globalContext.isChoosingComplianceStatusFilter = isChoosingComplianceStatusFilter;
    globalContext.setIsChoosingComplianceStatusFilter = setIsChoosingComplianceStatusFilter;
    globalContext.isChoosingSubmissionsStatusFilter = isChoosingSubmissionsStatusFilter;
    globalContext.setIsChoosingSubmissionsStatusFilter = setIsChoosingSubmissionsStatusFilter;
    globalContext.isChoosingSubmissionsTypeFilter = isChoosingSubmissionsTypeFilter;
    globalContext.setIsChoosingSubmissionsTypeFilter = setIsChoosingSubmissionsTypeFilter;
    globalContext.selectedFilterCountry = selectedFilterCountry;
    globalContext.setSelectedFilterCountry = setSelectedFilterCountry;
    globalContext.isChoosingCountryFilter = isChoosingCountryFilter;
    globalContext.setIsChoosingCountryFilter = setIsChoosingCountryFilter;
    globalContext.selectedFilterRegulatoryArea = selectedFilterRegulatoryArea;
    globalContext.setSelectedFilterRegulatoryArea = setSelectedFilterRegulatoryArea;
    globalContext.selectedFilterPublicationType = selectedFilterPublicationType;
    globalContext.setSelectedFilterPublicationType = setSelectedFilterPublicationType;
    globalContext.selectedFilterSubmissionsOpen = selectedFilterSubmissionsOpen;
    globalContext.setSelectedFilterSubmissionsOpen = setSelectedFilterSubmissionsOpen;
    globalContext.isChoosingPublicationTypeFilter = isChoosingPublicationTypeFilter;
    globalContext.setIsChoosingPublicationTypeFilter = setIsChoosingPublicationTypeFilter;
    globalContext.isChoosingRegulatoryAreaFilter = isChoosingRegulatoryAreaFilter;
    globalContext.setIsChoosingRegulatoryAreaFilter = setIsChoosingRegulatoryAreaFilter;
    globalContext.users = users;
    globalContext.currentUserId = currentUserId;
    globalContext.Highcharts = Highcharts;
    globalContext.HighchartsGantt = HighchartsGantt;
    globalContext.regDocsGraphOptionsForCountry = regDocsGraphOptionsForCountry;
    globalContext.regDocsGraphOptionsForRegulatory = regDocsGraphOptionsForRegulatory;
    globalContext.regDocsGraphOptionsForComplianceStatus = regDocsGraphOptionsForComplianceStatus;
    globalContext.isLoadingRegulatoryDocumentsGraphs = isLoadingRegulatoryDocumentsGraphs;
    globalContext.isLoadingSubmissionsGraphs = isLoadingSubmissionsGraphs;
    globalContext.setIsLoadingSubmissionsGraphs = setIsLoadingSubmissionsGraphs;
    globalContext.standardsGraphOptionsForComplianceStatus = standardsGraphOptionsForComplianceStatus;
    globalContext.standardsGraphOptionsForSource = standardsGraphOptionsForSource;
    globalContext.isLoadingStandardsGraphs = isLoadingStandardsGraphs;
    globalContext.selectedReferences = selectedReferences;
    globalContext.setSelectedReferences = setSelectedReferences;
    globalContext.childRowsByParent = childRowsByParent;
    globalContext.setChildRowsByParent = setChildRowsByParent;
    globalContext.getSelectedRowsForDisplay = () => {
        const fromData = (data || []).filter((r) => selectedReferences.includes(r.Id));
        const seen = new Set(fromData.map((r) => r.Id));
        const fromChildren = Object.values(childRowsByParent || {})
            .flat()
            .filter((r) => selectedReferences.includes(r.Id) && !seen.has(r.Id));
        return [...fromData, ...fromChildren];
    };
    globalContext.setShowExportSelectedReferencesPopup = setShowExportSelectedReferencesPopup;
    globalContext.setShowDeleteSelectedReferencesPopup = setShowDeleteSelectedReferencesPopup;
    globalContext.closeAllPopups = closeAllPopups;
    globalContext.filterOptions_Status = filterOptions_Status;
    globalContext.filterOptions_Types = filterOptions_Types;
    globalContext.setFilterOptions_Status = setFilterOptions_Status;
    globalContext.filterOptions_Countries = filterOptions_Countries;
    globalContext.setFilterOptions_Countries = setFilterOptions_Countries;
    globalContext.filterOptions_PublicationTypes = filterOptions_PublicationTypes;
    globalContext.setFilterOptions_PublicationTypes = setFilterOptions_PublicationTypes;
    globalContext.filterOptions_RegulatoryAreas = filterOptions_RegulatoryAreas;
    globalContext.setFilterOptions_RegulatoryAreas = setFilterOptions_RegulatoryAreas;
    globalContext.exportReferences = exportReferences;
    globalContext.deleteSelectedItems = deleteSelectedItems;
    globalContext.refreshGraphs = refreshGraphs;
    globalContext.refreshData = refreshData;
    globalContext.isExporting = isExporting;
    globalContext.setIsExporting = setIsExporting;
    globalContext.isDeleting = isDeleting;
    globalContext.setIsDeleting = setIsDeleting;
    globalContext.errorDeleting = errorDeleting;
    globalContext.setErrorDeleting = setErrorDeleting;
    globalContext.successDeleting = successDeleting;
    globalContext.setSuccessDeleting = setSuccessDeleting;
    globalContext.setErrorExporting = setErrorExporting;
    globalContext.setSuccessExporting = setSuccessExporting;
    globalContext.refreshGraphs = refreshGraphs;
    globalContext.refreshData = refreshData;
    globalContext.showTotalAndFilteredCounts = showTotalAndFilteredCounts;
    globalContext.absoluteTotalCount = absoluteTotalCount;
    globalContext.setAbsoluteTotalCount = setAbsoluteTotalCount;
    globalContext.filteredTotalCount = filteredTotalCount;
    globalContext.setFilteredTotalCount = setFilteredTotalCount;
    globalContext.updatingTotalCounts = updatingTotalCounts;
    globalContext.setUpdatingTotalCounts = setUpdatingTotalCounts;
    globalContext.ComplianceType = ComplianceType;
    globalContext.selectedTags = selectedTags;
    globalContext.setSelectedTags = setSelectedTags;
    globalContext.enableTags = enableTags;
    globalContext.addTaskEntityTypesList = addTaskEntityTypesList;
    globalContext.setAddTaskEntityTypesList = setAddTaskEntityTypesList;
    globalContext.linkedObjectsList = linkedObjectsList;
    globalContext.setLinkedObjectsList = setLinkedObjectsList;
    globalContext.getStaticEntityTypeName = getStaticEntityTypeName;
    globalContext.loadData = loadData;
    globalContext.CustomMenuBar = CustomMenuBar;
    globalContext.getUserById = getUserById;
    globalContext.submissionPossibleStatuses = submissionPossibleStatuses;
    globalContext.setSubmissionPossibleStatuses = setSubmissionPossibleStatuses;
    globalContext.submissionPriorities = submissionPriorities;
    globalContext.setSubmissionPriorities = setSubmissionPriorities;
    globalContext.submissionTypes = submissionTypes;
    globalContext.setSubmissionTypes = setSubmissionTypes;
    globalContext.readableDate = readableDate;
    globalContext.readableDateUTC = readableDateUTC;
    globalContext.formatDate = formatDate;
    globalContext.unformatDate = unformatDate;
    globalContext.SubmissionPriority = SubmissionPriority;
    globalContext.SubmissionType = SubmissionType;
    globalContext.SubmissionStatus = SubmissionStatus;
    globalContext.hideAddButton = hideAddButton;
    globalContext.setSelectedFilterSubmissionsStatus = setSelectedFilterSubmissionsStatus;
    globalContext.setSelectedFilterSubmissionsType = setSelectedFilterSubmissionsType;
    globalContext.selectedFilterSubmissionsStatus = selectedFilterSubmissionsStatus;
    globalContext.selectedFilterSubmissionsType = selectedFilterSubmissionsType;
    globalContext.selectedFilterSystematicReviewsShowMineOnly = selectedFilterSystematicReviewsShowMineOnly;
    globalContext.initUrl = initUrl;
    globalContext.submissionsGraphOptionsForCountry = submissionsGraphOptionsForCountry;
    globalContext.submissionsGraphOptionsForType = submissionsGraphOptionsForType;
    globalContext.submissionsGraphOptionsForStatus = submissionsGraphOptionsForStatus;
    globalContext.clearAllFilters = clearAllFilters;
    //globalContext.legalManufacturerId = legalManufacturerId;
    //globalContext.legalManufacturerName = legalManufacturerName;
    globalContext.certificateId = certificateId;
    globalContext.userRole = userRole;
    globalContext.rimsUserRole = rimsUserRole;
    globalContext.isMemberGuest = isMemberGuest;
    globalContext.setIsMemberGuest = setIsMemberGuest;
    globalContext.isRowContextualMenuVisible = isRowContextualMenuVisible;
    globalContext.setIsRowContextualMenuVisible = setIsRowContextualMenuVisible;
    globalContext.rowContextualMenu = rowContextualMenu;
    globalContext.setRowContextualMenu = setRowContextualMenu;
    globalContext.srAddButton = srAddButton;
    globalContext.srCategoriesUrl = srCategoriesUrl;
    globalContext.selectedFilterSystematicReviewsArea = selectedFilterSystematicReviewsArea;
    globalContext.selectedSystematicReviewsType = selectedSystematicReviewsType;
    globalContext.setSelectedSystematicReviewsType = setSelectedSystematicReviewsType;
    globalContext.selectedSystematicReviewsTypeAdd = selectedSystematicReviewsTypeAdd;
    globalContext.setSelectedSystematicReviewsTypeAdd = setSelectedSystematicReviewsTypeAdd;
    globalContext.selectedSystematicReviewToDelete = selectedSystematicReviewToDelete;
    globalContext.setSelectedSystematicReviewToDelete = setSelectedSystematicReviewToDelete;
    globalContext.setSelectedFilterSystematicReviewsShowMineOnly = setSelectedFilterSystematicReviewsShowMineOnly;
    globalContext.systematicReviewsHeader = systematicReviewsHeader;
    globalContext.setSystematicReviewsHeader = setSystematicReviewsHeader;
    globalContext.loadSystematicReviewHeader = loadSystematicReviewHeader;
    globalContext.selectedFilterSystematicReviewsSection = selectedFilterSystematicReviewsSection;
    globalContext.LimitNumberOfSurveillances = LimitNumberOfSurveillances;
    globalContext.NumberOfSurveillances = NumberOfSurveillances;
    globalContext.srProjectPageUrl = srProjectPageUrl;
    globalContext.selectedSRProjectToDelete = selectedSRProjectToDelete;
    globalContext.setSelectedSRProjectToDelete = setSelectedSRProjectToDelete;
    globalContext.loadItemDetails = loadItemDetails;
    globalContext.isChoosingSrProjectsArchiveFilter = isChoosingSrProjectsArchiveFilter;
    globalContext.setIsChoosingSrProjectsArchiveFilter = setIsChoosingSrProjectsArchiveFilter;
    globalContext.selectedFilterSrProjectsArchive = selectedFilterSrProjectsArchive;
    globalContext.setSelectedFilterSrProjectsArchive = setSelectedFilterSrProjectsArchive;
    globalContext.selectedFilterProductsArchive = selectedFilterProductsArchive;
    globalContext.setSelectedFilterProductsArchive = setSelectedFilterProductsArchive;
    globalContext.showSRProjectsArchiveFilter = showSRProjectsArchiveFilter;
    globalContext.showProductsArchiveFilter = showProductsArchiveFilter;
    globalContext.showCMArchiveFilter = showCMArchiveFilter;
    globalContext.showSRProjectsCompanyUserFilter = showSRProjectsCompanyUserFilter;
    globalContext.applyFilterSrProjectsArchive = applyFilterSrProjectsArchive;
    globalContext.applyFilterProductsArchive = applyFilterProductsArchive;
    globalContext.selectedFilterSRProjectsShowMineOnly = selectedFilterSRProjectsShowMineOnly;
    globalContext.setSelectedFilterSRProjectsShowMineOnly = setSelectedFilterSRProjectsShowMineOnly;
    globalContext.srApiUrl = srApiUrl;
    globalContext.srProjectApiUrl = srProjectApiUrl;
    globalContext.srProjectIdFilter = srProjectIdFilter;
    globalContext.srProjectName = srProjectName;
    globalContext.customRowClickFunction = customRowClickFunction;
    globalContext.rowClickUrlToProjectSystematicReviews = rowClickUrlToProjectSystematicReviews;
    globalContext.baseLinkUrlForSrs = baseLinkUrlForSrs;
    globalContext.embedInSubmissions = embedInSubmissions;
    globalContext.actionMethodForSubmissions = actionMethodForSubmissions;
    globalContext.hideBreadcrumbs = hideBreadcrumbs;
    globalContext.hideTitle = hideTitle;
    globalContext.showTitleAsSubTitle = showTitleAsSubTitle;
    globalContext.errorCurrentItemTitle = errorCurrentItemTitle;
    globalContext.setErrorCurrentItemTitle = setErrorCurrentItemTitle;
    globalContext.showLegalManufacturerFilter = showLegalManufacturerFilter;
    globalContext.legalManufacturers = legalManufacturers;
    globalContext.setLegalManufacturers = setLegalManufacturers;
    globalContext.isLoadingLegalManufacturers = isLoadingLegalManufacturers;
    globalContext.setIsLoadingLegalManufacturers = setIsLoadingLegalManufacturers;
    globalContext.currentLegalManufacturerFilter = currentLegalManufacturerFilter;
    globalContext.setCurrentLegalManufacturerFilter = setCurrentLegalManufacturerFilter;
    globalContext.currentLegalManufacturerNameFilter = currentLegalManufacturerNameFilter;
    globalContext.setCurrentLegalManufacturerNameFilter = setCurrentLegalManufacturerNameFilter;
    globalContext.isLoadingRelatedLegalManufacturers = isLoadingRelatedLegalManufacturers;
    globalContext.setIsLoadingRelatedLegalManufacturers = setIsLoadingRelatedLegalManufacturers;
    globalContext.relatedLegalManufacturers = relatedLegalManufacturers;
    globalContext.setRelatedLegalManufacturers = setRelatedLegalManufacturers;
    globalContext.setIsCustomizablePopupVisible = setIsCustomizablePopupVisible;
    globalContext.isCustomizablePopupVisible = isCustomizablePopupVisible;
    globalContext.setCustomizablePopup = setCustomizablePopup;
    globalContext.customizablePopup = customizablePopup;
    globalContext.ReloadStructureFunction = ReloadStructureFunction;
    globalContext.tagFilterUpdateTrigger = tagFilterUpdateTrigger;
    globalContext.callbackUpdateTriggerTagFilter = callbackUpdateTriggerTagFilter;
    globalContext.rimsSearchCallback = rimsSearchCallback;
    globalContext.showRIMSFilter = showRIMSFilter;
    globalContext.currentRIMSFilters = currentRIMSFilters;
    globalContext.enableMultiItemAIChatPane = enableMultiItemAIChatPane;
    globalContext.isMultiItemAIChatPaneOpen = isMultiItemAIChatPaneOpen;
    globalContext.showExportButton = showExportButton;
    globalContext.showDeleteButton = showDeleteButton;
    globalContext.reachedAllowance = reachedAllowance;
    globalContext.enableTimelineGraph = enableTimelineGraph;
    globalContext.setShowTimelineGraphPopup = setShowTimelineGraphPopup;
    globalContext.newItemCustomFields = newItemCustomFields;
    globalContext.setNewItemCustomFields = setNewItemCustomFields;
    globalContext.newItemCustomFieldsAnswers = newItemCustomFieldsAnswers;
    globalContext.setNewItemCustomFieldsAnswers = setNewItemCustomFieldsAnswers;
    globalContext.productStandardsListItemUrl = productStandardsListItemUrl;
    globalContext.productRegulatoryDocumentsListItemUrl = productRegulatoryDocumentsListItemUrl;
    globalContext.productReferenceManagerListItemUrl = productReferenceManagerListItemUrl;
    globalContext.preLoadItemUrlParamName = preLoadItemUrlParamName;
    globalContext.productsConfigurationsUrl = productsConfigurationsUrl;
    globalContext.productsStandardsUrl = productsStandardsUrl;
    globalContext.productsRegdocsUrl = productsRegdocsUrl;
    globalContext.productsLiteratureUrl = productsLiteratureUrl;
    globalContext.productsArchiveUrl = productsArchiveUrl;
    globalContext.productFamilyUrl = productFamilyUrl;
    globalContext.productRegistrationsCountUrl = productRegistrationsCountUrl;
    globalContext.isUpdatingProductsCount = isUpdatingProductsCount;
    globalContext.setIsUpdatingProductsCount = setIsUpdatingProductsCount;
    globalContext.productsCount = productsCount;
    globalContext.setProductsCount = setProductsCount;
    globalContext.filteredProductsCount = filteredProductsCount;
    globalContext.setFilteredProductsCount= setFilteredProductsCount;
    globalContext.productFamiliesStandardsUrl = productFamiliesStandardsUrl;
    globalContext.productFamiliesRegdocsUrl = productFamiliesRegdocsUrl;
    globalContext.hideSelectAllCheckbox = hideSelectAllCheckbox;
    globalContext.complianceStandardsUrl = complianceStandardsUrl;
    globalContext.complianceRegdocsUrl = complianceRegdocsUrl;
    globalContext.reachedAllowanceProductsOnly = reachedAllowanceProductsOnly;
    globalContext.enableCustomFields = enableCustomFields;
    globalContext.hideSearchBar = hideSearchBar;
    globalContext.filterBarControls = filterBarControls;
    globalContext.hideExcelExport = hideExcelExport;
    globalContext.disableCustomFieldCreation = disableCustomFieldCreation;
    globalContext.searchPlaceholder = searchPlaceholder;
    globalContext.setShowCountryRegistrationsExportAllReferencesPopup = setShowCountryRegistrationsExportAllReferencesPopup;
    globalContext.setShowCountryRegistrationsDeleteAllReferencesPopup = setShowCountryRegistrationsDeleteAllReferencesPopup;
    globalContext.updateListTotalCount = updateListTotalCount;
    globalContext.lastFiltersUsedForListTotalCount = lastFiltersUsedForListTotalCount;
    globalContext.listTotalCount = listTotalCount;
    globalContext.setIsShowingTaskManagerPopup = setIsShowingTaskManagerPopup;
    globalContext.taskCount = taskCount;
    globalContext.showTaskCount = showTaskCount;
    globalContext.openTaskManagerForEntity = openTaskManagerForEntity;
    globalContext.externalLinkedObjects = dataTableStructure.externalLinkedObjects;
    globalContext.linkedEntityType = dataTableStructure.linkedEntityType;
    globalContext.linkedEntityId = dataTableStructure.linkedEntityId;
    globalContext.pendingCreate = dataTableStructure.pendingCreate;
    globalContext.addTaskParentTaskId = dataTableStructure.addTaskParentTaskId;
    globalContext.setAddTaskParentTaskId = dataTableStructure.setAddTaskParentTaskId;
    globalContext.applyFilterCMArchive = applyFilterCMArchive;
    globalContext.setSelectedFilterCMArchive = setSelectedFilterCMArchive;
    globalContext.selectedFilterCMArchive = selectedFilterCMArchive;
    globalContext.triggerRefreshGraphs = triggerRefreshGraphs;
    globalContext.setIsVisibleTechnicalDocumentationTemplates = setIsVisibleTechnicalDocumentationTemplates;
    globalContext.setIsVisibleTechnicalDocumentationJurisdictions = setIsVisibleTechnicalDocumentationJurisdictions;




    useEffect(() => {
        if (typeof dataTableStructure.registerApi === "function") {
            dataTableStructure.registerApi({
                loadItemDetails,
                showAddItemPopup,
                refreshData,
                loadData,
                openExportPopup: () => {
                    setErrorExporting(false);
                    setSuccessExporting(false);
                    setShowExportSelectedReferencesPopup(true);
                },
                selectedCount: selectedReferences.length,
            });
        }
    });

    useEffect(() => {
        if (typeof dataTableStructure.onSelectedReferencesChange === "function")
            dataTableStructure.onSelectedReferencesChange(selectedReferences.length);
    }, [selectedReferences.length]);

    const fillParentHeight = !!dataTableStructure.fillParentHeight || !!dataTableStructure.hasLimitedWidth;
    let finalWindowHeight = fillParentHeight ? "100%" : "calc(100vh - 74px)";


    return (<>

        <GlobalAppContext.Provider value={globalContext}>

            <div
                onClick={handleOutsideClick}
                className="datatable-main-wrapper"
                style={{
                    ...(dataTableStructure.hideGrid ? { display: "none" } : null),
                    ...(fillParentHeight ? { height: "100%", maxHeight: "100%", overflow: "hidden", minHeight: 0 } : null),
                }}
            >

                <div style={{ display: "flex", flexDirection: "row", height: finalWindowHeight, minWidth: 0, minHeight: 0, width: fillParentHeight ? "100%" : undefined, overflow: fillParentHeight ? "hidden" : undefined }}>


                    {/* This allows for customizable contextual menus for the items for example */}
                    {isRowContextualMenuVisible ? <>{rowContextualMenu}</> : null}


                    {/* This allows for customizable general popups (for managing tags in the SR for example) */}
                    {isCustomizablePopupVisible ? <>{customizablePopup}</> : null}
                     


                    {(hasLeftMenu && dataTableStructure.menu) ? 
                        <div className="thin-scrollbar" style={{
                            minWidth: "20%", maxWidth: "20%",
                            /*marginRight: "20px",*/
                            /*maxHeight: `calc(100vh - 100px)`,*/
                            overflowY: "auto",
                            paddingRight: "10px",
                            paddingLeft: "10px",
                            borderLeft: "1px solid #f0f0f0",
                            borderRight: "1px solid #f0f0f0",

                        }}>
                            {
                                (() => {
                                    const Menu = dataTableStructure.menu;
                                    let onOptionClick = null;

                                    if (dataTableStructure.entityType == "systematic-review") onOptionClick = handleSystematicReviewMenuOptionClick;

                                    return <Menu dataTableStructure={dataTableStructure} onOptionClick={onOptionClick} AppContext={globalContext } />
                                })()
                            }
                        </div>
                    : null}

                    <div ref={contentParentRef} style={{ flex: 1, minWidth: 0, minHeight: 0, width: fillParentHeight ? "100%" : undefined, display: fillParentHeight ? "flex" : undefined, flexDirection: fillParentHeight ? "column" : undefined, overflow: fillParentHeight ? "hidden" : undefined, ...(hasLeftMenu || (dataTableStructure.entityType == "systematic-review" && srProjectIdFilter) ? { paddingLeft: "10px" } : null) }}>


                        {hideHeader ? null :
                            <Header />
                        }


                        {/* Total list count */}
                        {showListTotalCount ? 
                            <div style={{ marginBottom: "10px", textAlign: "right", marginRight: "20px" }}>
                                <span
                                    style={{
                                        padding: "6px 12px",
                                        borderRadius: "999px",
                                        background: "#f4f6f8",
                                        border: "1px solid #d0d7de",
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        color: "#203864",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    Total items: {isLoadingListTotalCount ? <LoadingSpinnerImage small={true} /> : listTotalCount}
                                </span>
                            </div>
                        : null}


                        {/* div with horizontal scroll only. This will scroll the entire table */}

                        <div className="datatable-container thin-scrollbar" style={{ maxHeight: fillParentHeight ? "100%" : "calc(100vh - 74px)", height: fillParentHeight ? "100%" : undefined, minHeight: 0, display: "flex", flexDirection: "column", overflowX: "auto", overflowY: "hidden", width: `calc(${contentParentwidth}px - 10px)` /*maxHeight: dataTableHeight,*/ }}>

                            {/* Header row */}

                            <div className="new-datatable-header" style={{ minWidth: minWidth + "px" }} >
                                {dataStructure.map((item, index) => (

                                    item.isSelectItemCheckbox ?

                                        <div key={index}
                                            className="new-datatable-header-col"
                                            style={{ width: `${columnWidth(item.width, index)}`, }}
                                        >
                                        {hideSelectAllCheckbox ? null : 
                                            <span className="table-column-filter">
                                                {showLoadingInsteadOfSelectAllCheckbox ?
                                                    <LoadingSpinnerImage small={true} />
                                                    :
                                                    <input type="checkbox" onChange={handleSelectAllReferences} checked={allReferencesSelected} />
                                                }
                                            </span>
                                        }
                                        </div>

                                        :

                                        item.sortable ?

                                            <div key={index}
                                                className="new-datatable-header-col"
                                                style={{ width: `${columnWidth(item.width, index)}`, minWidth: `${columnWidth(item.width, index)}`, cursor: "pointer", }}
                                                onClick={() =>
                                                    changeDataOrderField(item.field)
                                                }
                                            >
                                                <span className="table-column-filter">

                                                    {/* Column name */}

                                                    {item.name}

                                                    {/* Column filter icon */}

                                                    {item.hasFilter ? <>
                                                        <ColumnFilter filterCallback={columnFilterCallBack} loadFilterOptions={columnFilterLoadFilterOptions} column={item} defaultFilters={defaultFilters} />
                                                    </> : null}

                                                    {/* Column sorting icon */}

                                                    {dataSortByField == item.field ? (
                                                        dataSortByType == "ASCENDING" ? (
                                                            <i style={{ marginLeft: "5px" }} className="fas fa-long-arrow-alt-up"></i>
                                                        ) : (
                                                            <i style={{ marginLeft: "5px" }} className="fas fa-long-arrow-alt-down"></i>
                                                        )
                                                    ) : null}
                                                </span>
                                            </div>

                                            :
                                     
                                            <div key={index} className="new-datatable-header-col" style={{ width: `${columnWidth(item.width, index)}`, minWidth: `${columnWidth(item.width, index)}`, }}>

                                                {/* Column name */}

                                                {item.name}

                                                {/* Column filter icon */}

                                                {item.hasFilter ? <>
                                                    <ColumnFilter filterCallback={columnFilterCallBack} loadFilterOptions={columnFilterLoadFilterOptions} column={item} defaultFilters={defaultFilters} />
                                                </> : null}

                                            </div>
                                    
                                ))}
                            </div>


                            {/* Result rows */}


                            <div
                                className="datatable-content thin-scrollbar"
                                style={{
                                    flex: 1,
                                    minWidth: minWidth +"px",
                                    overflowY: "auto",
                                    overflowX: "hidden",
                                }}
                            >
                                <div>
                                    {data && data.flatMap((row) => {
                                        if (!dataTableStructure.expandable)
                                            return [row];
                                        const expanded = expandedRowIds.includes(row.Id);
                                        const children = expanded
                                            ? (loadingChildId == row.Id && !childRowsByParent[row.Id]
                                                ? [{ _loading: true, Id: `loading-${row.Id}` }]
                                                : (childRowsByParent[row.Id] || []).map((child) => ({ ...child, _isChild: true })))
                                            : [];
                                        return [row, ...children];
                                    }).map((row, index) => {

                                        if (row._loading) {
                                            return (
                                                <div
                                                    key={row.Id}
                                                    className="new-datatable-row"
                                                    style={{ background: "#fafafa", cursor: "default" }}
                                                >
                                                    <div
                                                        className="new-datatable-row-cell"
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "10px",
                                                            padding: "14px 16px 14px 52px",
                                                            color: "#718096",
                                                            fontSize: "12px",
                                                        }}
                                                    >
                                                        <LoadingSpinnerImage small={true} />
                                                        <span>Loading subtasks...</span>
                                                    </div>
                                                </div>
                                            );
                                        }

                                        // Check if the row style should be changed depending on the value of a specific column

                                        let rowStyleProcessorClassName = "";
                                        
                                        if (dataTableStructure.rowStyleProcessor && dataTableStructure.rowStyleProcessorColumn) {
                                            rowStyleProcessorClassName = dataTableStructure.rowStyleProcessor(row[dataTableStructure.rowStyleProcessorColumn]);
                                        }

                                        return (
                                            <div className={`new-datatable-row ${rowStyleProcessorClassName}`} key={index} style={{ cursor: "pointer", ...(row._isChild ? { background: "#fafafa" } : null) }} >

                                                    {
                                                        // Draw each column of the row ordered by the dataStructure header and drawn with the specified component
                                                        dataStructure.map((headerCol, indexData) => {
                                                            let fieldName = headerCol.field;
                                                            let fieldWidth = columnWidth(headerCol.width, indexData);
                                                            let Component = headerCol.renderWith;
                                                            let result = null;
                                                            let isSelectItemCheckbox = headerCol.isSelectItemCheckbox;
                                                            //let disableRowClick = headerCol.disableRowClick;
                                                            let isMultiField = headerCol.isMultiField;
                                                            let value;

                                                            if (isSelectItemCheckbox) {
                                                                return <div key={indexData} className="new-datatable-row-cell" style={{ width: `${fieldWidth}`, minWidth: `${fieldWidth}` }}>
                                                                    <input type="checkbox" name="mainListSelect" checked={selectedReferences.includes(row.Id)} value={row.Id} onChange={handleMainListSelect} />
                                                                </div>
                                                            }

                                                            if (row.hasOwnProperty(fieldName)) {
                                                                let value = row[fieldName];

                                                                // If multivalue creates object with all necessary values
                                                                if (isMultiField instanceof Array) {
                                                                    value = {};
                                                                    isMultiField.map(field => {

                                                                        if (typeof field == "string")
                                                                            value[field] = row[field];

                                                                        if (typeof field == "object") // Accepts injected objects {}
                                                                        {
                                                                            for (const key in field)
                                                                                if (field.hasOwnProperty(key))
                                                                                    value[key] = field[key];
                                                                        }

                                                                    });
                                                                }

                                                                result = <Component value={value} row={row} users={users} entityType={entityType} globalContext={globalContext} />
                                                            }
                                                            else { // It's a user custom field

                                                                let CustomFieldId = headerCol.customFieldId;

                                                                switch (headerCol.customFieldType) {
                                                                    case 0:
                                                                        Component = FieldTypes.FieldType_Text;
                                                                        value = row.CustomFieldsAnswers?.find(answer => answer.CustomFieldId == CustomFieldId)?.Value ?? "";
                                                                        break;
                                                                    case 1:
                                                                        Component = FieldTypes.FieldType_CustomUserFieldSingleSelect;
                                                                        value = {
                                                                            CustomField: row.CustomFields.find(customField => customField.Id == CustomFieldId),
                                                                            CustomFieldAnswers: row.CustomFieldsAnswers?.find(answer => answer.CustomFieldId == CustomFieldId)?.MultipleAnswers ?? null
                                                                        }
                                                                        break;
                                                                    case 2:
                                                                        Component = FieldTypes.FieldType_CustomUserFieldMultiSelect;
                                                                        value = {
                                                                            CustomField: row.CustomFields.find(customField => customField.Id == CustomFieldId),
                                                                            CustomFieldAnswers: row.CustomFieldsAnswers?.find(answer => answer.CustomFieldId == CustomFieldId)?.MultipleAnswers ?? null
                                                                        }
                                                                        break;
                                                                    case 3:
                                                                        Component = FieldTypes.FieldType_DateList;
                                                                        value = row.CustomFieldsAnswers?.find(answer => answer.CustomFieldId == CustomFieldId)?.Value ?? "";
                                                                        break;
                                                                    default: 
                                                                        Component = FieldTypes.FieldType_Text;
                                                                        value = ""; // <unknown field type>
                                                                        break;
                                                                }
                                                                
                                                                result = <Component value={value} row={row} users={users} entityType={entityType} globalContext={globalContext} />
                                                                
                                                            }

                                                            return <div
                                                                key={indexData}
                                                                className={`new-datatable-row-cell ${dataTableStructure.datatableRowCellCustomClass ? dataTableStructure.datatableRowCellCustomClass : ""}`}
                                                                style={{ width: `${fieldWidth}`, minWidth: `${fieldWidth}`, ...(indexData === expandColumnIndex && dataTableStructure.expandable ? { paddingRight: "4px" } : null) }}
                                                                onClick={(e) => {

                                                                    // Disable row click if element is link, button, input, etc...
                                                                    const ignored = e.target.closest(
                                                                        'a,button,input,select,textarea,[data-no-row-click]'
                                                                    );

                                                                    if (ignored) return;

                                                                    if (dataTableStructure.disableRowClicks)
                                                                        return;

                                                                    let itemId = dataTableStructure.customItemIdColumn ? row[dataTableStructure.customItemIdColumn] : row.Id;

                                                                    if (globalContext.customRowClickFunction)
                                                                        //before
                                                                        //globalContext.customRowClickFunction({ event: e, rowId: itemId, globalContext: globalContext });

                                                                        globalContext.customRowClickFunction({ event: e, rowId: row.Id, row: row, globalContext: globalContext });

                                                                    else
                                                                        loadItemDetails(itemId, e);
                                                                }}
                                                            >
                                                                {indexData === expandColumnIndex && dataTableStructure.expandable && (
                                                                    (!row._isChild && row[dataTableStructure.expandable.countField] > 0) || row._isChild
                                                                ) ? (
                                                                    <span
                                                                        style={{
                                                                            display: "inline-flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "flex-start",
                                                                            width: row._isChild ? "36px" : "18px",
                                                                            marginRight: "12px",
                                                                            flexShrink: 0,
                                                                        }}
                                                                    >
                                                                        {!row._isChild ? (
                                                                            <span
                                                                                data-no-row-click
                                                                                onClick={(e) => { e.stopPropagation(); toggleExpandedRow(row); }}
                                                                                style={{ cursor: "pointer", width: "18px", textAlign: "center" }}
                                                                            >
                                                                                <i className={expandedRowIds.includes(row.Id) ? "fas fa-angle-down" : "fas fa-angle-right"}></i>
                                                                            </span>
                                                                        ) : (
                                                                            <span
                                                                                title="Subtask"
                                                                                style={{
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center",
                                                                                    width: "36px",
                                                                                    paddingLeft: "10px",
                                                                                    opacity: 0.55,
                                                                                }}
                                                                            >
                                                                                <img
                                                                                    src="/assets/images/child_row_icon.png"
                                                                                    alt=""
                                                                                    style={{ width: "12px", height: "12px" }}
                                                                                />
                                                                            </span>
                                                                        )}
                                                                    </span>
                                                                ) : null}
                                                                {result}
                                                            </div>
                                                        })
                                        
                                                    }
                                    
                                                </div>
                                            )
                                        }
                                        )}
                                </div>

                                {/* Loading and no-more-results row */}

                                {isLoadingData ?
                                    <div style={{ textAlign: "center" }}>
                                        <LoadingSpinnerImage />
                                    </div>
                                    :
                                    <>
                                        {/* If this div is visible it should try to load more files. Either inner div content or minHeight is mandatory for the intersector to work */}
                                        <div ref={targetRef} style={{ minHeight: "5px" }}></div>
                                    </>
                                }


                                {!hasMoreData ?
                                    <>
                                        {showRefreshLastLoadData ? 
                                            <div className="no-more-results" >
                                                <span onClick={() => loadData({ nextPage: true })} style={{ padding: "3px 7px", border: "1px solid #eee", borderRadius: "10px", backgroundColor: "#eff8ff", cursor: "pointer" }}>Reload</span>
                                            </div>
                                        :
                                            <div className="no-more-results">No more items</div>
                                        }
                                    </>
                                : null }
                            </div>


                        </div>

                    </div>

                </div>

            </div>


            {ItemDetailsPane != null ?
                <ItemDetailsPane globalContext={globalContext} />
            :
                <DefaultItemDetailsPane />
            }

            {isVisibleAddItemPopup &&
                (AddItemPopup != null ?
                    <>
                        <div style={{position: "fixed", backgroundColor: "rgba(1, 1, 1, 0.5)", height: "100%", width: "100%", top: 0, left: 0, zIndex: 1000, overflowY: "auto" }}>
                            <AddItemPopup globalContext={globalContext} />
                        </div>
                    </>
                    :
                    <DefaultAddItemPopup />
                )
            }

            {isVisibleRemoveItemPopup && (
                (RemoveItemPopup != null ?
                    <RemoveItemPopup globalContext={globalContext} />
                    : null
                )
            )}


            {isVisibleTechnicalDocumentationTemplates && <>
                <TechnicalDocumentationTemplatesList />
            </>}


            {isVisibleTechnicalDocumentationJurisdictions && <>
                <TechnicalDocumentationJurisdictionsList />
            </>}


            {enableMultiItemAIChatPane && (
                <MultiItemAIChatPane globalContext={globalContext} />
            )}





            {showDeleteSelectedReferencesPopup &&
                <DeleteSelectedReferencesPopup />
            }


            {showExportSelectedReferencesPopup &&
                <ExportSelectedReferencesPopup />
            }


            {showCountryRegistrationsExportAllReferencesPopup &&
                <CountryRegistrationsExportAllReferencesPopup />
            }

            {showCountryRegistrationsDeleteAllReferencesPopup &&
                <CountryRegistrationsDeleteAllReferencesPopup />
            }


            {enableTimelineGraph && showTimelineGraphPopup &&
                <TimelinePopup />
            }

            {showErrorMessagePopup ?
                <ErrorMessagePopup error={errorMessageObject} onClose={closeErrorMessagePopup} />
            : null}



            {/* TASK MANAGER POPUP */}
            {isShowingTaskManagerPopup ? <>


                <div className="add-task-popup" style={{width: "70%", maxWidth: "none" }}>

                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ width: "50%" }}>
                            <h3>Tasks</h3>
                        </div>
                        <div style={{ width: "50%", textAlign: "right" }}>
                            <button
                                className="close-button"
                                onClick={() => hideTaskManagerPopup()}
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div style={{ marginTop: "20px" }}>
                        <div style={{ paddingTop: "10px", }}>
                            <div>
                                <TaskManagerPopup emitter={taskManagerEmitter} paramEntityType={entityType} paramIsSlimVersion={true} paramHasLimitedWidth={true} />
                            </div>
                        </div>
                    </div>

                </div>


            </> : null}


        </GlobalAppContext.Provider>

    </>);


}



const DefaultItemDetailsPane = () => {

    const AppContext = useContext(GlobalAppContext);

    const currentItemNameRef = useRef(null);

    return (
        <div id="thisone_default"
            style={{ height: "100vh", overflow: "auto" }}
            className={`slide-pane ${AppContext.isPaneOpen ? "open" : ""}`}
        >
            <div className="content">
                {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? (
                    <>
                        <div>
                            <LoadingSpinnerImage />
                        </div>
                    </>
                ) : (
                    <>
                        <div style={{ textAlign: "right", marginBottom: "10px" }}>
                            <button className="close-button" onClick={AppContext.closePane}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>

                        <h2>{AppContext.singleItemTitle} Details</h2>

                        {/* FORMS FIELDS */}

                        <div style={{margin: "40px 0px"}}>

                            {/* Form field: Name */}
                            <div className="view-task-field">
                                <div className="view-task-field-line">
                                    <div className="view-task-field-title">Reference & Title</div>
                                    <div className="view-task-field-value">
                                        {AppContext.isEditingField.name === false ? (
                                            <>
                                                <span
                                                    className={`editable-field-span ${AppContext.errorCurrentItemName
                                                        ? "form-field-error"
                                                        : null
                                                        }`}
                                                    onClick={(e) => {
                                                        AppContext.enableTaskFormFieldEdit("name", e);
                                                        setTimeout(() => {
                                                            // We need this timeout because the ref for the edit field isn't immediately available
                                                            currentItemNameRef.current.selectionStart = 0;
                                                            currentItemNameRef.current.selectionEnd = 0;
                                                        }, 10);
                                                    }
                                                    }
                                                >
                                                    {AppContext.currentItem.Name}
                                                        {AppContext.errorCurrentItemName ? (
                                                            <span className="form-field-error-message">
                                                                The field Name is necessary
                                                            </span>
                                                        ) : (
                                                        <i style={{ marginLeft: "5px", fontSize: "0.8em" }} className="fas fa-pencil-alt"></i>
                                                    )}
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                <span style={{ width: "100%" }}>
                                                    <input
                                                        ref={currentItemNameRef}
                                                        style={{ width: "100%" }}
                                                        autoFocus
                                                        onBlur={() => {
                                                            AppContext.disableAllItemFormFieldsEdit();
                                                            AppContext.validFormField(
                                                                AppContext.currentItem.Name,
                                                                AppContext.setErrorCurrentItemName
                                                            );
                                                        }}
                                                        onChange={(e) =>
                                                            AppContext.setCurrentItem({
                                                                ...AppContext.currentItem,
                                                                Name: e.target.value
                                                            })
                                                        }
                                                        value={AppContext.currentItem.Name}
                                                    />
                                                </span>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Form field: Compliance Status */}

                            <div className="view-task-field">
                                <div className="view-task-field-line">
                                    <div className="view-task-field-title">Compliance Status</div>
                                    <div className="view-task-field-value">


                                        {AppContext.isEditingField.compliance_status === false ? (
                                            <>
                                                <span
                                                    className="editable-field-span editable-field-span-complex"
                                                    onClick={(e) =>
                                                        AppContext.enableTaskFormFieldEdit("compliance_status", e)
                                                    }
                                                >
                                                    <FieldTypes.FieldType_Compliance_Status value={AppContext.currentItem.Status} />

                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                <span>
                                                    <select
                                                        value={AppContext.currentItem.Status}
                                                        onBlur={() =>
                                                            AppContext.disableAllItemFormFieldsEdit()
                                                        }
                                                        onChange={(e) => {
                                                            AppContext.setCurrentItem({
                                                                ...AppContext.currentItem,
                                                                Status: parseInt(e.target.value)
                                                            });
                                                        }}
                                                    >
                                                        {Constants.ComplianceStatuses.map((compliance_status, index) => (
                                                            <option key={index} value={compliance_status.id}>
                                                                {compliance_status.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </span>
                                            </>
                                        )}


                                    </div>
                                </div>
                            </div>


                        </div>


                        {/* FORMS BUTTONS */}


                        <div className="action-button-bar">

                            {AppContext.userRole == "Admin" ? <>

                                    

                            <div className="action-button-bar-left">
                                {!AppContext.isSavingItem ? (
                                    <>
                                        <button
                                            className="action-button save-button"
                                            onClick={AppContext.saveCurrentItem}
                                        >
                                            Save
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <LoadingSpinnerImage />
                                    </>
                                )}
                                <span
                                    className={`${AppContext.isShowingSaveMessage
                                        ? "save-message-shown"
                                        : "save-message-hidden"
                                        }`}
                                    onTransitionEnd={() => AppContext.setIsShowingSaveMessage(false)}
                                >
                                    Save successful!
                                </span>

                            </div>



                            <div className="action-button-bar-center">

                                <button
                                    className="action-button cancel-button"
                                    onClick={AppContext.closePane}
                                >
                                    Cancel
                                </button>

                            </div>



                            <div className="action-button-bar-right">
                                {!AppContext.isDeletingItem ? (
                                    <>
                                        {!AppContext.isShowingDeleteConfirmation ?
                                            <button
                                                className="action-button delete-button"
                                                onClick={() =>
                                                    AppContext.setIsShowingDeleteConfirmation(true)
                                                }
                                            >
                                                Delete Item
                                            </button>
                                            :
                                            <>
                                                <div style={{ marginRight: "35px", marginBottom: "10px" }}>Are you sure?</div>
                                                <button
                                                    className="action-button delete-button"
                                                    onClick={AppContext.deleteCurrentItem}
                                                >
                                                    Yes, Delete this item!
                                                </button>
                                            </>
                                        }
                                    </>
                                ) : (
                                    <>
                                        <LoadingSpinnerImage />
                                    </>
                                )}
                            </div>

                            </> : null}

                        </div>




                    </>
                )}
            </div>
        </div>
    );
};



const Breadcrumbs = () => {
    let AppContext = useContext(GlobalAppContext);

    return (
        <>
            <div className="breadcrumbs">
                {AppContext.breadcrumbs?.map((item, index) => (
                    <span key={index}>
                        {index > 0 && <span style={{margin: "0 5px"}}> &gt; </span>}

                        {item.Link != null ? <>
                            <a href={item.Link} className="breadcrumb">
                                {item.Name}
                            </a>
                        </> : <>
                            {item.Name}
                        </>}
                    </span>
                ))}

            </div>
        </>
    );
};



const Header = () => {

    const AppContext = useContext(GlobalAppContext);

    const optionButtonRef = useRef(null);
    const optionsPopupRef = useRef(null);

    const [isOptionsPopupVisible, setIsOptionsPopupVisible] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });

    const handleOptionButtonClick = () => {
        if (optionButtonRef.current) {
            const rect = optionButtonRef.current.getBoundingClientRect();
            setPopupPosition({
                top: rect.bottom + window.scrollY + 5,
                left: rect.left + window.scrollX,
            });
        }
        setIsOptionsPopupVisible(!isOptionsPopupVisible);
    };

    const showActionPopup = (type) => {

        setIsOptionsPopupVisible(false);

        AppContext.closeAllPopups();


        // Reset buttons and messages
        AppContext.setErrorDeleting(false)
        AppContext.setSuccessDeleting(false);
        AppContext.setErrorExporting(false);
        AppContext.setSuccessExporting(false);


        if (type == "export")
            AppContext.setShowExportSelectedReferencesPopup(true);

        if (type == "delete")
            AppContext.setShowDeleteSelectedReferencesPopup(true);

        if (type == "countryregistrations-exportall")
            AppContext.setShowCountryRegistrationsExportAllReferencesPopup(true);

        if (type == "countryregistrations-deleteall")
            AppContext.setShowCountryRegistrationsDeleteAllReferencesPopup(true);

    }

    const currentCompletionStatusRef = useRef(null);


    const handleMultipleItemsAIChatButtonClick = () => {

        AppContext.toggleMultiItemAIChatPane();

    }


    const handleTimelineButtonClick = () => {

        AppContext.closeAllPopups();
        AppContext.setShowTimelineGraphPopup(true);
    }

    const buttonStyle = {
        color: "#203864",
        padding: "7px 20px",
        border: "1px solid #dee2e6",
        borderRadius: "15px",
        backgroundColor: "#f8f9fa",
        fontWeight: "500",
        display: "inline-flex",
        alignItems: "center",
        transition: "all 0.2s ease",
        cursor: "pointer",
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
    };
    const disabledButtonStyle = {
        display: "inline-flex",
        alignItems: "center",
        padding: "7px 20px",
        color: "rgb(49, 49, 73)",
        backgroundColor: "rgb(240, 240, 240)",
        border: "2px solid rgb(204, 204, 204)",
        borderRadius: "15px",
        fontWeight: "500",
        cursor: "help",
        opacity: "0.5"
    };

    // Check if it's a registration list filtered by country by default

    let countryRegistrationsCountryFilter = null;
    let countryRegistrationsProductsFilter = null;
    let countryRegistrationsSellingFilter = null;
    let countryRegistrationsStatusFilter = null;
    if (AppContext.entityType == "countryregistrations") {
        const urlParams = new URLSearchParams(window.location.search);
        countryRegistrationsCountryFilter = urlParams.get("filter[CountryId]") ?? null;
        countryRegistrationsProductsFilter = urlParams.get("filter[ProductId]") ?? null;
        countryRegistrationsSellingFilter = urlParams.get("filter[Selling]") ?? null;
        countryRegistrationsStatusFilter = urlParams.get("filter[Status]") ?? null;
    }

    let productsLegalManufacturersFilter = null;
    let productsPhysicalManufacturersFilter = null;
    let productsSPPPsFilter = null;
    if (AppContext.entityType == "product-skus") {
        const urlParams = new URLSearchParams(window.location.search);
        productsLegalManufacturersFilter = urlParams.get("filter[LegalManufacturers]") ?? null;
        productsPhysicalManufacturersFilter = urlParams.get("filter[PhysicalManufacturers]") ?? null;
        productsSPPPsFilter = urlParams.get("filter[SPPPs]") ?? null;
    }

    // Same "?filter[CountryId]=<id> in the URL shows as a heading next to the page title"
    // pattern as countryregistrations above, for the Country cell links on the Submissions
    // Q&A list (see FieldType_CountryLink in FieldTypes.js).
    let submissionQACountryFilter = null;
    if (AppContext.entityType == "submissionqa") {
        const urlParams = new URLSearchParams(window.location.search);
        submissionQACountryFilter = urlParams.get("filter[CountryId]") ?? null;
    }

    const showProductsSubMenu =
        AppContext.entityType === "product-skus" ||
        AppContext.entityType === "product-family" ||
        UDI_ENTITY_TYPES.includes(AppContext.entityType);
    const showCMSubMenu =
        AppContext.entityType === "compliance-regulatorydocuments" ||
        AppContext.entityType === "compliance-standards" ||
        AppContext.entityType === "compliance-qms" ||
        AppContext.entityType === "compliance-technical-documents";
    const showTopMenuRow =
        showProductsSubMenu ||
        showCMSubMenu ||
        !!AppContext.showLegalManufacturerFilter;
    const toolbarHeader =
        typeof AppContext.dataTableStructure?.toolbarHeader === "function"
            ? AppContext.dataTableStructure.toolbarHeader()
            : AppContext.dataTableStructure?.toolbarHeader || null;
    const showHeaderActionsRow =
        !!toolbarHeader ||
        !!AppContext.showTotalAndFilteredCounts ||
        !!AppContext.showTaskCount ||
        AppContext.entityType === "product-skus" ||
        AppContext.entityType === "countryregistrations" ||
        !!AppContext.enableMultiItemAIChatPane ||
        !!AppContext.enableTimelineGraph ||
        !!AppContext.showExportButton ||
        (!!AppContext.showDeleteButton && AppContext.userRole == "Admin") ||
        !AppContext.hideAddButton;



    return (
        <div style={{ display: "flex", flexDirection: "row", marginBottom: "20px" }}>

            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>

                {AppContext.hideBreadcrumbs ? null : <>
                    <div style={{ width: "100%" }}>
                        <Breadcrumbs />
                    </div>
                </>}

                {AppContext.hideTitle ? null : <>
                    <div style={{ width: "100%", textAlign: "left", marginBottom: "10px" }}>
                        <div style={{display: "flex", flexDirection: "row"}}>
                            <div>
                                <h2
                                    className={`new-page-header-title${AppContext.showTitleAsSubTitle ? " new-page-header-title-as-subtitle" : ""}`}
                                    style={{ color: "#1a202c" }}
                                >
                                    <i className={`${AppContext.pageIcon}`} style={{color: "#2b6cb0"}}></i> {AppContext.pageTitle}
                                </h2>
                            </div>

                            {AppContext.entityType == "countryregistrations" && countryRegistrationsCountryFilter ?
                                <div>
                                    <h2 className="new-page-header-title" style={{ color: "#203864" }}>: <ShowRegistrationsFilterCountryName countryId={countryRegistrationsCountryFilter} /></h2>
                                </div>
                                : null}

                            {AppContext.entityType == "submissionqa" && submissionQACountryFilter ?
                                <div>
                                    <h2 className="new-page-header-title" style={{ color: "#203864" }}>: <ShowRegistrationsFilterCountryName countryId={submissionQACountryFilter} /></h2>
                                </div>
                                : null}


                            {AppContext.entityType == "product-skus" && productsLegalManufacturersFilter ?
                                <div>
                                    <h2 className="new-page-header-title" style={{ color: "#203864" }}>: <ShowProductsFilterLegalManufacturerName legalManufacturerId={productsLegalManufacturersFilter} /></h2></div>
                                : null}

                            {AppContext.entityType == "product-skus" && productsPhysicalManufacturersFilter ?
                                <div>
                                    <h2 className="new-page-header-title" style={{ color: "#203864" }}>: <ShowProductsFilterPhysicalManufacturerName physicalManufacturerId={productsPhysicalManufacturersFilter} /></h2> </div>
                                : null}

                            {AppContext.entityType == "product-skus" && productsSPPPsFilter ?
                                <div>
                                    <h2 className="new-page-header-title" style={{ color: "#203864" }}>: <ShowProductsFilterSPPPName SPPPId={productsSPPPsFilter} /></h2>
                                </div>
                                : null}
                        </div>
                        <div style={{marginTop:"20px"} }>
                            {AppContext.entityType == "countryregistrations" && countryRegistrationsProductsFilter ? 
                                <div>
                                <p className="new-page-header-filter" style={{ }}> <strong>Product:  </strong><ShowProductsFilterProductName productId={countryRegistrationsProductsFilter} /></p>
                                </div>
                                : null}
                            {AppContext.entityType == "countryregistrations" && countryRegistrationsSellingFilter ?
                                <div>
                                    <p className="new-page-header-filter" style={{}}> <strong>Selling:  </strong><FieldTypes.FieldType_CountryRegistrationSelling value={countryRegistrationsSellingFilter} /></p>
                                </div>
                                : null}

                            {AppContext.entityType == "countryregistrations" && countryRegistrationsStatusFilter ?
                                <div>
                                    <p className="new-page-header-filter" style={{}}> <strong>Registration Status:  </strong><FieldTypes.FieldType_RegistrationsStatus value={countryRegistrationsStatusFilter} /></p>
                                </div>
                                : null}
                        </div>
                    </div>
                </>}


                {!!AppContext?.pageDescription && (
                    <div style={{ width: "100%", textAlign: "left", marginBottom: "30px" }}>
                        <div dangerouslySetInnerHTML={{ __html: AppContext.pageDescription }} />
                    </div>
                )}
                {/* TOP HEADER / MENU ROW */}
                {showTopMenuRow ? (
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%", flexWrap: "wrap", gap: "20px" }}>

                    
                    {/* LEFT SIDE: SUBSMENUS */}
                    <div style={{ flex: 1 }}>
                        {showProductsSubMenu && (
                            <SubMenuProducts />
                        )}

                        {showCMSubMenu && (
                            <SubMenuCM />
                        )}
                    </div>

                    {/* RIGHT SIDE: LEGAL MANUFACTURER FILTER */}

                    {AppContext.showLegalManufacturerFilter && (
                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px", marginRight: "10px" }}>
                            <LegalManufacturerFilter />
                        </div>
                    )}


                </div>
                ) : null}

                {/* CONTENT */}


                {/* GRAPHS */}

                {AppContext.entityType == "compliance-regulatorydocuments" && <>
                    <GraphsForRegulatoryDocuments />
                </>}

                {AppContext.entityType == "compliance-standards" && <>
                    <GraphsForStandards />
                </>}

                {AppContext.entityType == "submissions" && <>
                    {!AppContext.hideTitle && <>
                        <div className="submenu-grid" style={{ marginBottom: "15px" }}>
                            <OpenSubmissionsKpiCard selected={true} />
                            <SubmissionQAKpiCard selected={false} />
                        </div>
                    </>}
                    <GraphsForSubmissions />
                </>}

                {AppContext.entityType == "submissionqa" && !AppContext.hideTitle && <>
                    <div className="submenu-grid" style={{ marginBottom: "15px" }}>
                        <OpenSubmissionsKpiCard selected={false} />
                        <SubmissionQAKpiCard selected={true} />
                    </div>
                </>}

                {AppContext.entityType == "systematic-review" && AppContext.srProjectIdFilter == null && <>
                    {AppContext.systematicReviewsHeader &&
                        <div dangerouslySetInnerHTML={{ __html: AppContext.systematicReviewsHeader }} />
                    }
                </>}






                {showHeaderActionsRow ? (
                <div className="row" style={{ marginTop: "10px", marginBottom: "15px", display: "flex", justifyContent: "right" }}>

                    <div style={{ display: "flex", alignItems: "center", marginRight: "auto" }}>
                    {/* TOTAL AND FILTERED COUNTS */}
                        {AppContext.showTotalAndFilteredCounts ? (
                            <div
                                style={{
                                    fontSize: "12px",
                                    display: "inline-block",
                                    padding: "4px 12px",
                                    borderRadius: "15px",
                                    marginLeft: "17px",
                                    border: "1px solid rgb(219, 219, 219)",
                                    backgroundColor: "rgb(247, 247, 247)",
                                }}
                            >
                                Total items:{" "}
                                {AppContext.updatingTotalCounts ? (
                                    <LoadingSpinnerImage />
                                ) : (
                                    <>
                                        <span
                                            style={{
                                                fontSize: "15px",
                                                fontWeight: 700,
                                                marginLeft: "7px",
                                                color: "#203864",
                                            }}
                                        >
                                            {AppContext.absoluteTotalCount}
                                        </span>

                                        {AppContext.absoluteTotalCount != AppContext.filteredTotalCount ? (
                                            <>
                                                <span
                                                    style={{
                                                        fontSize: "13px",
                                                        fontWeight: 500,
                                                        marginLeft: "12px",
                                                    }}
                                                >
                                                    {" "}
                                                    (Filtered: {AppContext.filteredTotalCount})
                                                </span>
                                            </>
                                        ) : null}
                                    </>
                                )}
                            </div>
                        ) : null}


               
                        {AppContext.entityType == "product-skus" ? (
                            <div
                                style={{
                                    fontSize: "12px",
                                    display: "inline-block",
                                    padding: "4px 12px",
                                    borderRadius: "15px",
                                    marginLeft: "17px",
                                    border: "1px solid rgb(219, 219, 219)",
                                    backgroundColor: "rgb(247, 247, 247)",
                                }}
                            >
                                Total products:{" "}
                                {AppContext.isUpdatingProductsCount ? (
                                    <LoadingSpinnerImage />
                                ) : (
                                    <>
                                        <span
                                            style={{
                                                fontSize: "15px",
                                                fontWeight: 700,
                                                marginLeft: "7px",
                                                color: "#203864",
                                            }}
                                        >
                                            {AppContext.productsCount}
                                        </span>

                                        {AppContext.filteredProductsCount != null ? (
                                            <>
                                                <span
                                                    style={{
                                                        fontSize: "13px",
                                                        fontWeight: 500,
                                                        marginLeft: "12px",
                                                    }}
                                                >
                                                    {" "}
                                                    (Filtered: {AppContext.filteredProductsCount})
                                                </span>
                                            </>
                                        ) : null}
                                    </>
                                )}
                            </div>
                        ) : null}


                        {AppContext.showTaskCount
                        ? <>

                            <div style={{ marginRight: "10px", marginLeft: "20px" }}>
                                <span className="task-action-btn pointer" onClick={() => AppContext.openTaskManagerForEntity()}>
                                    <i className="far fa-calendar-check"></i>
                                    <span>Open Tasks</span>
                                    <div
                                        className={`task-count-badge ${AppContext.taskCount > 0 ? "has-tasks" : "no-tasks"
                                            }`}
                                    >
                                        {AppContext.taskCount|| "0"}
                                    </div>
                                </span>
                            </div>
                        </> : null}



                        {AppContext.entityType == "countryregistrations" ?
                            <>
                                <RegistrationsExpirationFilter AppContext={AppContext} />

                                {countryRegistrationsCountryFilter ?
                                    <RegistrationsCountryNotes AppContext={AppContext} countryId={countryRegistrationsCountryFilter} />
                                    : null}
                            </>

                            : null}
                    </div>

                 








                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>

                        {AppContext.selectedReferences.length > 0 ?

                            (() => {
                                // Define the limit logic
                                const isOverLimit = AppContext.selectedReferences.length > 10;
                                const hasSelectionToolbarActions =
                                    AppContext.enableMultiItemAIChatPane ||
                                    AppContext.enableTimelineGraph ||
                                    (AppContext.showDeleteButton && AppContext.userRole == "Admin") ||
                                    AppContext.showExportButton;

                                if (!hasSelectionToolbarActions)
                                    return null;

                                return (
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <span style={{ fontWeight: "bold", marginRight: "10px" }}>
                                            {AppContext.selectedReferences.length} selected item(s)
                                        </span>

                                        {AppContext.enableMultiItemAIChatPane ?

                                            <div
                                                style={{
                                                    display: "flex",
                                                    textAlign: "center",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    marginRight: "15px",
                                                    minWidth: "100px",
                                                    position: "relative",
                                                }}
                                            >

                                                <span
                                                    title={isOverLimit ? "Max 10 references allowed" : ""}
                                                    onClick={isOverLimit ? null : handleMultipleItemsAIChatButtonClick}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <span
                                                        className={`medboard-ai-analyzer-button ${isOverLimit ? "disabled-btn" : "pointer"}`}
                                                        style={{ opacity: isOverLimit ? 0.5 : 1 }}
                                                    >
                                                        <img
                                                            src="/assets/images/stars-stroke-rounded-solid.svg"
                                                            className="ai-icon"
                                                            style={{
                                                                width: '19px',
                                                                marginTop: '-3px',
                                                                marginRight: '5px',
                                                                filter: isOverLimit ? 'grayscale(1)' : 'none'
                                                            }}
                                                            alt="AI icon"
                                                        />
                                                        Ask AI
                                                    </span>
                                                </span>
                                            </div>

                                            : null}


                                        {AppContext.enableTimelineGraph ?

                                            <div
                                                style={{
                                                    display: "flex",
                                                    textAlign: "center",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    marginRight: "15px",
                                                    minWidth: "100px",
                                                    position: "relative",
                                                }}
                                            >

                                                <span
                                                    onClick={handleTimelineButtonClick}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <span
                                                        className={`medboard-ai-analyzer-button pointer`}
                                                    >
                                                        <i className="fas fa-poll-h g-mr-8"></i> Timelines
                                                    </span>
                                                </span>

                                            </div>

                                            : null}




                                        {AppContext.showDeleteButton && AppContext.userRole == "Admin" ? (
                                            <div style={{ display: "inline-flex", marginRight: "15px" }}>
                                                <span
                                                    className="pointer"
                                                    style={{ ...buttonStyle, color: "#b71b11" }}
                                                    onClick={() => showActionPopup("delete")}
                                                >
                                                    <i className="fas fa-trash-alt g-mr-8" style={{ marginRight: '8px' }}></i> Delete
                                                </span>
                                            </div>
                                        ) : null}

                                        {AppContext.showExportButton ? (
                                            <div style={{ display: "inline-flex", marginRight: "15px" }}>
                                                <span
                                                    className="pointer"
                                                    style={buttonStyle}
                                                    onClick={() => showActionPopup("export")}
                                                >
                                                    <i className={`fas ${AppContext.hideExcelExport ? "fa-file-code" : "fa-file-excel"} g-mr-8`} style={{ marginRight: '8px' }}></i> Export
                                                </span>
                                            </div>
                                        ) : null}



                                    </div>
                                );
                            })()


                            :


                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>


                                {AppContext.enableMultiItemAIChatPane ?

                                    <div
                                        style={{
                                            display: "flex",
                                            textAlign: "center",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            marginRight: "15px",
                                            minWidth: "100px",
                                            position: "relative",
                                        }}
                                    >

                                        <span
                                            title="Please select 1..10 items to Ask AI"
                                            style={{ cursor: 'help' }}
                                        >
                                            <span
                                                style={{
                                                    padding: "5px 20px",
                                                    borderRadius: "15px",
                                                    background: "#f0f0f0",
                                                    color: "#313149",
                                                    border: "2px solid #ccc",
                                                    display: "inline-block",
                                                    opacity: "0.5"
                                                }}
                                            >
                                                <img
                                                    src="/assets/images/stars-stroke-rounded-solid.svg"
                                                    className="ai-icon"
                                                    style={{
                                                        width: '19px',
                                                        marginTop: '-3px',
                                                        marginRight: '5px',
                                                        filter: 'grayscale(1)'
                                                    }}
                                                    alt="AI icon"
                                                />
                                                Ask AI
                                            </span>
                                        </span>
                                    </div>

                                    : null}




                                {AppContext.enableTimelineGraph ?

                                    <div
                                        style={{
                                            display: "flex",
                                            textAlign: "center",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            marginRight: "15px",
                                            minWidth: "100px",
                                            position: "relative",
                                            opacity: "0.5"
                                        }}
                                    >

                                        <span
                                            title="Please select at least one item to view the timelines"
                                            style={{ cursor: 'help' }}
                                        >
                                            <span
                                                style={{
                                                    padding: "5px 20px",
                                                    borderRadius: "15px",
                                                    background: "#f0f0f0",
                                                    color: "#313149",
                                                    border: "2px solid #ccc",
                                                    display: "inline-block",
                                                }}
                                            >
                                                <i className="fas fa-poll-h g-mr-8"></i> Timelines
                                            </span>
                                        </span>

                                    </div>

                                    : null}




                                {AppContext.showExportButton && AppContext.entityType != "countryregistrations" ? (
                                    <div style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        marginRight: "25px"
                                    }}>
                                        <span
                                            title="Please select at least one item to export"
                                            style={disabledButtonStyle}
                                        >
                                            <i
                                                className={`fas ${AppContext.hideExcelExport ? "fa-file-code" : "fa-file-excel"}`}
                                                style={{ marginRight: '8px' }}
                                            ></i>
                                            Export
                                        </span>
                                    </div>
                                ) : null}



                                {/* If it's country registrations how the export all/delete all buttons if no item is selected */}

                                {AppContext.entityType == "countryregistrations" ?

                                    <div>
                                        {AppContext.userRole == "Admin" ? 
                                        
                                            <div style={{ display: "inline-flex", marginRight: "15px" }}>
                                                <span
                                                    className="pointer"
                                                    style={{ ...buttonStyle, color: "#b71b11" }}
                                                    onClick={() => showActionPopup("countryregistrations-deleteall")}
                                                >
                                                    <i className="fas fa-trash-alt g-mr-8" style={{ marginRight: '8px' }}></i> Delete all ({AppContext.listTotalCount})
                                                </span>
                                            </div>

                                        : null}

                                        <div style={{ display: "inline-flex", marginRight: "15px" }}>
                                            <span
                                                className="pointer"
                                                style={buttonStyle}
                                                onClick={() => showActionPopup("countryregistrations-exportall")}
                                            >
                                                <i className="fas fa-file-excel g-mr-8" style={{ marginRight: '8px' }}></i> Export all ({AppContext.listTotalCount})
                                            </span>
                                        </div>
                                    </div>
                                
                                : null}



                            </div>
                        }





                    </div>

                    {/* Add Item */}

                    {AppContext.hideAddButton ? null :
                        <div
                            style={{
                                display: "flex", textAlign: "center", justifyContent: "center", marginRight: "17px", alignItems: "center"
                            }}
                        >


                            {AppContext.reachedAllowance ? <>

                                <span>
                                    <span className="action-button add-task-button" style={{ backgroundColor: "#c0c0c0", cursor: "help" }} title="Allowance limit reached. Contact MedBoard to increase the limit.">
                                        <i className="fas fa-plus-circle g-mr-5"></i> Add {AppContext.singleItemTitle}
                                    </span>
                                </span>

                            </> : <>

                                {AppContext.userRole == "Admin" ? <>

                                    {AppContext.entityType == "systematic-review" ? <>

                                        {
                                            (() => {
                                                const SrAddButton = AppContext.srAddButton;

                                                const redirectToProjects = () => {
                                                    window.location = AppContext.srProjectPageUrl;
                                                }

                                                return <>

                                                    {AppContext.srProjectIdFilter != null ? <>
                                                        <SrProjectAddSrButton GlobalAppContext={AppContext} />
                                                    </> : <>
                                                        <span onClick={redirectToProjects}>
                                                            <span className="btn btn-outline-primary other-button" style={{ marginRight: "10px" }}>
                                                                <i className="fas fa-layer-group g-mr-5"></i> SR Groups
                                                            </span>
                                                        </span>
                                                    </>}

                                                    <SrAddButton GlobalAppContext={AppContext} />
                                                </>
                                            })()
                                        }

                                    </> : <>

                                        {AppContext.entityType == "compliance-technical-documents" ? <>

                                            <span className="action-button add-task-button g-mr-5" onClick={() => AppContext.setIsVisibleTechnicalDocumentationTemplates(true)}>Templates</span>
                                            <span className="action-button add-task-button g-mr-5" onClick={() => AppContext.setIsVisibleTechnicalDocumentationJurisdictions(true)}>Jurisdictions</span>

                                        </> : null}



                                        <span onClick={AppContext.showAddItemPopup}>
                                            <span className="action-button add-task-button">
                                                <i className="fas fa-plus-circle g-mr-5"></i> Add {AppContext.singleItemTitle}
                                            </span>
                                        </span>

                                    </>}

                                </> : <>
                                    <span>
                                        <span className="action-button add-task-button" style={{ backgroundColor: "#c0c0c0" }} title="No permission. Check with your Admin.">
                                            <i className="fas fa-plus-circle g-mr-5"></i> Add {AppContext.singleItemTitle}
                                        </span>
                                    </span>
                                </>}


                            </>}





                        </div>
                    }

                    {toolbarHeader}





                    {/* CUSTOM MENU BAR */}

                    {AppContext.entityType == "submissions" ? <>

                        <AppContext.CustomMenuBar context={AppContext} />

                    </> : null}





                </div>
                ) : null}




                {/* Legal Manufacturer general filter warning */}

                {AppContext.currentLegalManufacturerFilter != null && AppContext.currentLegalManufacturerFilter != undefined && AppContext.currentLegalManufacturerFilter != -1 ? <>
                    <div style={{ display: "flex", flexDirection: "row", width: "100%", marginTop: "10px", marginBottom: "15px" }}>
                        <span className="filtered-by-legal-manufacturer-tag">
                                <i className="fas fa-info-circle"></i> This list is filtered by legal manufacturer "<strong>{AppContext.currentLegalManufacturerNameFilter}</strong>". Change it <a href="/your-medboard/country-registrations/">here</a>
                            </span>
                    </div>
                </> : null}





                {/* SEARCH AND FILTERS */}


                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", flexWrap: "nowrap", width: "100%", gap: "10px" }}>

                    <div
                        style={{
                            display: "flex",
                            flexGrow: 1,
                            alignItems: "center",
                            minWidth: 0,
                        }}
                    >
                        {/* Search */}

                        {AppContext.hideSearchBar ? null : 
                            <div className="search-input">
                                <span className="search-icon">
                                    <i className="fas fa-search"></i>
                                </span>
                                <input
                                    placeholder={AppContext.searchPlaceholder || (`Search ` + AppContext.singleItemTitle)}
                                    value={AppContext.itemSearchText}
                                    autoComplete="off"
                                    onChange={(e) => {
                                        let text = e.target.value;
                                        AppContext.setItemSearchText(text);
                                        AppContext.doTextSearchTask({ localSearch: text });

                                    }}
                                />
                            </div>
                        }

                        {typeof AppContext.dataTableStructure?.toolbarAfterSearch === "function"
                            ? AppContext.dataTableStructure.toolbarAfterSearch()
                            : AppContext.dataTableStructure?.toolbarAfterSearch || null}

                        {/* Compliance Status Filter */}

                        {AppContext.showComplianceStatusFilter ? <FilterComplianceStatus /> : null}

                        {/* Submissions Status Filter */}

                        {AppContext.showSubmissionsStatusFilter ? <FilterSubmissionsStatus /> : null}

                        {/* Country Filter */}

                        {AppContext.showCountryFilter ? <FilterCountry /> : null}

                        {/* Publication Type Filter */}

                        {AppContext.showPublicationTypeFilter ? <FilterPublicationTypeFilter /> : null}

                        {/* Regulatory Area Filter */}

                        {AppContext.showRegulatoryAreaFilter ? <FilterRegulatoryAreaFilter /> : null}

                        {/* Submissions Type Filter */}

                        {AppContext.showSubmissionsTypeFilter ? <FilterSubmissionsType /> : null}

                        {/* Systematic Reviews Company/User Filter */}

                        {AppContext.showSystematicReviewsCompanyUserFilter ? <FilterSystematicReviewsCompanyUser /> : null}

                        {/* SR Projects Company/User Filter */}

                        {AppContext.showSRProjectsCompanyUserFilter ? <FilterSRProjectsCompanyUser /> : null}

                        {/* SR Projects Archive Filter */}

                        {AppContext.showSRProjectsArchiveFilter ? <FilterSRProjectsArchive /> : null}

                        {/* RIMS Filter (rims objects: product, family, country, operator, certificate */}


                        {AppContext.showProductsArchiveFilter ? <FilterProductsArchive /> : null}

                        {AppContext.filterBarControls}


                        {AppContext.showCMArchiveFilter ? <FilterCMArchive /> : null}






                        {AppContext.itemSearchText != "" ||
                            AppContext.selectedFilterComplianceStatus != "" ||
                            AppContext.selectedFilterSubmissionsStatus != "" ||
                            AppContext.selectedFilterCountry != "" ||
                            AppContext.selectedFilterPublicationType != "" ||
                            AppContext.selectedFilterRegulatoryArea != "" ||
                            AppContext.selectedFilterSubmissionsType != "" ? <>

                            <ClearAllFiltersButton />

                        </> : null}

                    </div>






                    {AppContext.showRIMSFilter ?
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginRight: "15px", }} >
                            <RIMSFilter entityTypeId={AppContext.entityTypeId} legalManufacturerId={AppContext.currentLegalManufacturerFilter} area={AppContext.selectedFilterSystematicReviewsArea} archive={AppContext.showCMArchiveFilter ? AppContext.selectedFilterCMArchive : null} currentFilters={AppContext.currentRIMSFilters} searchCallback={AppContext.rimsSearchCallback} />
                        </div>
                        : null}



                    {AppContext.enableTags ?
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", }} >
                            <TagFilter context={AppContext} objectType={AppContext.entityType} />
                        </div>
                        :
                        null
                    }

                    {AppContext.enableCustomFields ? (
                        <div style={{ flexShrink: 0 }}>
                            <ColumnsConfiguration context={AppContext} entityTypeId={AppContext.entityTypeId} ReloadStructureFunction={AppContext.ReloadStructureFunction} />
                        </div>
                    ) : null}


                </div>
            </div>
        </div>
    );
};



const ClearAllFiltersButton = () => {

    const AppContext = useContext(GlobalAppContext);

    let clearAllFilters = () => {

        AppContext.clearAllFilters();
    }

    return (

        <div style={{ marginLeft: "15px" }}>
            <span onClick={() => clearAllFilters()} style={{ whiteSpace: "nowrap", display: "inline-block", padding: "7px 8px", borderRadius: "5px", border: "1px solid #c0c0c0", cursor: "pointer" }} >
            X
            </span>
        </div>

    );

}



const SrProjectAddSrButton = () => {

    const AppContext = useContext(GlobalAppContext);

    const [isShowingSrsList, setIsShowingSrsList] = useState(false);
    const [SRList, setSRList] = useState([]);
    const [selectedSystematicReviewId, setSelectedSystematicReviewId] = useState(null);
    const [isAdding, setIsAdding] = useState(false);
    const [added, setAdded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    let currentType = useRef(null);


    useEffect(() => {

        refreshSRList();

    }, [])



    const refreshSRList = () => {

        setSelectedSystematicReviewId(null);
        
        let url = AppContext.srApiUrl + "SystematicReviewsAll";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsLoading(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                setSRList(result);

                // preselect first item
                if (result.length > 0)
                    setSelectedSystematicReviewId(result[0].Id);

            })
            .catch((error) => {
                setError(true);
                console.log(error)
            })
            .finally(() => {
                setIsLoading(false);
            });


    }


    const addSrToProject = () => {

        let url = AppContext.srProjectApiUrl + "ProjectsSRs/?id=" + AppContext.srProjectIdFilter + "&srId=" + selectedSystematicReviewId;

        let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        };

        setIsAdding(true);
        setError(false);
        setAdded(false);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                // Add new sr to list
                if(!AppContext.data.find(item => item.Id == result.Id))
                    AppContext.setData([result, ...AppContext.data]);

                setAdded(true);
            })
            .catch((error) => {
                setError(true);
                console.log(error)
            })
            .finally(() => {
                setIsAdding(false);
            });

    }


    const closePopup = () => {

        setError(null);
        setAdded(false);
        setIsShowingSrsList(false);

    }



    return (<>
        <span onClick={() => setIsShowingSrsList(true)}>
            <span className="action-button add-task-button" style={{marginRight: "10px"}}>
                Add Existing Systematic Review
            </span>
        </span>

        {isShowingSrsList ? <>

            <div className="add-task-popup">
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "50%", textAlign: "left" }}>
                        <h3>Add Existing Systematic Review to Group</h3>
                    </div>
                    <div style={{ width: "50%", textAlign: "right" }}>
                        <button
                            className="close-button"
                            onClick={() => closePopup()}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>




                <div style={{marginBottom: "45px", marginTop: "25px"}}>

                    {isLoading ? <LoadingSpinnerImage /> : <>

                        <select
                            value={selectedSystematicReviewId}
                            onChange={(e) => setSelectedSystematicReviewId(e.target.value)}
                            className="sr-create-form-dropdown"
                        >
                            {SRList.reduce((groups, item) => {
                                let group = groups.find(g => g.alias === item.Alias);
                                if (!group) {
                                    group = { alias: item.Alias, items: [] };
                                    groups.push(group);
                                }
                                group.items.push(item);
                                return groups;
                            }, [])
                                .map(group => (
                                <optgroup key={group.alias} label={group.alias}>
                                    {group.items.map(opt => (
                                        <option key={opt.Id} value={opt.Id}>{opt.Title}</option>
                                    ))}
                                </optgroup>
                            ))}
                        </select>

                    </>}

                    {error && <div className="form-field-error-message">An error occured while adding the Systematic Review to the Project</div>}
                    {added && <div className="form-field-success-message">Added successfully!</div>}

                </div>



                
                {/* BUTTONS */}

                <div className="action-button-bar">
                    <div className="action-button-bar-left">
                        <button
                            className="action-button cancel-button"
                            onClick={() => closePopup()}
                        >
                            Close
                        </button>
                    </div>
                    <div className="action-button-bar-center"></div>
                    <div className="action-button-bar-right">

                        {isAdding? 
                        <>
                            <LoadingSpinnerImage />
                        </> : <>
                            <button
                            className="action-button save-button"
                            onClick={() => addSrToProject()}
                        >
                            Add to SR Group
                            </button>
                        </>}

                    </div>
                </div>



            </div>

        </> : null}

    </>);

}








const FilterSRProjectsArchive = () => {

    const AppContext = useContext(GlobalAppContext);

    let handleFilterChange = (value) => {

        AppContext.applyFilterSrProjectsArchive(value);

    }

    return (

        <div style={{ marginLeft: "15px" }}>

            {AppContext.isChoosingSrProjectsArchiveFilter ? <>

                <select value={AppContext.selectedFilterSrProjectsArchive} onChange={(e) => handleFilterChange(e.target.value)} style={{ width: "125px" }}>
                    <option value="false">Active</option>
                    <option value="true">Archived</option>
                </select>

            </> : <>

                <span onClick={() => AppContext.setIsChoosingSrProjectsArchiveFilter(true)} style={{
                    whiteSpace: "nowrap", display: "inline-block", padding: "7px 8px", borderRadius: "5px", border: "1px solid #c0c0c0", cursor: "pointer"
                }} >
                    {AppContext.selectedFilterSrProjectsArchive === "false" ? <>

                        Active

                    </> : <>

                        Archived

                    </>}

                </span>

            </>}

        </div>
    );

}


const filterBaseStyle = {
    whiteSpace: "nowrap",
    display: "inline-flex",
    alignItems: "center",
    padding: "6px 14px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
};

export const inactiveStyle = {
    ...filterBaseStyle,
    color: "#5f6368",
    border: "1px solid #a0aec0",
    backgroundColor: "#ffffff",
};

export const activeStyle = {
    ...filterBaseStyle,
    color: "#203864",
    border: "1px solid #a0aec0",
    backgroundColor: "#e8f0fe", 
};

const FilterProductsArchive = () => {

    const AppContext = useContext(GlobalAppContext);

    let handleFilterChange = (value) => {

        AppContext.applyFilterProductsArchive(value);

    }

    return (

        <div style={{ marginLeft: "15px", display: "flex", alignItems: "center", gap: "4px" }}>
            {/* Active Products Toggle */}
            <span
                onClick={() => handleFilterChange("false")}
                style={AppContext.selectedFilterProductsArchive === "false" ? activeStyle : inactiveStyle}
            >
                <i
                    className={AppContext.selectedFilterProductsArchive === "false" ? "fas fa-check-square" : "far fa-square"}
                    style={{ marginRight: '6px', fontSize: '12px' }}
                ></i>
                Active Products
            </span>

            {/* Archived Products Toggle */}
            <span
                onClick={() => handleFilterChange("true")}
                style={AppContext.selectedFilterProductsArchive === "true" ? activeStyle : inactiveStyle}
            >
                <i
                    className={AppContext.selectedFilterProductsArchive === "true" ? "fas fa-check-square" : "far fa-square"}
                    style={{ marginRight: '6px', fontSize: '12px' }}
                ></i>
                Archived
            </span>
        </div>
    );

}

const FilterCMArchive = () => {

    const AppContext = useContext(GlobalAppContext);

    let handleFilterChange = (value) => {

        AppContext.applyFilterCMArchive(value);

    }

    return (

        <div style={{ marginLeft: "15px", display: "flex", alignItems: "center", gap: "4px" }}>
            { }
            <span
                onClick={() => handleFilterChange("false")}
                style={AppContext.selectedFilterCMArchive === "false" ? activeStyle : inactiveStyle}
            >
                <i
                    className={AppContext.selectedFilterCMArchive === "false" ? "fas fa-check-square" : "far fa-square"}
                    style={{ marginRight: '6px', fontSize: '12px' }}
                ></i>
                Active (In scope)
            </span>

            {/* Archived CM Toggle */}
            <span
                onClick={() => handleFilterChange("true")}
                style={AppContext.selectedFilterCMArchive === "true" ? activeStyle : inactiveStyle}
            >
                <i
                    className={AppContext.selectedFilterCMArchive === "true" ? "fas fa-check-square" : "far fa-square"}
                    style={{ marginRight: '6px', fontSize: '12px' }}
                ></i>
                Archived
            </span>
        </div>
    );

}


const FilterSRProjectsCompanyUser = () => {

    const AppContext = useContext(GlobalAppContext);


    const changeFilter = (status) => {

        let mineOnly;

        if (status == "mine")
            mineOnly = true;
        else
            mineOnly = false;

        AppContext.setSelectedFilterSRProjectsShowMineOnly(mineOnly);

        AppContext.refreshData();
    }


    return (<>

        <span className="show-mine-team-block">
            <span onClick={() => changeFilter("mine")} title="Show only my groups" className={`show-only-mine ${AppContext.selectedFilterSRProjectsShowMineOnly == false ? "show-mine-team-unselected" : null}`}><i className="fas fa-user"></i></span>
            <span onClick={() => changeFilter("all")} title="Show everyone's groups" className={`show-mine-and-team ${AppContext.selectedFilterSRProjectsShowMineOnly == true ? "show-mine-team-unselected" : null}`}><i className="fas fa-users"></i></span>
        </span>

    </>);

}



const FilterSystematicReviewsCompanyUser = () => {

    const AppContext = useContext(GlobalAppContext);


    const changeFilter = (status) => {

        let mineOnly;

        if (status == "mine")
            mineOnly = true;
        else
            mineOnly = false;

        AppContext.setSelectedFilterSystematicReviewsShowMineOnly(mineOnly);

        AppContext.loadData({
            localFilterSystematicReviewsShowMineOnly: mineOnly,
        });
    }


    return (<>

        <span className="show-mine-team-block">
            <span onClick={() => changeFilter("mine")} title="Show only my systematic reviews" className={`show-only-mine ${AppContext.selectedFilterSystematicReviewsShowMineOnly == false ? "show-mine-team-unselected" : null}`}><i className="fas fa-user"></i></span>
            <span onClick={() => changeFilter("all")} title="Show everyone's systematic reviews" className={`show-mine-and-team ${AppContext.selectedFilterSystematicReviewsShowMineOnly == true ? "show-mine-team-unselected" : null}`}><i className="fas fa-users"></i></span>
        </span>

    </>);

}



const FilterComplianceStatus = () => {

    const AppContext = useContext(GlobalAppContext);

    let handleFilterChange = (value) => {

        AppContext.applyFilterComplianceStatus(value);

    }

    return (

        <div style={{ marginLeft: "15px" }}>

            {AppContext.isChoosingComplianceStatusFilter ? <>

                <select value={AppContext.selectedFilterComplianceStatus} onChange={(e) => handleFilterChange(e.target.value)} style={{ width: "125px" }}>
                    <option value="">All statuses</option>
                    {AppContext.filterOptions_Status.map((item, index) => (
                        <option key={index} value={item.Id} >{item.Name}</option>
                    ))
                    }
                </select>

            </> : <>

                <span onClick={() => AppContext.setIsChoosingComplianceStatusFilter(true)} style={{
                    whiteSpace: "nowrap", display: "inline-block", padding: "7px 8px", borderRadius: "5px", border: "1px solid #c0c0c0", cursor: "pointer"
                }} >
                    {AppContext.selectedFilterComplianceStatus === "" ? <>
                            <i className="fas fa-filter g-pr-4" style={{ fontSize: "11px", color: "#585f69" }}></i>  Status

                    </> : <>

                        {AppContext.filterOptions_Status.find((item) => item.Id == AppContext.selectedFilterComplianceStatus)?.Name}

                    </>}

                </span>

            </>}

        </div>
    );

}



const FilterSubmissionsStatus = () => {

    const AppContext = useContext(GlobalAppContext);

    let handleFilterChange = (value) => {

        AppContext.applyFilterSubmissionsStatus(value);

    }

    let isOpenTypeCurrently = AppContext.selectedFilterSubmissionsOpen == "true";
    let allStatusesLabel = isOpenTypeCurrently ? "Open" : "Completed";

    return (

        <div style={{ marginLeft: "15px" }}>

            {AppContext.isChoosingSubmissionsStatusFilter ? <>

                <select value={AppContext.selectedFilterSubmissionsStatus} onChange={(e) => handleFilterChange(e.target.value)} style={{ width: "125px" }}>
                    <option value="">All `{allStatusesLabel}` statuses</option>
                    {AppContext.filterOptions_Status.filter(item => item.isOpenType == isOpenTypeCurrently).map((item, index) => (
                        <option key={index} value={item.Id} >{item.Name}</option>
                    ))
                    }
                </select>

            </> : <>

                <span onClick={() => AppContext.setIsChoosingSubmissionsStatusFilter(true)} style={{
                    whiteSpace: "nowrap", display: "inline-block", padding: "7px 8px", borderRadius: "5px", border: "1px solid #c0c0c0", cursor: "pointer"
                }} >
                    {AppContext.selectedFilterSubmissionsStatus === "" ? <>

                            <i className="fas fa-filter g-pr-4" style={{ fontSize: "11px", color: "#585f69" }}></i>  Status

                    </> : <>

                        {AppContext.filterOptions_Status.find((item) => item.Id == AppContext.selectedFilterSubmissionsStatus)?.Name}

                    </>}

                </span>

            </>}

        </div>
    );

}



const FilterSubmissionsType = () => {

    const AppContext = useContext(GlobalAppContext);

    let handleFilterChange = (value) => {

        AppContext.applyFilterSubmissionsType(value);

    }

    return (

        <div style={{ marginLeft: "15px" }}>

            {AppContext.isChoosingSubmissionsTypeFilter ? <>

                <select value={AppContext.selectedFilterSubmissionsType} onChange={(e) => handleFilterChange(e.target.value)} style={{ width: "125px" }}>
                    <option value="">All types</option>
                    {AppContext.filterOptions_Types.map((item, index) => (
                        <option key={index} value={item.Id} >{item.Name}</option>
                    ))
                    }
                </select>

            </> : <>

                    <span onClick={() => AppContext.setIsChoosingSubmissionsTypeFilter(true)} style={{
                    whiteSpace: "nowrap", display: "inline-block", padding: "7px 8px", borderRadius: "5px", border: "1px solid #c0c0c0", cursor: "pointer"
                }} >
                    {AppContext.selectedFilterSubmissionsType === "" ? <>

                            <i className="fas fa-filter g-pr-4" style={{ fontSize: "11px", color: "#585f69" }}></i> Types

                    </> : <>

                        {AppContext.filterOptions_Types.find((item) => item.Id == AppContext.selectedFilterSubmissionsType)?.Name}

                    </>}

                </span>

            </>}

        </div>
    );


}



const FilterCountry = () => {

    const AppContext = useContext(GlobalAppContext);

    let handleFilterChange = (value) => {

        AppContext.applyFilterCountry(value);

    }

    return (

        <div style={{ marginLeft: "15px" }}>

            {AppContext.isChoosingCountryFilter ? <>

                <select value={AppContext.selectedFilterCountry} onChange={(e) => handleFilterChange(e.target.value)} style={{ width: "125px" }}>
                    <option value="">All countries</option>
                    {AppContext.filterOptions_Countries.map((item, index) => ( 
                        <option key={index} value={item.CountryId} >{item.CountryName}</option>
                    ))
                    }
                </select>

            </> : <>

                <span onClick={() => AppContext.setIsChoosingCountryFilter(true)} style={{
                    whiteSpace: "nowrap", display: "inline-block", padding: "7px 8px", borderRadius: "5px", border: "1px solid #c0c0c0", cursor: "pointer"
                }} >
                    {AppContext.selectedFilterCountry === "" ? <>

                            <i className="fas fa-filter g-pr-4" style={{ fontSize: "11px", color: "#585f69" }}></i>  Countries

                    </> : <>

                        {AppContext.filterOptions_Countries.find((item) => item.CountryId == AppContext.selectedFilterCountry)?.CountryName} 

                    </>}

                </span>

            </>}

        </div>
    );
}



const FilterPublicationTypeFilter = () => {

    const AppContext = useContext(GlobalAppContext);

    let handleFilterChange = (value) => {

        AppContext.applyFilterPublicationType(value);

    }

    return (

        <div style={{ marginLeft: "15px" }}>

            {AppContext.isChoosingPublicationTypeFilter ? <>

                <select value={AppContext.selectedFilterPublicationType} onChange={(e) => handleFilterChange(e.target.value)} style={{ width: "125px" }}>
                    <option value="">All types</option>
                    {AppContext.filterOptions_PublicationTypes.map((item, index) => (
                        <option key={index} value={item.TypeId} >{item.TypeName}</option>
                    ))
                    }
                </select>

            </> : <>

                <span onClick={() => AppContext.setIsChoosingPublicationTypeFilter(true)} style={{
                    whiteSpace: "nowrap", display: "inline-block", padding: "7px 8px", borderRadius: "5px", border: "1px solid #c0c0c0", cursor: "pointer"
                }} >
                    {AppContext.selectedFilterPublicationType === "" ? <>

                            <i className="fas fa-filter g-pr-4" style={{ fontSize: "11px", color: "#585f69" }}></i>  Types

                    </> : <>

                                {AppContext.filterOptions_PublicationTypes.find((item) => item.TypeId == AppContext.selectedFilterPublicationType)?.TypeName}

                    </>}

                </span>

            </>}

        </div>
    );

}



const FilterRegulatoryAreaFilter = () => {

    const AppContext = useContext(GlobalAppContext);

    let handleFilterChange = (value) => {

        AppContext.applyFilterRegulatoryArea(value);

    }

    return (

        <div style={{ marginLeft: "15px" }}>

            {AppContext.isChoosingRegulatoryAreaFilter ? <>

                <select value={AppContext.selectedFilterRegulatoryArea} onChange={(e) => handleFilterChange(e.target.value)} style={{ width: "125px" }}>
                    <option value="">All regulatory areas</option>
                    {AppContext.filterOptions_RegulatoryAreas.map((item, index) => (
                        <option key={index} value={item.RegAreaId} >{item.RegAreaName}</option>
                    ))
                    }
                </select>

            </> : <>

                <span onClick={() => AppContext.setIsChoosingRegulatoryAreaFilter(true)} style={{
                    whiteSpace: "nowrap", display: "inline-block", padding: "7px 8px", borderRadius: "5px", border: "1px solid #c0c0c0", cursor: "pointer"
                }} >
                    {AppContext.selectedFilterRegulatoryArea === "" ? <>

                            <i className="fas fa-filter g-pr-4" style={{ fontSize: "11px", color: "#585f69" }}></i> Regulatory areas

                    </> : <>

                        {AppContext.filterOptions_RegulatoryAreas.find((item) => item.RegAreaId == AppContext.selectedFilterRegulatoryArea)?.RegAreaName}

                    </>}

                </span>

            </>}

        </div>
    );

}



const DefaultAddItemPopup = () => {
    const AppContext = useContext(GlobalAppContext);

    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Add {AppContext.singleItemTitle}</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>
            <input
                value={AppContext.addItemName}
                className={`form-field-text ${AppContext.errorAddItemName ? "form-field-error" : null
                    }`}
                onChange={(e) => AppContext.setAddItemName(e.target.value)}
                style={{ width: "100%" }}
                type="text"
                placeholder={AppContext.singleItemTitle}
            />
            {AppContext.errorAddItemName && (
                <span className="form-field-error-message">
                    This field is necessary
                </span>
            )}
            <br />
            <br />

            <div className="action-button-bar">
                <div className="action-button-bar-left">
                    {AppContext.isAddingItem ? (
                        <LoadingSpinnerImage />
                    ) : (
                        <button
                            className="action-button save-button"
                            onClick={AppContext.addItem}
                        >
                            Add {AppContext.singleItemTitle}
                        </button>
                    )}
                </div>

                <div className="action-button-bar-center"></div>

                <div className="action-button-bar-right">
                    <button
                        className="action-button cancel-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        Cancel
                    </button>
                </div>
            </div>




        </div>
    );
};





const DeleteSelectedReferencesPopup = () => {


    const AppContext = useContext(GlobalAppContext);


    const getDisplayName = (r, entityType) => {
        if (entityType === "product-skus") return r.ProductName;
        if (entityType === "countryregistrations") return `${r.ProductName} - ${r.CountryName}`;
        if (entityType === "change-assessments") return `${r.Title}`;
        if (entityType === "submissions") return `${r.Title}`;
        return r.Name;
    };

    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px" }}>


                <div style={{ width: "50%" }}>
                    <h3>Delete {AppContext.selectedReferences.length && AppContext.selectedReferences.length > 0 ? AppContext.selectedReferences.length + " selected reference(s)" : " All"}</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => { AppContext.setShowDeleteSelectedReferencesPopup(false); }}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

            </div>

            <div style={{ textAlign: "center", marginTop: "25px", marginBottom: "25px" }}>

                {AppContext.selectedReferences.length > 0 && <>

                    <div style={{ marginBottom: "15px" }}>
                        You are about to delete the following items:
                    </div>


                    <div className="thin-scrollbar" style={{ maxHeight: "250px", overflowY: "auto" }}>

                        {(AppContext.getSelectedRowsForDisplay
                            ? AppContext.getSelectedRowsForDisplay()
                            : AppContext.data.filter(r => AppContext.selectedReferences.includes(r.Id))
                        ).map((r, index) => (

                            <div key={index} style={{ marginBottom: "10px", padding: "5px", backgroundColor: "#f2f2f2" }}>
                                {getDisplayName(r, AppContext.entityType)}
                            </div>

                        ))}

                    </div>

                    <br />

                </>}



                <div style={{ marginTop: "15px" }}>

                    {AppContext.isDeleting ? <>

                        <LoadingSpinnerImage />

                    </> : <>

                        {AppContext.errorDeleting && <>
                                <div style={{ marginBottom: "15px", fontWeight: "bold" }}>
                                An error occurred. Please try again
                            </div>
                        </>}

                        {AppContext.successDeleting ? <>
                            <div style={{ marginBottom: "15px", fontWeight: "bold" }}>
                                The items were deleted successfully
                            </div>
                        </> : <>

                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center"
                            }}>
                                <div>
                                    <button className="action-button save-button" onClick={() => AppContext.deleteSelectedItems()}>Delete</button>
                                </div>
                            </div>


                        </>

                        }

                    </>}

                </div>

            </div>

        </div>
    );

}






const ExportSelectedReferencesPopup = () => {


    const AppContext = useContext(GlobalAppContext);
    const [selectedEudamedService, setSelectedEudamedService] = useState(0);
    const [showEudamedOptions, setShowEudamedOptions] = useState(!!AppContext.hideExcelExport);

    const getDisplayName = (r, entityType) => {
        if (entityType === "product-skus") return r.ProductName;
        if (entityType === "submissions") return r.Title;
        if (entityType === "countryregistrations") return `${r.ProductName} - ${r.CountryName}`;
        if (UDI_ENTITY_TYPES.includes(entityType)) return `${r.SKUProductCode} - ${r.UDI_DI}`;
        return r.Name;
    };

    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px" }}>


                <div style={{ width: "50%" }}>
                    <h3>Export {AppContext.selectedReferences.length && AppContext.selectedReferences.length > 0 ? AppContext.selectedReferences.length + " selected reference(s)" : " All"}</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => { AppContext.setShowExportSelectedReferencesPopup(false); }}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

            </div>

            <div style={{ textAlign: "center", marginTop: "25px", marginBottom: "25px" }}>

                {AppContext.selectedReferences.length > 0 && <>

                    <div style={{ marginBottom: "15px" }}>
                        You are about to export the following items:
                    </div>


                    <div className="thin-scrollbar" style={{ maxHeight: "250px", overflowY: "auto" }}>

                        {(AppContext.getSelectedRowsForDisplay
                            ? AppContext.getSelectedRowsForDisplay()
                            : AppContext.data.filter(r => AppContext.selectedReferences.includes(r.Id))
                        ).map((r, index) => (

                            <div key={index} style={{ marginBottom: "10px", padding: "5px", backgroundColor: "#f2f2f2" }}>
                                {getDisplayName(r, AppContext.entityType)}
                            </div>

                        ))}

                    </div>

                    <br />

                </>}



                <div style={{ marginTop: "15px" }}>
                    {AppContext.isExporting ? (
                        <>
                            <LoadingSpinnerImage />
                        </>
                    ) : (
                        <>
                            {AppContext.errorExporting && (
                                <div style={{ marginBottom: "15px" }}>
                                    An error occurred. Please try again
                                </div>
                            )}

                            {AppContext.successExporting ? (
                                <div style={{ marginBottom: "15px" }}>
                                    The references were exported successfully
                                </div>
                            ) : (
                                <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>

                                    {/* TOP ROW: Main Buttons */}
                                    {!AppContext.hideExcelExport && (
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                // 1. Check BOTH role and services to decide layout
                                                justifyContent: (AppContext.userRole === "Admin" && AppContext.eudamedXmlServices && AppContext.eudamedXmlServices.length > 0)
                                                    ? "space-between"
                                                    : "flex-end", 
                                                alignItems: "flex-start"
                                            }}>

                                                {/* LEFT SIDE: EUDAMED Toggle Button */}
                                                {AppContext.userRole === "Admin" && AppContext.eudamedXmlServices && AppContext.eudamedXmlServices.length > 0 && (
                                                    <div>
                                                        <button
                                                            className="action-button save-button"
                                                            onClick={() => setShowEudamedOptions(!showEudamedOptions)}
                                                        >
                                                            EUDAMED {showEudamedOptions ? <i className="fas fa-angle-up" style={{ marginLeft: "5px" }}></i> : <i className="fas fa-angle-down" style={{ marginLeft: "5px" }}></i>}
                                                        </button>
                                                    </div>
                                                )}

                                                {/* RIGHT SIDE: Excel Options */}
                                                <div style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "flex-end",
                                                    gap: "10px",
                                                    marginLeft: "auto"
                                                }}>
                                                    <button className="action-button save-button" onClick={() => AppContext.exportReferences("excel")}>
                                                        Export to Excel
                                                    </button>

                                                    {AppContext.legalManufacturers && AppContext.legalManufacturers.length > 0 && (AppContext.entityType === "compliance-regulatorydocuments" || AppContext.entityType === "compliance-standards") && (
                                                        <button className="action-button save-button" onClick={() => AppContext.exportReferences("excel-with-legal")}>
                                                            Export to Excel with All Legal Manufacturers
                                                        </button>
                                                    )}
                                                </div>

                                            </div>
                                    )}

                                    {/* BOTTOM ROW: Expanded EUDAMED Options */}
                                    {AppContext.userRole === "Admin" && AppContext.eudamedXmlServices && AppContext.eudamedXmlServices.length > 0 && showEudamedOptions && (
                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            backgroundColor: "#f9f9f9",
                                            padding: "15px",
                                            borderRadius: "6px",
                                            border: "1px solid #eaeaea",
                                            marginTop: "20px"
                                        }}>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                gap: "15px" /* This handles the top margin instead of needing g-mt-20 */
                                            }}>
                                                <select
                                                    className="form-control"
                                                    style={{ width: "auto" }}
                                                    value={selectedEudamedService}
                                                    onChange={(e) => setSelectedEudamedService(parseInt(e.target.value))}
                                                >
                                                    {AppContext.eudamedXmlServices.map((service, index) => (
                                                        <option key={service.value} value={index}>{service.label}</option>
                                                    ))}
                                                </select>

                                                <EudamedPlaygroundNotice />

                                                <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                                                    <button
                                                        className="action-button save-button"
                                                        disabled={AppContext.isExporting}
                                                        onClick={() => AppContext.exportEudamedXml(AppContext.eudamedXmlServices[selectedEudamedService])}
                                                    >
                                                        Download EUDAMED XML
                                                    </button>

                                                    <button
                                                        className="action-button save-button"
                                                        style={{ ...(window.enableEUDAMED === true && !AppContext.eudamedXmlServices[selectedEudamedService].filename.endsWith(".zip") ? {} : { opacity: 0.5, cursor: "not-allowed" }) }}
                                                        disabled={AppContext.isExporting || window.enableEUDAMED !== true || AppContext.eudamedXmlServices[selectedEudamedService].filename.endsWith(".zip")}
                                                        title={window.enableEUDAMED !== true
                                                            ? "EUDAMED submission is not enabled for your company"
                                                            : AppContext.eudamedXmlServices[selectedEudamedService].filename.endsWith(".zip")
                                                                ? "This service produces a zip of several XMLs - download it and submit each file individually"
                                                                : "Submit this XML directly to EUDAMED"}
                                                        onClick={() => AppContext.sendEudamedXmlToEudamed(AppContext.eudamedXmlServices[selectedEudamedService])}
                                                    >
                                                        Send to EUDAMED
                                                    </button>
                                                </div>
                                            </div>

                                            {/* EUDAMED Feedback Messages */}
                                            {AppContext.eudamedXmlError && (
                                                <div style={{ color: "#d9534f", marginTop: "10px", whiteSpace: "pre-line" }}>
                                                    {AppContext.eudamedXmlError}
                                                </div>
                                            )}
                                            {AppContext.eudamedXmlWarning && (
                                                <div style={{ color: "#6c757d", marginTop: "10px", whiteSpace: "pre-line" }}>
                                                    Warning: {AppContext.eudamedXmlWarning}
                                                </div>
                                            )}

                                            {AppContext.eudamedXmlSuccess && (
                                                <div style={{ color: "#28a745", marginTop: "10px" }}>
                                                    {AppContext.eudamedXmlSuccess}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                </div>
                            )}
                        </>
                    )}
                </div>


            </div>

        </div>
    );

}



const CountryRegistrationsExportAllReferencesPopup = () => {
    const AppContext = useContext(GlobalAppContext);

    const exportAllReferences = async (type = "excel") => {
        try {
            AppContext.setIsExporting(true);
            AppContext.setErrorExporting(false);
            AppContext.setSuccessExporting(false);

            let appliedFilters = AppContext.lastFiltersUsedForListTotalCount;

            let requestOptions = {
                method: "GET",
            };

            if (type === "excel") {
                requestOptions.headers = {
                    "Content-Type":
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                };
            }

            const response = await fetch(
                `/umbraco/api/RIMSRegistrations/RegistrationsExport/?exportAll=true&` + appliedFilters,
                requestOptions
            );

            if (!response.ok) {
                if (response.status === 401) {
                    document.dispatchEvent(new Event("api:unauthorized"));
                }

                AppContext.setErrorExporting(true);
                throw new Error("Network response was not ok");
            }

            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");

            a.href = url;

            if (type === "excel") {
                a.download =
                    AppContext.excelExportFileName
                        ? `${AppContext.excelExportFileName}.xlsx`
                        : "MedboardExport.xlsx";
            }

            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);

            AppContext.setSuccessExporting(true);
        } catch (error) {
            console.error("Export error:", error);
            AppContext.setErrorExporting(true);
        } finally {
            AppContext.setIsExporting(false);
        }
    };

    return (
        <div className="add-task-popup">
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    marginBottom: "5px",
                }}
            >
                <div style={{ width: "50%" }}>
                    <h3>Export All Registrations</h3>
                </div>

                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() =>
                            AppContext.setShowCountryRegistrationsExportAllReferencesPopup(false)
                        }
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>

            <div
                style={{
                    textAlign: "center",
                    marginTop: "25px",
                    marginBottom: "25px",
                }}
            >
                <div style={{ marginBottom: "20px" }}>
                    You are about to export all registrations.
                </div>

                {AppContext.isExporting ? (
                    <LoadingSpinnerImage />
                ) : (
                    <>
                        {AppContext.errorExporting && (
                            <div style={{ marginBottom: "15px" }}>
                                An error occurred. Please try again.
                            </div>
                        )}

                        {AppContext.successExporting ? (
                            <div style={{ marginBottom: "15px" }}>
                                The references were exported successfully.
                            </div>
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <button
                                    className="action-button save-button"
                                    onClick={() =>
                                        exportAllReferences("excel")
                                    }
                                >
                                    Export to Excel
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};







const CountryRegistrationsDeleteAllReferencesPopup = () => {
    const AppContext = useContext(GlobalAppContext);

    const deleteAllReferences = async () => {
        try {
            AppContext.setIsDeleting(true);
            AppContext.setErrorDeleting(false);
            AppContext.setSuccessDeleting(false);

            let appliedFilters = AppContext.lastFiltersUsedForListTotalCount;

            const response = await fetch(
                `/umbraco/api/RIMSRegistrations/BulkRegistrations/?deleteAll=true&` + appliedFilters,
                {
                    method: "DELETE",
                }
            );

            if (!response.ok) {
                if (response.status === 401) {
                    document.dispatchEvent(new Event("api:unauthorized"));
                }

                AppContext.setErrorDeleting(true);
                throw new Error("Network response was not ok");
            }

            AppContext.setSuccessDeleting(true);

            // Optional: refresh the list
            if (AppContext.loadData) {
                await AppContext.loadData();
            }
        } catch (error) {
            console.error("Delete error:", error);
            AppContext.setErrorDeleting(true);
        } finally {
            AppContext.setIsDeleting(false);
        }
    };

    return (
        <div className="add-task-popup">
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    marginBottom: "5px",
                }}
            >
                <div style={{ width: "50%" }}>
                    <h3>Delete All Registrations</h3>
                </div>

                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() =>
                            AppContext.setShowCountryRegistrationsDeleteAllReferencesPopup(false)
                        }
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>

            <div
                style={{
                    textAlign: "center",
                    marginTop: "25px",
                    marginBottom: "25px",
                }}
            >
                <div
                    style={{
                        marginBottom: "20px",
                        color: "#c62828",
                        fontWeight: "bold",
                    }}
                >
                    Warning: This will permanently delete <b>{AppContext.listTotalCount}</b> registrations.
                </div>

                {AppContext.isDeleting ? (
                    <LoadingSpinnerImage />
                ) : (
                    <>
                        {AppContext.errorDeleting && (
                            <div style={{ marginBottom: "15px" }}>
                                An error occurred. Please try again.
                            </div>
                        )}

                        {AppContext.successDeleting ? (
                            <div style={{ marginBottom: "15px" }}>
                                All references were deleted successfully.
                            </div>
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: "10px",
                                }}
                            >
                                <button
                                    className="action-button delete-button"
                                    onClick={deleteAllReferences}
                                >
                                    Delete All References
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};













const GraphsForRegulatoryDocuments = () => {

    const AppContext = useContext(GlobalAppContext);

    return (

        <div style={{ display: "flex", flexDirection: "row", height: "220px" }}>

            {AppContext.isLoadingRegulatoryDocumentsGraphs != null && <>

                {AppContext.isLoadingRegulatoryDocumentsGraphs == true ? <>

                    <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                        <LoadingSpinnerImage />
                    </div>

                </> : <>

                    <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                        <div style={{ width: "30%" }}>
                                <HighchartsReact highcharts={AppContext.Highcharts} constructorType="mapChart" options={AppContext.regDocsGraphOptionsForCountry}
                                    callback={(chart) => {
                                        // just to change the hover message in the credits
                                        const creditTitle = chart.container.querySelector(".highcharts-credits title");
                                        if (creditTitle)
                                            creditTitle.textContent = "MedBoard.com";
                                    }}
                                />
                        </div>

                        <div style={{ width: "5%" }}></div>

                        <div style={{ width: "30%" }}>
                            <HighchartsReact highcharts={AppContext.Highcharts} options={AppContext.regDocsGraphOptionsForRegulatory} />
                        </div>

                        <div style={{ width: "5%" }}></div>

                        <div style={{ width: "30%" }}>
                            <HighchartsReact highcharts={AppContext.Highcharts} options={AppContext.regDocsGraphOptionsForComplianceStatus} />
                        </div>
                    </div>

                </>}

            </>}

        </div>
    
    );

}



const GraphsForStandards = () => {

    const AppContext = useContext(GlobalAppContext);

    return (

        <div style={{ display: "flex", flexDirection: "row", height: "220px" }}>

            {/* Graphs for Standards */}

            {AppContext.isLoadingStandardsGraphs != null && <>

                {AppContext.isLoadingStandardsGraphs == true ? <>

                    <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                        <LoadingSpinnerImage />
                    </div>

                </> : <>

                        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                            <div style={{ width: "40%" }}>
                                <HighchartsReact highcharts={AppContext.Highcharts} options={AppContext.standardsGraphOptionsForSource} />
                            </div>

                            <div style={{ width: "10%" }}></div>

                            <div style={{ width: "40%" }}>
                                <HighchartsReact highcharts={AppContext.Highcharts} options={AppContext.standardsGraphOptionsForComplianceStatus} />
                            </div>


                    </div>

                </>}

            </>}

        </div>

    );

}



const GraphsForSubmissions = () => {

    const AppContext = useContext(GlobalAppContext);

    return (

        <div style={{ display: "flex", flexDirection: "row", height: "220px" }}>

            {AppContext.isLoadingSubmissionsGraphs != null && <>

                {AppContext.isLoadingSubmissionsGraphs == true ? <>

                    <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                        <LoadingSpinnerImage />
                    </div>

                </> : <>

                    <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                            <div style={{ width: "30%" }}>
                                <HighchartsReact
                                    highcharts={AppContext.Highcharts}
                                    constructorType="mapChart"
                                    options={AppContext.submissionsGraphOptionsForCountry}
                                />
                            </div>

                            <div style={{ width: "5%" }}></div>

                            <div style={{ width: "30%" }}>
                                <HighchartsReact
                                    highcharts={AppContext.Highcharts}
                                    options={AppContext.submissionsGraphOptionsForType}
                                />
                            </div>

                            <div style={{ width: "5%" }}></div>

                            <div style={{ width: "30%" }}>
                                <HighchartsReact
                                    highcharts={AppContext.Highcharts}
                                    options={AppContext.submissionsGraphOptionsForStatus}
                                />
                            </div>
                    </div>

                </>}

            </>}

        </div>

    );

}



const LegalManufacturerFilter = () => {

    const AppContext = useContext(GlobalAppContext);

    const setLegalManufacturerIdSession = (id) => {

        let url = "/umbraco/api/Compliance/LegalManufacturerSession?" +
            `legalManufacturerId=${encodeURIComponent(id)}&`;

        let requestOptions = {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((result) => {
            })
            .catch((error) => {
                console.log("error: " + error);
            })
            .finally(() => {
            });
    }

    const handleFilterChange = (e) => {

        let id = e.target.value;

        AppContext.setCurrentLegalManufacturerFilter(id);
        AppContext.setCurrentLegalManufacturerNameFilter(AppContext.legalManufacturers.find(lm => lm.EstablishmentId == id)?.Establishment);
        AppContext.refreshData();
        AppContext.refreshGraphs();
        setLegalManufacturerIdSession(id);
    }

    const clearFilter = () => {

        let id = -1;

        AppContext.setCurrentLegalManufacturerFilter(id);
        AppContext.setCurrentLegalManufacturerNameFilter("");
        AppContext.refreshData();
        AppContext.refreshGraphs();
        setLegalManufacturerIdSession(id);
    }

    return (
        <>
            {AppContext.legalManufacturers.length === 0 ? null :
                <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>

                    <div style={{ display: "flex", alignItems: "center", gap: "8px", padding: "10px 12px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: "8px" }}>
                        <i className="fas fa-filter" style={{ color: "#a0aec0" }} />
                        <select
                            value={AppContext.currentLegalManufacturerFilter}
                            onChange={handleFilterChange}
                            style={{ border: "none", background: "transparent", outline: "none", fontWeight: 600, color: "#4a5568", cursor: "pointer" }}
                        >
                            <option value="-1">All Legal Manufacturers</option>
                            {AppContext.legalManufacturers.map((lm) =>
                                <option key={lm.EstablishmentId} value={lm.EstablishmentId}>
                                    {lm.Establishment}
                                </option>
                            )}
                        </select>
                    </div>

                    {parseInt(AppContext.currentLegalManufacturerFilter) > -1 ?
                        <button
                            onClick={clearFilter}
                            className="btn g-font-size-13"
                            style={{ paddingRight: "12px", paddingLeft: "12px", lineHeight: "1.6rem", height: "35px", backgroundColor: "rgb(247, 247, 247)", color: "rgb(52, 119, 180)", border: "1px solid rgb(52, 119, 180)", borderRadius: "8px" }}
                        >
                            <i className="far fa-times-circle g-mr-5"></i>Clear filter
                        </button>
                        : null}

                </div>
            }
        </>
    );
}




const SubMenuProducts = () => {

    const AppContext = useContext(GlobalAppContext);

    const [counts, setCounts] = useState({
        products: "-",
        families: "-",
        udis: "-",
        legalManufacturers: "-",
        physicalManufacturers: "-",
    });

    const loadCounts = async () => {
        try {
            const response = await fetch("/umbraco/api/RIMSProducts/Dashboard/?establishmentId=" + AppContext.currentLegalManufacturerFilter); // Replace with your endpoint
            const data = await response.json();

            setCounts({
                products: data.ProductCount || 0,
                families: data.FamilyCount || 0,
                udis: data.UdiCount || 0,
                legalManufacturers: data.LegalManufacturerCount || 0,
                physicalManufacturers: data.PhysicalManufacturerCount || 0,
            });
        } catch (err) {
            console.error("Failed to load product counts:", err);
        }
    };

    useEffect(() => {

        loadCounts();

    }, [AppContext.triggerRefreshGraphs]);


    const cards = [
        {
            title: "Products",
            entity: "product-skus",
            value: counts.products,
            icon: "fas fa-box-open",
            url: "/your-medboard/products/",
        },
        {
            title: "Product Families",
            entity: "product-family",
            value: counts.families,
            icon: "fas fa-layer-group",
            url: "/your-medboard/product-families/",
        },
        {
            title: "UDIs",
            entities: UDI_ENTITY_TYPES,
            value: counts.udis,
            icon: "fas fa-barcode",
            url: "/your-medboard/product-portfolio/basic-udis/",
        },
        {
            title: "Legal Manufacturers",
            value: counts.legalManufacturers,
            icon: "fas fa-building",
            url: "/your-medboard/product-portfolio/?mode=6",
        },
        {
            title: "Physical Manufacturers",
            value: counts.physicalManufacturers,
            icon: "fas fa-industry",
            url: "/your-medboard/product-portfolio/?mode=9",
        },
    ];

    return (
        <div className="submenu-grid">
            {cards.map(card => (
                <a
                    key={card.title}
                    href={card.url}
                    className={`submenu-card ${
                        (card.entities ?? [card.entity]).includes(AppContext.entityType)
                            ? "submenu-card-selected"
                            : ""
                    }`}
                    style={{ textDecoration: "none" }}
                >
                    <span className="submenu-title">{card.title}</span>

                    <div className="submenu-value-row">
                        <i className={`${card.icon} submenu-icon`} style={{ marginRight: "8px" }} />
                        <span className="submenu-value" style={card.valueColor ? { color: card.valueColor } : { color: "#555" }} >
                            {card.value || 0}
                        </span>
                    </div>
                </a>
            ))}
        </div>
    );
};



const SubMenuCM = () => {
    const AppContext = useContext(GlobalAppContext);

    const [counts, setCounts] = useState({
        regulations: "-",
        standards: "-",
        technicalDocumentation: "-",
        qmsProcedures: "-",
    });

    const loadCounts = async () => {
        try {
            const response = await fetch("/umbraco/api/Compliance/Dashboard/?legalManufacturerId=" + AppContext.currentLegalManufacturerFilter); // Replace with your endpoint
            const data = await response.json();

            setCounts({
                regulations: data.find(stat => stat.Name=="RegulatoryDocuments")?.Total || 0,
                standards: data.find(stat => stat.Name=="Standards")?.Total || 0,
                technicalDocumentation: data.find(stat => stat.Name=="TechnicalDocumentation")?.Total || 0,
                qmsProcedures: data.find(stat => stat.Name=="QMS")?.Total || 0,
            });
        } catch (err) {
            console.error("Failed to load compliance counts:", err);
        }
    };


    useEffect(() => {

        loadCounts();

    }, [AppContext.triggerRefreshGraphs]);

    const cards = [
        {
            title: "Regulations",
            entity: "compliance-regulatorydocuments",
            value: counts.regulations,
            icon: "fas fa-landmark",
            url: "/your-medboard/compliance-portfolio/regulatory-documents/",
        },
        {
            title: "Standards",
            entity: "compliance-standards",
            value: counts.standards,
            icon: "fas fa-file-contract",
            url: "/your-medboard/compliance-portfolio/standards/",
        },
        {
            title: "Technical documentation",
            entity: "compliance-technical-documents",
            value: counts.technicalDocumentation,
            icon: "fas fa-book",
            url: "/your-medboard/compliance-portfolio/technical-documentation/",
        },
        {
            title: "QMS/GxP procedures",
            entity: "compliance-qms",
            value: counts.qmsProcedures,
            icon: "fas fa-clipboard-list",
            url: "/your-medboard/compliance-portfolio/qms-procedures/",
        },
    ];

    return (
        <div className="submenu-grid">
            {cards.map(card => (
                <a
                    key={card.title}
                    href={card.url}
                    className={`submenu-card ${
                        card.entity === AppContext.entityType
                            ? "submenu-card-selected"
                            : ""
                    }`}
                    style={{ textDecoration: "none" }}
                >
                    <span className="submenu-title">{card.title}</span>

                    <div className="submenu-value-row">
                        <i
                            className={`${card.icon} submenu-icon`}
                            style={{ marginRight: "8px" }}
                        />

                        <span
                            className="submenu-value"
                            style={card.valueColor ? { color: card.valueColor } : { color: "#555" }}
                        >
                            {card.value || 0}
                        </span>
                    </div>
                </a>
            ))}
        </div>
    );
};


const ColumnFilter = ({
    column,
    filterCallback,
    loadFilterOptions,
    defaultFilters
}) => {

    const wrapperRef = useRef(null);
    const popupRef = useRef(null);

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);

    const [options, setOptions] = useState([]);
    const [search, setSearch] = useState("");

    const [selected, setSelected] = useState([]);
    const [appliedSelected, setAppliedSelected] = useState([]);

    const [popupStyle, setPopupStyle] = useState({});

    useEffect(() => {

        const handleClickOutside = (event) => {

            const clickedWrapper =
                wrapperRef.current &&
                wrapperRef.current.contains(event.target);

            const clickedPopup =
                popupRef.current &&
                popupRef.current.contains(event.target);

            if (!clickedWrapper && !clickedPopup) {

                setSelected(appliedSelected);
                setOpen(false);

            }

        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [appliedSelected]);



    const updatePopupPosition = () => {

        if (!wrapperRef.current) return;

        const rect = wrapperRef.current.getBoundingClientRect();

        const popupWidth = 320;
        const popupHeight = 350;
        const margin = 10;

        // ---------- Vertical positioning ----------

        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;

        let top = rect.bottom + 6;

        if (spaceBelow < popupHeight && spaceAbove > spaceBelow) {
            top = rect.top - popupHeight - 6;
        }

        top = Math.max(margin, Math.min(top, window.innerHeight - popupHeight - margin));
        // ---------- Horizontal positioning ----------

        let left = rect.left;

        // Prevent overflow on right side
        if (left + popupWidth > window.innerWidth - margin) {

            left = window.innerWidth - popupWidth - margin;

        }

        // Prevent overflow on left side
        if (left < margin) {
            left = margin;
        }

        setPopupStyle({
            position: "fixed",
            top,
            left,
            zIndex: 99999
        });

    };



    useEffect(() => {

        if (!open) return;

        updatePopupPosition();

        window.addEventListener("resize", updatePopupPosition);
        window.addEventListener("scroll", updatePopupPosition, true);

        return () => {

            window.removeEventListener("resize", updatePopupPosition);
            window.removeEventListener("scroll", updatePopupPosition, true);

        };

    }, [open]);



    const handleOpen = async (e) => {

        e.stopPropagation();

        const willOpen = !open;

        if (willOpen) {
            updatePopupPosition();
        }

        setOpen(willOpen);

        // Reload the options every time the dropdown opens, not just the first time: the list
        // is narrowed by the other columns' active filters, which may have changed since the
        // last open.
        if (willOpen) {

            try {

                setLoading(true);

                const result = await loadFilterOptions(column.field);

                const opts = result || [];

                setOptions(opts);

                if (!loaded) {

                    setLoaded(true);

                    // Apply defaults ONLY first load
                    if (defaultFilters?.length) {

                        const matching = defaultFilters
                            .filter(f => f.key === column.field)
                            .map(f => parseInt(f.value));

                        if (matching.length > 0) {

                            setSelected(matching);
                            setAppliedSelected(matching);

                        }

                    }

                }
            } catch (err) {

                console.error("Failed loading filters", err);

            } finally {

                setLoading(false);

            }

        }

    };



    const toggleOption = (value) => {

        setSelected((prev) => {

            if (prev.includes(value)) {
                return prev.filter((v) => v !== value);
            }

            return [...prev, value];

        });

    };



    const filteredOptions = options.filter((item) =>
        item.Text?.toLowerCase().includes(search.toLowerCase())
    );



    const handleSelectAll = () => {

        setSelected(filteredOptions.map((x) => x.Value));

    };



    const handleClear = () => {

        setSelected([]);

    };



    const handleApply = () => {

        setAppliedSelected(selected);

        filterCallback({
            field: column.field,
            values: selected
        });

        setOpen(false);

    };



    return (
        <div
            ref={wrapperRef}
            onClick={handleOpen}
            style={{
                position: "relative",
                display: "inline-flex",
                alignItems: "center",
                whiteSpace: "nowrap",
                padding: "3px 7px",
                borderRadius: "5px",
                marginLeft: "6px",
                cursor: "pointer",
            }}
        >

            <button
                type="button"
                style={{
                    border: "none",
                    background: "transparent",
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    whiteSpace: "nowrap",
                    color: "#a0aec0",
                }}
            >
                <i className="fas fa-filter"></i>

                {appliedSelected.length > 0 && (
                    <span
                        style={{
                            fontSize: "12px",
                            fontWeight: "bold"
                        }}
                    >
                        ({appliedSelected.length})
                    </span>
                )}
            </button>



            {open && createPortal(

                <div
                    ref={popupRef}
                    data-col={column.field}
                    onClick={(e) => e.stopPropagation()}
                    style={{
                        ...popupStyle,
                        width: "320px",
                        background: "#fff",
                        padding: "10px",
                        borderRadius: "10px",
                        border: "1px solid #ddd",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                    }}
                >

                    {loading && (

                        <div
                            style={{
                                padding: "20px",
                                textAlign: "center"
                            }}
                        >
                            <LoadingSpinnerImage />
                        </div>

                    )}



                    {!loading && (
                        <>

                            <div
                                style={{
                                    display: "flex",
                                    gap: "6px",
                                    marginBottom: "10px"
                                }}
                            >

                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={search}
                                    autoComplete="off"
                                    onChange={(e) => setSearch(e.target.value)}
                                    style={{
                                        flex: 1,
                                        padding: "6px 8px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px"
                                    }}
                                />

                                {search.trim() !== "" && (
                                    <button
                                        type="button"
                                        onClick={() => setSearch("")}
                                        style={{
                                            border: "1px solid #ccc",
                                            background: "#f5f5f5",
                                            borderRadius: "6px",
                                            cursor: "pointer",
                                            height: "30px",
                                            width: "30px"
                                        }}
                                    >
                                        X
                                    </button>
                                )}

                            </div>



                            <div
                                style={{
                                    maxHeight: "220px",
                                    overflowY: "auto",
                                    border: "1px solid #eee",
                                    borderRadius: "6px",
                                    padding: "6px"
                                }}
                            >

                                {filteredOptions.length === 0 && (

                                    <div
                                        style={{
                                            padding: "10px",
                                            color: "#777"
                                        }}
                                    >
                                        No results
                                    </div>

                                )}



                                {filteredOptions.map((item, index) => {

                                    const id = `opt-${column.field}-${index}`;

                                    return (

                                        <div
                                            key={item.Value}
                                            style={{
                                                display: "flex",
                                                alignItems: "start",
                                                gap: "8px",
                                                padding: "4px 0",
                                            }}
                                        >

                                            <input
                                                id={id}
                                                type="checkbox"
                                                style={{marginTop: "4px"}}
                                                checked={selected.includes(item.Value)}
                                                onChange={() => toggleOption(item.Value)}
                                            />

                                            <label
                                                htmlFor={id}
                                                style={{
                                                    cursor: "pointer",
                                                    fontSize: "14px",
                                                    marginBottom: "0px",
                                                }}
                                            >
                                                {item.Text}
                                            </label>

                                        </div>

                                    );

                                })}

                            </div>



                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginTop: "10px"
                                }}
                            >

                                <div
                                    style={{
                                        display: "flex",
                                        gap: "8px"
                                    }}
                                >

                                    <button
                                        type="button"
                                        onClick={handleSelectAll}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            color: "#0d6efd",
                                            cursor: "pointer"
                                        }}
                                    >
                                        Select All
                                    </button>

                                    <button
                                        type="button"
                                        onClick={handleClear}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            color: "#0d6efd",
                                            cursor: "pointer"
                                        }}
                                    >
                                        Clear
                                    </button>

                                </div>



                                <button
                                    type="button"
                                    onClick={handleApply}
                                    style={{
                                        border: "none",
                                        background: "#0d6efd",
                                        color: "#fff",
                                        padding: "6px 12px",
                                        borderRadius: "6px",
                                        cursor: "pointer"
                                    }}
                                >
                                    Apply
                                </button>

                            </div>

                        </>
                    )}

                </div>,

                document.body

            )}

        </div>
    );

};




// #####################################################








const RegistrationsCountryNotes = ({ AppContext, countryId }) => {
    const [notes, setNotes] = useState([]);
    const [selectedNote, setSelectedNote] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [rightPanelMode, setRightPanelMode] = useState("view"); // view, add, edit
    const [noteFormText, setNoteFormText] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [actionLoading, setActionLoading] = useState(false);
    const [title, setTitle] = useState("");

    const [errorTitle, setErrorTitle] = useState(null);
    const [errorText, setErrorText] = useState(null);

    const trumbowygRef = useRef(null);

    const fetchNotes = useCallback(async () => {
        if (!countryId) return;
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(
                `/umbraco/api/RIMSRegistrations/CountryNotes/?countryId=${countryId}`
            );
            if (!response.ok) throw new Error("Failed to fetch notes");
            const data = await response.json();
            setNotes(data.sort((a,b) => b.Id - a.Id));
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, [countryId]);




    // Pre-fill form when switching to edit mode
    useEffect(() => {
        if (rightPanelMode === "edit" && selectedNote) {
            setTitle(selectedNote.Title);
            setNoteFormText(selectedNote.Text);
        } else if (rightPanelMode === "add") {
            setTitle("");
            setNoteFormText("");
        }
    }, [rightPanelMode, selectedNote]);



    const selectNoteHandler = (note) => {
        if (rightPanelMode === "add" || rightPanelMode === "edit") {
            setRightPanelMode("view");
        }
        setSelectedNote(note);
    };



    const addNoteClick = () => {
        cancelEdit();
        setTimeout(() => {
            setSelectedNote({ CountryId: countryId, Title: "", Text: "" });
            setRightPanelMode("add");
        }, 0);
    };



    const editNoteClick = () => {
        if (selectedNote) setRightPanelMode("edit");
    };



    const deleteNote = async () => {
        if (!selectedNote) return;
        if (!window.confirm("Are you sure you want to delete this note?")) return;
        setActionLoading(true);
        try {
            const response = await fetch(
                `/umbraco/api/RIMSRegistrations/CountryNotes/?id=${selectedNote.Id}`,
                { method: "DELETE" }
            );
            if (!response.ok) throw new Error("Failed to delete note");
            await fetchNotes();
            setSelectedNote(null);
            setRightPanelMode("view");
        } catch (err) {
            setError(err.message);
        } finally {
            setActionLoading(false);
        }
    };



    const saveNote = async () => {

        let hasErrors = false;

        setErrorTitle(null);
        setErrorText(null);

        if (title.length == 0) {
            setErrorTitle("Note title cannot be empty");
            hasErrors = true;
        }


        const editorElement = $(trumbowygRef.current)
                                .parent()
                                .find(".trumbowyg-editor");

        const noteFormText = editorElement.html();


        if (!noteFormText.trim()) {
            setErrorText("Note text cannot be empty");
            hasErrors = true;
        }

        if (hasErrors)
            return;

        setActionLoading(true);
        setError(null);
        try {
            if (rightPanelMode === "add") {
                const payload = { CountryId: countryId, Title: title, Text: noteFormText };
                const response = await fetch("/umbraco/api/RIMSRegistrations/CountryNotes/", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });
                if (!response.ok) throw new Error("Failed to add note");
            } else if (rightPanelMode === "edit" && selectedNote) {
                const payload = {
                    Id: selectedNote.Id,
                    CountryId: countryId,
                    Text: noteFormText,
                    Title: title
                };
                const response = await fetch("/umbraco/api/RIMSRegistrations/CountryNotes/", {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });
                if (!response.ok) throw new Error("Failed to update note");
            }
            await fetchNotes();
            
            if (rightPanelMode === "edit" && selectedNote) {
                setSelectedNote((prev) => ({ ...prev, Title: title, Text: noteFormText }));
            } else if (rightPanelMode === "add") {
                setSelectedNote(null);
            }

            setRightPanelMode("view");

            setErrorTitle(null);
            setErrorText(null);

        } catch (err) {
            setError(err.message);
        } finally {
            setActionLoading(false);
        }
    };



    const cancelEdit = () => {
        if (rightPanelMode === "add")
            setSelectedNote(null);

        setRightPanelMode("view");
    };



    const openPopup = () => {

        setShowPopup(true);
        fetchNotes();
        setRightPanelMode("view");
        setSelectedNote(null);
    };


    const closePopup = () => setShowPopup(false);




    // Initialize Trumbowyg
    useEffect(() => {

        const initEditor = async () => {

            if (
                (rightPanelMode === "add" || rightPanelMode === "edit") &&
                trumbowygRef.current
            ) {

                // Make jQuery global
                window.$ = $;
                window.jQuery = $;

                // Dynamically import trumbowyg
                await import("trumbowyg");

                const $editor = $(trumbowygRef.current);

                if (!$editor.data("trumbowyg")) {

                    $editor.trumbowyg({

                        btns: [
                            ["viewHTML"],
                            ["formatting"],
                            ["strong", "em", "del"],
                            ["superscript", "subscript"],
                            ["link"],
                            ["insertImage"],
                            ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"],
                            ["unorderedList", "orderedList"],
                            ["horizontalRule"],
                            ["removeformat"],
                            ["fullscreen"]
                        ],

                        autogrow: true

                    });





                    $editor.trumbowyg(
                        "html",
                        DOMPurify.sanitize(selectedNote.Text || "")
                    );







                    
                    const editorElement = $editor.parent().find(".trumbowyg-editor");

                    editorElement.off("paste.notesImageUpload");

                    editorElement.on(
                        "paste.notesImageUpload",
                        async (e) => {

                            e.preventDefault();

                            const clipboardData = e.originalEvent.clipboardData;

                            if (!clipboardData?.items)
                                return;

                            const items = [...clipboardData.items];

                            const imageItems = items.filter(
                                item => item.type.startsWith("image/")
                            );

                            const htmlItem = items.find(
                                item => item.type === "text/html"
                            );

                            let htmlContent = "";
                            let embeddedImages = [];
                            let doc = null;

                            if (htmlItem) {

                                htmlContent = await new Promise(
                                    resolve => htmlItem.getAsString(resolve)
                                );

                                const parser = new DOMParser();

                                doc = parser.parseFromString(
                                    htmlContent,
                                    "text/html"
                                );

                                embeddedImages = [...doc.querySelectorAll("img")]
                                    .filter(img =>
                                        img.src.startsWith("data:image")
                                    );

                            }



                            if (imageItems.length === 0 &&
                                embeddedImages.length === 0) {

                                // If rich HTML exists (Word, Gmail, websites, etc.)
                                if (htmlContent) {

                                    $editor.trumbowyg(
                                        "execCmd",
                                        {
                                            cmd: "insertHTML",
                                            param: htmlContent
                                        }
                                    );

                                } else {

                                    // Fallback to plain text
                                    const text = clipboardData.getData("text/plain");

                                    $editor.trumbowyg(
                                        "execCmd",
                                        {
                                            cmd: "insertText",
                                            param: text
                                        }
                                    );

                                }

                                return;
                            }



                            e.preventDefault();

                            const placeholders = [];

                            const batchId = Date.now();

                            embeddedImages.forEach((img, index) => {

                                const placeholderId = `upload-${batchId}-${index}`;

                                placeholders.push({
                                    id: placeholderId,
                                    base64: img.src
                                });

                                img.src = "/assets/js/frontend/public/loading-spinner.gif";

                                img.setAttribute("style", "width:auto; height:auto; display:block; margin:10px 0;");

                                img.setAttribute("data-upload-id", placeholderId);

                            });

                            // Rebuild HTML from the modified DOM
                            // Only rebuild if a document exists
                            if (doc) {
                                htmlContent = doc.body.innerHTML;
                            }




                            if (!htmlContent && imageItems.length > 0) {

                                imageItems.forEach((item, index) => {

                                    const placeholderId = `upload-${Date.now()}-${index}`;

                                    placeholders.push({
                                        id: placeholderId,
                                        file: item.getAsFile()
                                    });

                                    htmlContent += `
                                        <img
                                            data-upload-id="${placeholderId}"
                                            src="/assets/js/frontend/public/loading-spinner.gif"
                                            style="width:auto; height:auto; display:block; margin:10px 0;"
                                        />
                                    `;

                                });

                            }

                            $editor.trumbowyg(
                                "execCmd",
                                {
                                    cmd: "insertHTML",
                                    param: htmlContent
                                }
                            );

                            const editorElement = $editor
                                .parent()
                                .find(".trumbowyg-editor");

                            try {

                                await Promise.all(

                                    placeholders.map(async (p, i) => {

                                        let base64 = p.base64;

                                        if (!base64) {

                                            base64 = await new Promise(
                                                (resolve, reject) => {

                                                    const reader = new FileReader();

                                                    reader.onload = () => resolve(reader.result);

                                                    reader.onerror = reject;

                                                    reader.readAsDataURL(p.file);

                                                }
                                            );

                                        }

                                        const response = await fetch(
                                            "/umbraco/api/Images/Image",
                                            {
                                                method: "POST",
                                                headers: {
                                                    "Content-Type": "application/json"
                                                },
                                                body: JSON.stringify({
                                                    entityType: AppContext.entityType,
                                                    imageBase64: base64
                                                })
                                            }
                                        );


                                        if (!response.ok)
                                            throw new Error("Upload failed");


                                        let imageUrl = await response.text();

                                        imageUrl = "/umbraco/api/Images/Image/?id=" + imageUrl + "&entityType=" + AppContext.entityType;

                                        editorElement.find(
                                            `[data-upload-id="${p.id}"]`
                                        )
                                            .attr("src", imageUrl)
                                            .removeAttr("data-upload-id")
                                            .css({
                                                width: "auto",
                                                height: "auto",
                                                maxWidth: "100%"
                                            });

                                    })

                                );

                                const html = editorElement.html();

                                setNoteFormText(html);

                            }
                            catch (err) {

                                console.error(err);

                            }


                            return () => {
                                if (richText && trumbowygRef.current) {
                                    const $editor = $(trumbowygRef.current);

                                    $editor
                                        .parent()
                                        .find(".trumbowyg-editor")
                                        .off("paste.notesImageUpload");

                                    if ($editor.data("trumbowyg")) {
                                        $editor.trumbowyg("destroy");
                                    }
                                }
                            };

                        }
                    );








                    $editor.on("tbwchange tbwblur", () => {

                        const editorElement = $editor
                                .parent()
                                .find(".trumbowyg-editor");

                        const html = editorElement.html();

                        setNoteFormText(html);

                    });
                }
            }
        };

        initEditor();

        return () => {

            if (trumbowygRef.current) {

                const $editor = $(trumbowygRef.current);

                if ($editor.data("trumbowyg")) {

                    $editor.trumbowyg("destroy");

                }
            }
        };

    }, [rightPanelMode, selectedNote]);






    const sanitize = (text) => {

        return DOMPurify.sanitize(text, { ALLOWED_TAGS: [], ALLOWED_ATTR: [], KEEP_CONTENT: true })

    }




    if (!showPopup) {
        return (
            <button
                onClick={openPopup}
                style={{
                    color: "rgb(32, 56, 100)",
                    padding: "7px 20px",
                    border: "1px solid rgb(222, 226, 230)",
                    borderRadius: "15px",
                    backgroundColor: "rgb(248, 249, 250)",
                    fontWeight: 500,
                    display: "inline-flex",
                    alignItems: "center",
                    transition: "0.2s",
                    cursor: "pointer",
                    boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px",
                }}
            >
                <i className="far fa-sticky-note" style={{ marginRight: "8px" }}></i>
                Country Notes
            </button>
        );
    }

    return (
        <div
            className="add-task-popup"
            style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1000,
                backgroundColor: "white",
                width: "80%",
                maxWidth: "1200px",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            }}
        >
            {/* Header Section */}
            <div style={{ display: "flex", flexDirection: "row", padding: "16px" }}>
                <div style={{ width: "50%" }}>
                    <h3>
                        <i className="far fa-sticky-note" style={{ marginRight: "8px" }}></i>
                        Country Notes
                    </h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        onClick={closePopup}
                        style={{
                            color: "rgb(32, 56, 100)",
                            padding: "7px 14px",
                            border: "1px solid rgb(222, 226, 230)",
                            borderRadius: "15px",
                            backgroundColor: "rgb(248, 249, 250)",
                            fontWeight: 500,
                            display: "inline-flex",
                            alignItems: "center",
                            cursor: "pointer"
                        }}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>
            <div style={{ display: "flex", flexDirection: "row"}}>
                <div
                    style={{
                        width: "30%",
                        marginLeft: "16px"
                    }}
                > {/* Add Note Button nested cleanly inside the left column layout */}
                    <button
                        onClick={addNoteClick}
                        className="action-button add-task-button"
                        style={{
                            marginBottom: "16px",
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center"
                        }}
                    >
                        <i className="fas fa-plus" style={{ marginRight: "8px" }}></i>
                        Add Note
                    </button>
                </div>
                <div
                    style={{
                        width: "70%",
                        marginRigth: "16px"
                    }}
                >{rightPanelMode === "view" && selectedNote && (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginBottom: "16px",
                            gap: "15px",
                        }}
                    >
                        <button
                            onClick={editNoteClick}
                            disabled={actionLoading}
                            style={{
                                color: "rgb(32, 56, 100)",
                                padding: "7px 20px",
                                border: "1px solid rgb(222, 226, 230)",
                                borderRadius: "15px",
                                backgroundColor: "rgb(248, 249, 250)",
                                fontWeight: 500,
                                display: "inline-flex",
                                alignItems: "center",
                                transition: "0.2s",
                                cursor: actionLoading ? "not-allowed" : "pointer",
                                boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px",
                                opacity: actionLoading ? 0.6 : 1,
                            }}
                        >
                            <i className="fas fa-edit" style={{ marginRight: "8px" }}></i>
                            Edit
                        </button>
                        <button
                            onClick={deleteNote}
                            disabled={actionLoading}
                            style={{
                                color: "rgb(220, 53, 69)",
                                padding: "7px 20px",
                                border: "1px solid rgb(222, 226, 230)",
                                borderRadius: "15px",
                                backgroundColor: "rgb(248, 249, 250)",
                                fontWeight: 500,
                                display: "inline-flex",
                                alignItems: "center",
                                transition: "0.2s",
                                cursor: actionLoading ? "not-allowed" : "pointer",
                                boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px",
                                opacity: actionLoading ? 0.6 : 1,
                            }}
                        >
                            <i className="fas fa-trash-alt" style={{ marginRight: "8px" }}></i>
                            Delete
                        </button>
                    </div>
                )}

                </div>
            </div>
            {/* Main Layout Body split columns */}
            <div style={{ display: "flex", flexDirection: "row", minHeight: "400px", maxHeight: "480px" }}>

                {/* Left column: list of notes */}
                <div
                    style={{
                        width: "30%",
                        borderRight: "1px solid #ccc",
                        padding: "16px",
                        overflowY: "auto",
                    }}
                >
                   

                    {loading ? (
                        <div><LoadingSpinnerImage /></div>
                    ) : (
                        <ul style={{ listStyle: "none", padding: 0 }}>
                            {notes.map((note) => (
                                <li
                                    key={note.Id}
                                    style={{
                                        padding: "8px",
                                        marginBottom: "8px",
                                        backgroundColor: selectedNote?.Id === note.Id ? "#e0e0e0" : "#f5f5f5",
                                        cursor: "pointer",
                                        borderRadius: "4px",
                                    }}
                                    onClick={() => selectNoteHandler(note)}
                                >
                                    <div style={{
                                        fontSize: "14px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        fontWeight: "bold"
                                    }}>
                                        {note.Title}
                                    </div>
                                    <div
                                        style={{
                                            fontSize: "12px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: note.Text ? sanitize(note.Text).substring(0, 80) : "",
                                        }}
                                    />
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                {/* Right column: view / add / edit note */}
                <div
                    style={{
                        width: "70%",
                        padding: "16px",
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    
                    {/* View Mode Content Panel */}
                    {rightPanelMode === "view" && (
                        <>
                            {selectedNote ? (
                                <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                                    <h2>{selectedNote.Title}</h2>
                                    <br />
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", paddingTop: "10px", borderTop: "1px solid #eee" }}>
                                        <div style={{ marginRight: "5px" }}>Created by:</div>
                                        <FieldTypes.FieldType_User value={selectedNote.CreatedBy} users={AppContext.users} size={"small"} />
                                        <div style={{ marginLeft: "5px" }}><FieldTypes.FieldType_DateTime value={selectedNote.CreatedOn} /></div>
                                    </div>
                                    <br />
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", paddingBottom: "10px", borderBottom: "1px solid #eee" }}>
                                        <div style={{ marginRight: "5px" }}>Last update:</div>
                                        <FieldTypes.FieldType_User value={selectedNote.UpdatedBy} users={AppContext.users} size={"small"} />
                                        <div style={{ marginLeft: "5px" }}><FieldTypes.FieldType_DateTime value={selectedNote.UpdatedOn} /></div>
                                    </div>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: selectedNote.Text }}
                                        style={{ marginTop: "20px", whiteSpace: "pre-wrap" }}
                                    />
                                </div>
                            ) : (
                                <p>Select a note or add a new note.</p>
                            )}
                        </>
                    )}

                    {/* Add / Edit Mode Content Panel */}
                    {(rightPanelMode === "add" || rightPanelMode === "edit") && (
                        <div style={{maxHeight: "300px;"} }>
                            <input
                                style={{
                                    fontSize: "14pt",
                                    borderRadius: "5px",
                                    border: "1px solid #bbb",
                                    padding: "3px 7px",
                                    width: "100%",
                                }}
                                placeholder="Title"
                                type="text"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />

                            {errorTitle && <span className="form-field-error-message">This field is necessary</span>}

                            <br />
                            <br />

                            <div
                                ref={trumbowygRef}
                                style={{
                                    width: "100%",
                                    minHeight: "200px",
                                    maxHeight: "300px"
                                }}
                            />
                            {errorText && <span className="form-field-error-message">This field is necessary</span>}

                            {error && <div style={{ color: "red", marginTop: "8px" }}>{error}</div>}

                        
                        </div>
                    )}
                </div>
            </div>
            
            {(rightPanelMode === "add" || rightPanelMode === "edit") && (
                <div
                    style={{
                        marginTop: "20px",
                        marginRight: "20px",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "15px",
                    }}
                >
                <button
                    onClick={cancelEdit}
                    disabled={actionLoading}
                    style={{
                        color: "rgb(32, 56, 100)",
                        padding: "7px 20px",
                        border: "1px solid rgb(222, 226, 230)",
                        borderRadius: "15px",
                        backgroundColor: "rgb(248, 249, 250)",
                        fontWeight: 500,
                        display: "inline-flex",
                        alignItems: "center",
                        transition: "0.2s",
                        cursor: actionLoading ? "not-allowed" : "pointer",
                        boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px",
                        opacity: actionLoading ? 0.6 : 1,
                    }}
                >
                    <i className="fas fa-times" style={{ marginRight: "8px" }}></i>
                    Cancel
                </button>
                <button
                    onClick={saveNote}
                    disabled={actionLoading}
                    style={{
                        color: "white",
                        padding: "7px 20px",
                        border: "1px solid rgb(32, 56, 100)",
                        borderRadius: "15px",
                        backgroundColor: "rgb(32, 56, 100)",
                        fontWeight: 500,
                        display: "inline-flex",
                        alignItems: "center",
                        transition: "0.2s",
                        cursor: actionLoading ? "not-allowed" : "pointer",
                        boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px",
                        opacity: actionLoading ? 0.6 : 1,
                    }}
                >
                    <i className="fas fa-save" style={{ marginRight: "8px" }}></i>
                    Save
                    </button>
                </div>
                )}
        </div>
    );
};





// #####################################################




















const RegistrationsExpirationFilter = () => {
    const OPTIONS = [
        { label: "Expired", value: "expired" },
        { label: "1 Month", value: "30" },
        { label: "3 Months", value: "91" },
        { label: "6 Months", value: "182" },
        { label: "9 Months", value: "273" },
        { label: "12 Months", value: "365" },
        { label: "24 Months", value: "730" },
    ];

    const buildUrl = (value) => {
        return `/your-medboard/country-registrations/registrations/?filter[ExpirationLimit]=${value}`;
    };

    const getQueryParam = (paramName) => {
        const params = new URLSearchParams(window.location.search);
        return params.get(paramName);
    };

    const expirationFilter = useMemo(
        () => getQueryParam("filter[ExpirationLimit]"),
        []
    );

    const hasFilter = Boolean(expirationFilter);

    const handleChange = (e) => {
        const value = e.target.value;
        window.location.href = buildUrl(value);
    };

    if (!hasFilter) {
        return null;
    }

    const currentValue = expirationFilter || "365";

    return (
        <div style={{ fontSize: "12px", display: "inline-block", padding: "4px 12px", borderRadius: "15px", marginRight: "auto", marginLeft: "17px" }}>
            
            <a
                href="/your-medboard/country-registrations/registrations/"
                className="btn u-btn-outline-primary g-font-size-13 g-pl-15 g-pr-15 g-pt-5 g-pb-5 g-mr-40 border-radius-20"
            >
                <i className="fas fa-database g-pr-8"></i>
                All Product Registrations
            </a>

            <a
                href={buildUrl("expired")}
                className="btn u-btn-outline-primary g-font-size-13 g-pl-15 g-pr-15 g-pt-5 g-pb-5 g-mr-40 border-radius-20"
            >
                <i className="fas fa-calendar-times g-pr-8"></i>
                Expired Registrations
            </a>

            <label htmlFor="changeExpired" style={{marginRight: "5px"}}>
                Registrations that expire in the next:
            </label>

            <select
                className="expiredDropDown"
                id="changeExpired"
                name="changeExpired"
                value={currentValue}
                onChange={handleChange}
            >
                {OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
        </div>
    );
};


const ShowRegistrationsFilterCountryName = ({ countryId }) => {
    const [countries, setCountries] = React.useState([]);
    const [countryName, setCountryName] = React.useState("");
    const [flagLink, setFlagLink] = React.useState("");

    React.useEffect(() => {
        loadCountries();
    }, []);

    React.useEffect(() => {
        if (countries.length > 0 && countryId) {
            const country = countries.find(
                (c) => c.CountryId === parseInt(countryId)
            );

            if (country) {
                setCountryName(country.CountryName);
                setFlagLink(country.FlagLink);
            }
        }
    }, [countries, countryId]);

    const loadCountries = () => {
        let countriesUrl = "/umbraco/api/RIMSProducts/Countries";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(countriesUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {
                if (result) {
                    setCountries(result);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return <span style={{marginLeft:"20px"} }> <img className="countryFlag" src={flagLink} style={{ height: "20px", marginRight: "5px" }} />
        {countryName}</span>;
};






const ShowProductsFilterProductName = ({ productId }) => {
    const [product, setProduct] = React.useState(null);
    const [productName, setProductName] = React.useState("");

    React.useEffect(() => {
        loadProduct();
    }, []);

    React.useEffect(() => {
        if (product != null && productId) {
            setProductName(product.SKUProductCode+ " · " +product.ProductName);
        }
    }, [product, productId]);

    const loadProduct = () => {
        let productUrl = "/umbraco/api/RIMSProducts/Product/?id=" + productId;

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(productUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {
                if (result) {
                    setProduct(result);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return <span>{productName}</span>;
};


const ShowProductsFilterLegalManufacturerName = ({legalManufacturerId}) => {
    return <ShowProductsFilterOperatorName operatorId={legalManufacturerId} operatorRoleId={1} />
}

const ShowProductsFilterPhysicalManufacturerName = ({physicalManufacturerId}) => {
    return <ShowProductsFilterOperatorName operatorId={physicalManufacturerId} operatorRoleId={5} />
}

const ShowProductsFilterSPPPName = ({SPPPId}) => {
    return <ShowProductsFilterOperatorName operatorId={SPPPId} operatorRoleId={9} />
}





const ShowProductsFilterOperatorName = ({ operatorId, operatorRoleId }) => {
    const [operator, setOperator] = React.useState(null);
    const [operatorName, setOperatorName] = React.useState("");

    React.useEffect(() => {
        loadOperator();
    }, []);

    React.useEffect(() => {
        if (operator != null && operatorId) {
			setOperatorName(operator.Name);
        }
    }, [operator, operatorId]);

    const loadOperator = () => {
        let operatorUrl = "/umbraco/api/RIMSRegistrations/Operator/?id=" + operatorId;

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(operatorUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {
                if (result) {
                    setOperator(result);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

	let role = "";
	switch(operatorRoleId) {
		case 1: role = "Legal Manufacturer"; break;
		case 5: role = "Physical Manufacturer"; break;
		case 9: role = "SPPP"; break;
		default: break;
	}

    return <span>{role} - {operatorName}</span>;
};










const ErrorMessagePopup = ({ error, onClose }) => {
    const [visible, setVisible] = useState(true);

    if (!visible || !error) return null;

    const handleClose = () => {
        setVisible(false);

        if (onClose) {
            onClose();
        }
    };

    return (
        <div
            className="add-task-popup"
            style={{
                //position: "fixed",
                top: "50%",
                //left: "50%",
                //transform: "translate(-50%, -50%)",
                width: "450px",
                background: "#fff",
                borderRadius: "12px",
                padding: "20px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                zIndex: 9999,
            }}
        >
            {/* Header */}
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginBottom: "20px",
                }}
            >
                <div style={{ width: "50%" }}>
                    <h3 style={{ margin: 0 }}>Error</h3>
                </div>

                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={handleClose}
                        style={{
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            fontSize: "18px",
                        }}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>

            {/* Content */}
            <div
                style={{
                    padding: "20px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "10px",
                    background: "#ffefef",
                    marginBottom: "20px",
                }}
            >
                <p style={{ margin: 0, fontSize: "15px", color: "#333" }}>
                    {error.Message || "Unknown error"}
                </p>

                {/* process the error.Data object here if there is more info */}

            </div>

            


            
        </div>
    );
};





const TimelinePopup = () => {

    const AppContext = useContext(GlobalAppContext);

    const [graphInfo, setGraphInfo] = useState({ categories: [], data: [] });


    let today = new Date();

    const day = 1000 * 60 * 60 * 24;
        

    // Set to 00:00:00:000 today
    today.setUTCHours(0);
    today.setUTCMinutes(0);
    today.setUTCSeconds(0);
    today.setUTCMilliseconds(0);
    today = today.getTime();

    function updateRemoveButtonStatus() {
        
    }

    const graphOptions = useMemo(() => (
        {
            chart: {
                backgroundColor: '#fafafa',
                spacingBottom: 30,
                zoomType: 'x',
                panning: true,
            },

            exporting: {
                enabled: true,
                fallbackToExportServer: false,
                chartOptions: {
                    chart: {
                        width: 1200,
                        events: {
                            load: function () {
                                const chart = this;
                                const yAxis = chart.yAxis[0];

                                // Optional: remove previous images in case of multiple exports
                                if(Array.isArray(chart.exportImages))
                                    chart.exportImages.forEach(img => img.destroy());
                                chart.exportImages = [];

                                Object.keys(yAxis.ticks).forEach((tickPos) => {
                                    const tick = yAxis.ticks[tickPos];
                                    const category = graphInfo.categories[tickPos];

                                    if (!category || !tick.label) return;

                                    // Compute position relative to exported chart
                                    const rowHeight = yAxis.len / yAxis.tickPositions.length;
                                    const x = tick.label.attr('x') + 2;
                                    const y = tick.label.attr('y') - rowHeight / 2 - 4;

                                    const countryFlag = window.location.origin + category.countryFlag;

                                    const img = chart.renderer
                                        .image(countryFlag, x, y, 16, 16)
                                        .add();

                                    chart.exportImages.push(img);
                                });
                            }
                        }
                    }
                },
                buttons: {
                    contextButton: {
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadSVG"] // Dont add the pdf...
                    }
                }

            },

            title: {
                text: 'Timelines'
            },

            subtitle: {
                text: ''
            },
            credits: {
                enabled: true,
                text: 'MedBoard.com',
                href: 'https://www.medboard.com',
                mapText: null
            },

            lang: {
                accessibility: {
                    axis: {
                        xAxisDescriptionPlural: 'The chart has a two-part X axis ' +
                            'showing time in both week numbers and days.'
                    }
                }
            },

            accessibility: {
                point: {
                    descriptionFormat: '{#if milestone}' +
                            '{name}, milestone for {yCategory} at {x:%Y-%m-%d}.' +
                        '{else}' +
                            '{name}, assigned to {yCategory} from {x:%Y-%m-%d} to {x2:%Y-%m-%d}.' +
                        '{/if}'
                }
            },

            plotOptions: {
                series: {
                    animation: false, // Do not animate dependency connectors
                    dragDrop: {
                        draggableX: true,
                        draggableY: true,
                        dragMinY: 0,
                        dragMaxY: 2,
                        dragPrecisionX: day / 3 // Snap to eight hours
                    },
                    dataLabels: {
                        enabled: true,
                        format: '{point.name}',
                        style: {
                            cursor: 'default',
                            pointerEvents: 'none'
                        }
                    },
                    allowPointSelect: true,
                    point: {
                        events: {
                            select: updateRemoveButtonStatus,
                            unselect: updateRemoveButtonStatus,
                            remove: updateRemoveButtonStatus
                        }
                    }
                },
                gantt: {
                    dataLabels: {
                        enabled: true,
                        allowOverlap: true
                    }
                }
            },

            yAxis: {
                type: 'category',
                categories: graphInfo.categories,
                accessibility: {
                    description: 'Regulations'
                },
                min: 0,
                max: graphInfo.categories.length ? graphInfo.categories.length - 1 : 0,
                labels: {
                    style: {
                        width: '250px',          // maximum width
                        whiteSpace: 'normal',    // wrap text if needed
                        textOverflow: 'ellipsis' // truncate if too long
                    },
                    align: 'left',   // left-align text
                    useHTML: true,
                    formatter: function () {
                        const countryFlag = window.location.origin + this.value.countryFlag; // if category is an object
                        const countryName = this.value.countryName;
                        const text = this.value.text || this.value;

                        return `
                            <div style="display:flex; align-items:center; gap:6px; margin-left: 8px;">
                                <img src="${countryFlag}" 
                                     style="width:16px;height:16px;object-fit:contain;" 
                                     title="${countryName}"
                                     />
                                <span title="${text}">${text}</span>
                            </div>
                        `;
                    }
                }
            },

            xAxis: {
                currentDateIndicator: false,
                scrollbar: { enabled: true },
                min: graphInfo.xAxis ? graphInfo.xAxis.min : null,
                max: graphInfo.xAxis ? graphInfo.xAxis.max : null,
                type: 'datetime',
                dateTimeLabelFormats: {
                    month: '%b', // Jan, Feb, Mar
                    year: '%Y'   // 2026, 2027
                },
                plotLines: [{
                    value: Date.now(),
                    color: '#aaa',
                    width: 2,
                    zIndex: 1,
                    label: { // Today line
                        text: 'Current date: ' + Highcharts.dateFormat('%Y-%m-%d', Date.now()), 
                        align: 'center',
                        verticalAlign: 'bottom',
                        y: 10,
                        rotation: 0,
                        style: {
                            fontWeight: 'bold',
                            color: '#aaa'
                        }
                    }
                }]
            },

            tooltip: {
                useHTML: true,
                outside: true,
                formatter() {
                    
                    const p = this.point;
                    const start = p.start || p.x;
                    const end = p.hasEndDate ? p.end : null;
                    const description = p.description ? `<br/><span className="tooltip-desc">${p.description}</span>` : '';

                    // Milestone (grouped)
                    if (p.milestone && Array.isArray(p.entries)) {

                        const sortedEntries = [...p.entries].sort((a, b) => {
                            const priority = (t) => {
                                if (t === 4 || t === 2) return 0; // highest priority
                                if (t === 3) return 2;           // lowest priority
                                return 1;                        // middle
                            };

                            return priority(a.type) - priority(b.type);
                        });

                        return `
                            <div style="width: 400px; max-width: 400px; white-space: normal; overflow-wrap: break-word;">
                                <b>${Highcharts.dateFormat('%Y-%m-%d', start)}</b>
                                ${sortedEntries.map(e => `
                                    <br/><br/>
                                    <b>${e.name}</b>
                                    ${e.description
                                        ? `<br/><div className="tooltip-desc">${e.description}</div>`
                                        : ''
                                    }
                                `).join('')}
                            </div>
                        `;
                    }


                    // It's a tooltip for the bar itself
                    return `
                        <div style="width: 400px; max-width: 400px; white-space: normal; overflow-wrap: break-word;">
                            <b>${p.tooltipName || p.name}</b>
                            <br/>Publication date: ${Highcharts.dateFormat('%Y-%m-%d', start)}
                            <br/>
                            ${description}
                        </div>
                    `;


                }
            },




            series: [{
                name: 'Timeline',
                data: graphInfo.data
            }]
        }
    ), [graphInfo]);




    useEffect(() => {

        let selectedItems = AppContext.data.filter(item => AppContext.selectedReferences.includes(item.Id));
        //let categories = selectedItems.map(item => item.Name);
        let mainItems = [];
        let milestones = [];
        let milestonesColors = {
            DateType_2: "#4ed033",  // Entry into force date
            DateType_3: "#FFFFFF",  // Generic date
            DateType_4: "#de3a3a",  // End date
        }


        // DUMMY VALUES
        // DUMMY VALUES
        // DUMMY VALUES
        let useDummy = false;

        if (useDummy) {

            selectedItems = selectedItems.map((item, index) => {

                if (!item.ApplicabilityDates || item.ApplicabilityDates.length == 0) {

                    if (index == 0) {

                        item.Date = "2025-01-05T00:00:00";
                        item.EndDate = { "DateType": 4, "DateValue": "2026-03-05T00:00:00", "DateTitle": "Subject to paragraph (3)", "DateDescription": "Description for item " + index },
                        item.EntryIntoForceDate = { "DateType": 2, "DateValue": "2025-02-06T00:00:00", "DateTitle": "EntryIntoForceDate", "DateDescription": "Description for item " + index },

                        item.ApplicabilityDates = [
                            { "DateType": 3, "DateValue": "2025-09-05T00:00:00", "DateTitle": "Subject to paragraph (3)", "DateDescription": "Description for item " + index },
                            { "DateType": 3, "DateValue": "2025-08-31T00:00:00", "DateTitle": "Regulation 2(2) comes into force", "DateDescription": "Description for item " + index },
                            { "DateType": 3, "DateValue": "2025-02-06T00:00:00", "DateTitle": "Publication Date 1", "DateDescription": "Description for publication date 1" },
                            { "DateType": 3, "DateValue": "2025-02-06T00:00:00", "DateTitle": "Publication Date 2", "DateDescription": "Description for publication date 2" },
                            { "DateType": 3, "DateValue": "2025-02-06T00:00:00", "DateTitle": "another milestone", "DateDescription": "Description for another milestone" },
                            { "DateType": 3, "DateValue": "2026-03-05T00:00:00", "DateTitle": "milestone same as END DATE", "DateDescription": "Description for publication milestone on END DATE" },
                        ];
                        return item;
                    }

                    if (index % 2 == 0) {
                        item.ApplicabilityDates = [
                            { "DateType": 3, "DateValue": "2026-08-15T00:00:00", "DateTitle": "Subject to paragraph (3)", "DateDescription": "Description for item " + index },
                            { "DateType": 3, "DateValue": "2027-10-23T00:00:00", "DateTitle": "Regulation 2(2) comes into force", "DateDescription": "Description for item " + index },
                            { "DateType": 1, "DateValue": "2026-02-16T00:00:00", "DateTitle": "Publication Date", "DateDescription": null }
                        ];
                    }
                    else {
                        item.ApplicabilityDates = [
                            { "DateType": 3, "DateValue": "2026-05-19T00:00:00", "DateTitle": "Publication", "DateDescription": "Description for item " + index },
                            { "DateType": 3, "DateValue": "2027-02-21T00:00:00", "DateTitle": "Another milestone", "DateDescription": "Description for item " + index },
                            { "DateType": 1, "DateValue": "2026-10-02T00:00:00", "DateTitle": "Middle", "DateDescription": null }
                        ];
                    }

                }
                return item;

            });

        }




        function getComplianceStatus(statusId) {

            let status = Constants.ComplianceStatuses.find((status) => status.id == statusId);

            if (!status)
                status = { name: "", bgColor: "#d5d5d5" };

            return status;

        }

        
        function getUTCDate(date) {
            let d = new Date(date);

            let UTCMilliseconds = Date.UTC(
                d.getFullYear(),
                d.getMonth(),
                d.getDate()
            );

            return UTCMilliseconds;

        }

        function yearInMilliseconds() {

            return 1000 * 60 * 60 * 24 * 365;
        }


        // This allDates is just to calculate the limits of the graph
        let allDates = [];

        selectedItems.map((item, index) => {

            const timeline = item.ApplicabilityDates;

            if (item.Date)
                allDates.push(getUTCDate(item.Date));

            if (item.EntryIntoForceDate)
                allDates.push(getUTCDate(item.EntryIntoForceDate.DateValue));

            if (item.EndDate)
                allDates.push(getUTCDate(item.EndDate.DateValue));


            if (!timeline)
                return;

            const dates = timeline
                .map(t => getUTCDate(t.DateValue))
                .filter(d => !isNaN(d)); // guards against bad/null values

            allDates.push(...dates);
        });


        // Artificially add today as a date to FAR_FUTURE calculation below
        let today = getUTCDate(new Date());
        allDates.push(today);


        // Assume max is today unless the items has dates

        let OverallMaxDate = getUTCDate();
        let OverallMinDate = getUTCDate();

        if (allDates.length > 0) {
            OverallMaxDate = Math.max(...allDates);
            OverallMinDate = Math.min(...allDates);
        }


        // For better graph scaling

        let FAR_FUTURE = OverallMaxDate + yearInMilliseconds() * 2; // Artificially add largest graph date limit: max(today, biggestEndDate) + 2 years
        let MAIN_START = OverallMinDate - 1000 * 60 * 60 * 24 * 30; // add 1 month buffer before start


        selectedItems.map((item, index) => {

            if (!item.ApplicabilityDates && !item.EntryIntoForceDate && !item.Date)
                return;

            if (!item.ApplicabilityDates)
                item.ApplicabilityDates = [];

            // Consider the EntryIntoForceDate if existing as an item of the ApplicabilityDate

            if (item.EntryIntoForceDate)
                item.ApplicabilityDates.push(item.EntryIntoForceDate);


            // Calculate the minimum date for this item's objects

            let allDates = [];

            // Add Start date if existing

            if (item.Date)
                allDates.push(getUTCDate(item.Date))

            // Add all applicable dates of timeline

            item.ApplicabilityDates?.map((tl, index) => {
                allDates.push(getUTCDate(tl.DateValue));
            });

            // What's the start date after adding all that?

            const minDate = allDates.length ?  Math.min(...allDates) : getUTCDate();


            // Has a defined End Date?

            let hasEndDate = false;
            let maxDate = FAR_FUTURE;

            if (item.EndDate) {
                hasEndDate = true;
                maxDate = getUTCDate(item.EndDate.DateValue);
            }


            // Add the main block




            let complianceStatus = getComplianceStatus(item.Status);

            mainItems.push({
                start: minDate,
                end: maxDate,
                name: "", //"BLOCK: " + item.Name,
                tooltipName: item.Name,
                id: 'timeline_item_' + index + "_",
                tempY: index, // defined which main row it goes into
                hasEndDate: hasEndDate,
                description: "Compliance Status: " + complianceStatus.name,
                color: complianceStatus.bgColor,
                countryFlag: item.CountryFlag, //"/media/3616/screenshot-2019-07-12-at-174703.png?width=25&amp;height=25&amp;mode=max",
                countryName: item.Country, //"Mexico",                                                                              
            });



            // Add end date as a milestone

            if (hasEndDate) {

                milestones.push({
                    start: getUTCDate(item.EndDate.DateValue),
                    name: "End date",
                    description: "",
                    tooltipName: "End Date",
                    milestone: true,
                    id: 'timeline_item_' + index + "_enddate",
                    tempY: index, // defined which main row it goes into
                    entries: [{
                        name: "End Date",
                        description: "",
                        type: item.EndDate.DateType,
                    }],
                    radius: 2,
                    color: milestonesColors["DateType_4"],
                    borderColor: '#000000',
                    backgroundColor: milestonesColors["DateType_4"],
                    borderWidth: 1,
                    dataLabels: {
                        enabled: false
                    },
                    
                });

            }




            // Add all the milestones

            item.ApplicabilityDates?.forEach((tl, index2) => {

                const start = getUTCDate(tl.DateValue);

                // Try to find an existing milestone with the same start + row
                let existing = milestones.find(m => m.start === start && m.tempY === index);

                // If found push into its entries array
                if (existing) {
                    existing.entries.push({
                        name: tl.DateTitle,
                        description: tl.DateDescription,
                        type: tl.DateType,
                    });

                    // is it a more priority item? type 2 (entry) or 4 (enddate) above 3 (generic)

                    if (tl.DateType == 2 || tl.DateType == 4) {
                        existing.color = milestonesColors['DateType_' + tl.DateType];
                        existing.backgroundColor = milestonesColors['DateType_' + tl.DateType];
                    }

                    return;
                }

                // Otherwise create a new milestone
                milestones.push({
                    start: start,
                    milestone: true,
                    id: 'timeline_item_' + index + '_' + index2,
                    tempY: index,
                    entries: [{
                        name: tl.DateTitle,
                        description: tl.DateDescription,
                        type: tl.DateType,
                    }],
                    color: milestonesColors['DateType_' + tl.DateType],
                    backgroundColor: milestonesColors['DateType_' + tl.DateType],
                    borderColor: '#000000',
                    borderWidth: 1,
                    dataLabels: {
                        enabled: false
                    }
                });
            });




            
        });


        // Sort items by start date and reassign the milestones
        mainItems = mainItems
            .sort((a, b) => b.start - a.start)
            .map((item, index) => {
                item.y = index;

                // reassign milestones
                milestones = milestones.map(ms => {
                    if (ms.tempY == item.tempY)
                        ms.y = item.y

                    return ms;
                })

                return item;
            })



        let categories = mainItems.map(item => (
            {
                countryFlag: item.countryFlag,
                countryName: item.countryName,
                text: item.tooltipName,
            }));


        let finalData = [...mainItems, ...milestones];


        let info = { categories, data: finalData, xAxis: { min: MAIN_START, max: FAR_FUTURE } };


        setGraphInfo(info);

    }, []);







    return (
        <div className="add-task-popup" style={{minWidth: "90%", zIndex: 1}}>
            <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px" }}>


                <div style={{ width: "50%" }}>
                    <h3>Timelines: {AppContext.selectedReferences.length && AppContext.selectedReferences.length > 0 ? AppContext.selectedReferences.length + " selected reference(s)" : ""}</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => { AppContext.setShowTimelineGraphPopup(false); }}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

            </div>

            <div style={{ textAlign: "center", marginTop: "25px", marginBottom: "25px" }}>

                {graphInfo.categories.length > 0 ? 
                    <HighchartsReact highcharts={AppContext.HighchartsGantt} constructorType="ganttChart" options={graphOptions} />
                : null}

            </div>

        </div>
    );

}




const TechnicalDocumentationTemplatesList = () => {

    const AppContext = useContext(GlobalAppContext);

    const [isLoadingTemplates, setIsLoadingTemplates] = useState(false);
    const [templates, setTemplates] = useState([]);
    const [deletingTemplate, setDeletingTemplate] = useState(null);
    const [updatingTemplate, setUpdatingTemplate] = useState(null);
    const [showingUpdatePopup, setShowingUpdatePopup] = useState(false);
    const [showingDeletePopup, setShowingDeletePopup] = useState(false);
    const [template, setTemplate] = useState(null);
    const [alreadyExists, setAlreadyExists] = useState(false);



    useEffect(() => {

        loadTemplates();

    }, []);



    const loadTemplates = () => {

        let url = "/umbraco/api/TechnicalDocumentation/Templates/";

        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsLoadingTemplates(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok)
                    throw new Error("Network response was not ok");
                return response.json();
            })
            .then((data) => {
                setTemplates(data);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setIsLoadingTemplates(false);
            });

    }




    
    
    const updateTemplate = () => {

        let url = "/umbraco/api/TechnicalDocumentation/Templates/?templateId=" + template.Id + "&name=" + template.Title;

        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
        };

        if (template.Title == "")
            return;

        if (templates.find(t => t.Title == template.Title)) {
            setAlreadyExists(true);
            return;
        }

        setAlreadyExists(false);
        setUpdatingTemplate(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok)
                    throw new Error("Network response was not ok");
                return response.json();
            })
            .then((data) => {
                setTemplates(prev => prev.map(t => t.Id == template.Id ? data : t));
                setShowingUpdatePopup(false);
                setTemplate(null);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setUpdatingTemplate(false);
            });

    }





    const deleteTemplate = () => {

        let url = "/umbraco/api/TechnicalDocumentation/Templates/?templateId=" + template.Id;

        const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        };


        setDeletingTemplate(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok)
                    throw new Error("Network response was not ok");
                return response.json();
            })
            .then((data) => {
                setTemplates(templates.filter(t => t.Id != template.Id));
                setShowingDeletePopup(false);
                setTemplate(null);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setDeletingTemplate(false);
            });

    }





    
    const openUpdatePopup = (id) => {

        let t = templates.find(template => template.Id == id);

        setTemplate(t);
        setShowingUpdatePopup(true);
    }

    
    const openDeletePopup = (id) => {

        let t = templates.find(template => template.Id == id);

        setTemplate(t);
        setShowingDeletePopup(true);
    }




    return <>

        <div className="add-task-popup">

            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Technical Documentation Templates</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.setIsVisibleTechnicalDocumentationTemplates(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>

            {isLoadingTemplates ? <div><LoadingSpinnerImage /></div> :

                <div style={{marginTop: "15px"}}>

                    <div style={{ marginBottom: "20px" }}>
                        To create a template, open an approved version of a Technical Documentation and choose "Save as template" from its options menu (top right)
                    </div>

                {templates.length == 0 ? 

                    <div>You don't have any templates yet</div>
                : 
                    <div className="datatable-container" style={{ display: "flex", flexDirection: "column", }}>

                        <div className="datatable-header" style={{ minWidth: "100%" }}>
                            <div style={{ width: "65%" }}>Template name</div>
                            <div style={{ width: "15%" }}>Sections</div>
                            <div style={{ width: "20%" }}>Actions</div>
                        </div>

                        <div
                            className="datatable-content thin-scrollbar"
                            style={{
                                flex: 1,
                                minWidth: "100%",
                                overflowY: "auto",
                                overflowX: "hidden",
                                maxHeight: "400px",
                            }}
                        >
                            <div>
                                {templates && templates.sort((a, b) => b.IsMedboard - a.IsMedboard).map((template, index) =>
                                    <div className="datatable-row" key={index}>
                                        <div style={{ width: "65%" }}>
                                            {template.Title}
                                            {template.IsMedboard ?
                                                <span style={{display: "flex", borderRadius: "15px", marginLeft: "10px", padding: "5px 0px", backgroundColor: "#eee"}}>
                                                    <img src="https://app.medboard.com/media/cbaew04v/logo.svg" alt="Medboard" style={{ maxHeight: "10px", minHeight: "10px" }} />
                                                </span>
                                            : null}
                                        </div>
                                        <div style={{ width: "15%" }}>
                                            {(template.Sections?.length ?? 0)} section{template.Sections?.length === 1 ? "" : "s"}
                                        </div>
                                        <div style={{ width: "20%" }}>

                                            {!template.IsMedboard ? <>

                                                <span onClick={() => openUpdatePopup(template.Id)} style={{ cursor: "pointer", marginRight: "15px" }}><i className="fas fa-pencil-alt"></i></span>

                                                <span onClick={() => openDeletePopup(template.Id)} style={{ cursor: "pointer" }}><i className="fas fa-trash-alt"></i></span>

                                            </> : null}

                                        </div>
                                    </div>
                                )}
                            </div>

                        </div>


                    </div>

                }

                </div>

            }








            {/**/ }












        </div>




        {/**/}




        
        {showingUpdatePopup ? 

            <div className="add-task-popup" style={{minWidth: "300px", width: "400px", marginTop: "100px", backgroundColor: "#ebebeb", }}>

                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "50%" }}>
                        <h3>Update Template</h3>
                    </div>
                    <div style={{ width: "50%", textAlign: "right" }}>
                        <button
                            className="close-button"
                            onClick={() => setShowingUpdatePopup(false)}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>


                <div style={{display: "flex", flexDirection: "row"}}>
                    <div style={{width: "70%"}}>
                        <input style={{ width: "100%" }}type="text" value={template.Title} onChange={(e) => setTemplate({ ...template, Title: e.target.value })} />
                    </div>
                </div>
                {alreadyExists ? <>
                    <span style={{ fontSize: "9pt", color: "#ff722e" }}>Template already exists</span>
                </> : null}


                <div style={{display: "flex", justifyContent: "end", marginTop: "15px"}}>
                    <div>
                        {updatingTemplate ?
                            <LoadingSpinnerImage /> : 
                            <span onClick={updateTemplate} className="action-button add-task-button"><i className="fas fa-pencil-alt g-mr-5"></i> Update</span>
                        }
                    </div>
                </div>



            </div>

            : null}






        
        {showingDeletePopup ? 

            <div className="add-task-popup" style={{minWidth: "300px", width: "400px", marginTop: "100px", backgroundColor: "#ebebeb", }}>

                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "50%" }}>
                        <h3>Delete Template</h3>
                    </div>
                    <div style={{ width: "50%", textAlign: "right" }}>
                        <button
                            className="close-button"
                            onClick={() => setShowingDeletePopup(false)}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>




                <div style={{display: "flex", flexDirection: "column"}}>
                    <div style={{width: "100%", marginBottom: "15px", textAlign: "center"}}>
                        <br/>Are you sure you want to delete this template?<br/><br/><b>{template.Title}</b>
                    </div>
                </div>



                <div style={{display: "flex", justifyContent: "end", marginTop: "15px"}}>
                    <div>
                        {deletingTemplate ?
                            <LoadingSpinnerImage /> : 
                            <span onClick={deleteTemplate} className="action-button add-task-button" style={{backgroundColor: "#be2c2c"}}><i className="far fa-trash-alt g-mr-5"></i> Delete</span>
                        }
                    </div>
                </div>

            </div>

        : null }



    </>


}




const TechnicalDocumentationJurisdictionsList = () => {

    const AppContext = useContext(GlobalAppContext);

    const [isLoadingJurisdictions, setIsLoadingJurisdictions] = useState(false);
    const [jurisdictions, setJurisdictions] = useState([]);
    const [jurisdiction, setJurisdiction] = useState(null);
    const [showingAddPopup, setShowingAddPopup] = useState(false);
    const [showingUpdatePopup, setShowingUpdatePopup] = useState(false);
    const [showingDeletePopup, setShowingDeletePopup] = useState(false);
    const [addingJurisdiction, setAddingJurisdiction] = useState(false);
    const [updatingJurisdiction, setUpdatingJurisdiction] = useState(false);
    const [deletingJurisdiction, setDeletingJurisdiction] = useState(false);
    const [alreadyExists, setAlreadyExists] = useState(false);

    useEffect(() => {

        loadJurisdictions();

    }, []);



    const loadJurisdictions = () => {

        let url = "/umbraco/api/TechnicalDocumentation/Jurisdictions/";

        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsLoadingJurisdictions(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok)
                    throw new Error("Network response was not ok");
                return response.json();
            })
            .then((data) => {
                setJurisdictions(data);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setIsLoadingJurisdictions(false);
            });

    }

    
    
    const addJurisdiction = () => {

        let url = "/umbraco/api/TechnicalDocumentation/Jurisdictions/?name=" + jurisdiction.Name;

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        };

        if (jurisdiction.Name == "")
            return;

        if (jurisdictions.find(j => j.Name == jurisdiction.Name)) {
            setAlreadyExists(true);
            return;
        }

        setAlreadyExists(false);
        setAddingJurisdiction(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok)
                    throw new Error("Network response was not ok");
                return response.json();
            })
            .then((data) => {
                setJurisdictions([...jurisdictions, data]);
                setShowingAddPopup(false);
                setJurisdiction(null);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setAddingJurisdiction(false);
            });

    }


    
    const updateJurisdiction = () => {

        let url = "/umbraco/api/TechnicalDocumentation/Jurisdictions/?jurisdictionId=" + jurisdiction.Id + "&name=" + jurisdiction.Name;

        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
        };

        if (jurisdiction.Name == "")
            return;

        if (jurisdictions.find(j => j.Name == jurisdiction.Name)) {
            setAlreadyExists(true);
            return;
        }

        setAlreadyExists(false);
        setUpdatingJurisdiction(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok)
                    throw new Error("Network response was not ok");
                return response.json();
            })
            .then((data) => {
                setJurisdictions(prev => prev.map(j => j.Id == jurisdiction.Id ? data : j));
                setShowingUpdatePopup(false);
                setJurisdiction(null);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setUpdatingJurisdiction(false);
            });

    }



    const deleteJurisdiction = () => {

        let url = "/umbraco/api/TechnicalDocumentation/Jurisdictions/?jurisdictionId=" + jurisdiction.Id;

        const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        };

        setDeletingJurisdiction(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok)
                    throw new Error("Network response was not ok");
                return response.json();
            })
            .then((data) => {
                setJurisdictions(jurisdictions.filter(jur => jur.Id != jurisdiction.Id));
                setShowingDeletePopup(false);
                setJurisdiction(null);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setDeletingJurisdiction(false);
            });

    }



    const openAddPopup = () => {

        let newJ = { Name: "" };

        setAlreadyExists(false);
        setJurisdiction(newJ);
        setShowingAddPopup(true);
    }


    const openUpdatePopup = (id) => {

        let j = jurisdictions.find(jur => jur.Id == id);

        setAlreadyExists(false);
        setJurisdiction(j);
        setShowingUpdatePopup(true);
    }


    const openDeletePopup = (id) => {

        let j = jurisdictions.find(jur => jur.Id == id);

        setJurisdiction(j);
        setShowingDeletePopup(true);
    }

    return <>

        <div className="add-task-popup">

            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Technical Documentation Jurisdictions</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.setIsVisibleTechnicalDocumentationJurisdictions(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>

            {isLoadingJurisdictions ? <div><LoadingSpinnerImage /></div> :

                <>

                    <div style={{marginTop: "10px", marginBottom: "15px", display: "flex", justifyContent: "right"}}>
                        <span className="action-button add-task-button" onClick={openAddPopup}><i className="fas fa-plus-circle g-mr-5"></i> Add Jurisdiction</span>
                    </div>

                {jurisdictions.length == 0 ? 

                    <div>You don't have any jurisdictions yet.</div>
                : 
                    <div className="datatable-container" style={{ display: "flex", flexDirection: "column", }}>

                        <div className="datatable-header" style={{ minWidth: "100%" }}>
                            <div style={{ width: "80%" }}>Jurisdiction</div>
                            <div style={{ width: "20%" }}>Actions</div>
                        </div>

                        <div
                            className="datatable-content thin-scrollbar"
                            style={{
                                flex: 1,
                                minWidth: "100%",
                                overflowY: "auto",
                                overflowX: "hidden",
                                maxHeight: "400px",
                            }}
                        >
                            <div>
                                {jurisdictions && jurisdictions.sort((a, b) => b.IsMedboard - a.IsMedboard).map((jurisdiction, index) => 
                                    <div className="datatable-row" key={index}>
                                        <div style={{ width: "80%" }}>
                                            {jurisdiction.Name}
                                            {jurisdiction.IsMedboard ?
                                                <span style={{display: "flex", borderRadius: "15px", marginLeft: "10px", padding: "5px 0px", backgroundColor: "#eee"}}>
                                                    <img src="https://app.medboard.com/media/cbaew04v/logo.svg" alt="Medboard" style={{ maxHeight: "10px", minHeight: "10px" }} />
                                                </span>
                                            : null}
                                        </div>
                                        <div style={{ width: "20%" }}>

                                            {!jurisdiction.IsMedboard ? <>

                                                {updatingJurisdiction == jurisdiction.Id ? <LoadingSpinnerImage /> : <span onClick={() => openUpdatePopup(jurisdiction.Id)} style={{ cursor: "pointer", marginRight: "15px" }}><i className="fas fa-pencil-alt"></i></span>}

                                                {deletingJurisdiction == jurisdiction.Id ? <LoadingSpinnerImage /> : <span onClick={() => openDeletePopup(jurisdiction.Id)} style={{ cursor: "pointer", marginRight: "15px"  }}><i className="fas fa-trash-alt"></i></span>}

                                            </> : null}

                                        </div>
                                    </div>
                                )}
                            </div>

                        </div>


                    </div>

                }

                </>

            }

        </div>


        {/**/}



        {showingAddPopup ? 

            <div className="add-task-popup" style={{minWidth: "300px", width: "400px", marginTop: "100px", backgroundColor: "#ebebeb", }}>

                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "50%" }}>
                        <h3>Add Jurisdiction</h3>
                    </div>
                    <div style={{ width: "50%", textAlign: "right" }}>
                        <button
                            className="close-button"
                            onClick={() => setShowingAddPopup(false)}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>

                <div style={{display: "flex", flexDirection: "row"}}>
                    <div style={{width: "70%"}}>
                        <input style={{ width: "100%" }} type="text" value={jurisdiction.Name} onChange={(e) => setJurisdiction({ ...jurisdiction, Name: e.target.value })} />
                    </div>
                </div>
                {alreadyExists ? <>
                    <span style={{ fontSize: "9pt", color: "#ff722e" }}>Jurisdiction already exists</span>
                </> : null}



                <div style={{display: "flex", justifyContent: "end", marginTop: "15px"}}>
                    <div>
                        {addingJurisdiction ?
                            <LoadingSpinnerImage /> : 
                            <span onClick={addJurisdiction} className="action-button add-task-button"><i className="fas fa-plus-circle g-mr-5"></i> Add</span>
                        }
                    </div>
                </div>




            </div>

        : null }




        
        {showingUpdatePopup ? 

            <div className="add-task-popup" style={{minWidth: "300px", width: "400px", marginTop: "100px", backgroundColor: "#ebebeb", }}>

                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "50%" }}>
                        <h3>Update Jurisdiction</h3>
                    </div>
                    <div style={{ width: "50%", textAlign: "right" }}>
                        <button
                            className="close-button"
                            onClick={() => setShowingUpdatePopup(false)}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>


                <div style={{display: "flex", flexDirection: "row"}}>
                    <div style={{width: "70%"}}>
                        <input style={{ width: "100%" }}type="text" value={jurisdiction.Name} onChange={(e) => setJurisdiction({ ...jurisdiction, Name: e.target.value })} />
                    </div>
                </div>
                {alreadyExists ? <>
                    <span style={{ fontSize: "9pt", color: "#ff722e" }}>Jurisdiction already exists</span>
                </> : null}


                <div style={{display: "flex", justifyContent: "end", marginTop: "15px"}}>
                    <div>
                        {updatingJurisdiction ?
                            <LoadingSpinnerImage /> : 
                            <span onClick={updateJurisdiction} className="action-button add-task-button"><i className="fas fa-pencil-alt g-mr-5"></i> Update</span>
                        }
                    </div>
                </div>



            </div>

            : null}


            
        {showingDeletePopup ? 

            <div className="add-task-popup" style={{minWidth: "300px", width: "400px", marginTop: "100px", backgroundColor: "#ebebeb", }}>

                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "50%" }}>
                        <h3>Delete Jurisdiction</h3>
                    </div>
                    <div style={{ width: "50%", textAlign: "right" }}>
                        <button
                            className="close-button"
                            onClick={() => setShowingDeletePopup(false)}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>




                <div style={{display: "flex", flexDirection: "column"}}>
                    <div style={{width: "100%", marginBottom: "15px", textAlign: "center"}}>
                        <br/>Are you sure you want to delete this jurisdiction?<br/><br/><b>{jurisdiction.Name}</b>
                    </div>
                </div>



                <div style={{display: "flex", justifyContent: "end", marginTop: "15px"}}>
                    <div>
                        {deletingJurisdiction ?
                            <LoadingSpinnerImage /> : 
                            <span onClick={deleteJurisdiction} className="action-button add-task-button" style={{backgroundColor: "#be2c2c"}}><i className="far fa-trash-alt g-mr-5"></i> Delete</span>
                        }
                    </div>
                </div>

            </div>

        : null }


    </>

}





const TaskManagerPopup = (props) => {
    const [TaskManagerComponent, setTaskManagerComponent] = useState(null);

    useEffect(() => {
        let active = true;
        import("../../TaskManager/TaskManager.js").then((mod) => {
            if (active)
                setTaskManagerComponent(() => mod.default);
        });
        return () => { active = false; };
    }, []);

    if (!TaskManagerComponent)
        return <LoadingSpinnerImage />;

    return <TaskManagerComponent {...props} />;
};

export default DataTable;